import { Location } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  NgForm,
  Validators,
  FormArray,
  FormGroup,
} from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { cloneDeep, get } from 'lodash';
import {
  ConfirmationService,
  LazyLoadEvent,
  MenuItem,
  MessageService,
  OverlayPanel,
  SelectItem,
  Table,
} from 'primeng';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { IAnswerTemplate, ITaskStepAnswer } from 'src/app/interfaces/answer';
import {
  IChecklistTaskTypeStep,
  IGenericTaskStepDetail,
  IMovementTaskStep,
} from 'src/app/interfaces/checklist-task-type';
import { Message } from '../../classes/Message';
import { ICustomTaskAction } from '../../interfaces/custom-task-action';
import {
  ICustomerSites,
  ICustomerSitesContact,
  ICustomerSitesDistanceAndDetails,
  SiteOpeningHoursForm,
} from '../../interfaces/customer-sites';
import { ICustomerSitesFilter } from '../../interfaces/customer-sites-filter';
import { IMotTaxStatus } from '../../interfaces/mot-tax-status';
import { IStep1Vehicle } from '../../interfaces/order-steps-data/step1-vehicle';
import { IStep3Location } from '../../interfaces/order-steps-data/step3-route-and-timings';
import { IOrganisationSpecificSteps } from '../../interfaces/organisation-specific-steps';
import { IPageResult } from '../../interfaces/page-result';
import { ISystemSettings } from '../../interfaces/system-settings';
import {
  IOrderInfo,
  ITaskInfo,
  ITaskStep,
  ITaskWithJobInfo,
  IVehicle,
  IVehicleAddress,
  IVehicleLastDropOffAddress,
} from '../../interfaces/task-info';
import { IUserOrganisationLevel } from '../../interfaces/user-organisation-level';
import {
  AccountCodeService,
  DatadogRumService,
  EnvironmentService,
  UserService,
} from '../../services';
import { AgreementService } from '../../services';
import { CustomerSitesService } from '../../services';
import { LoggerService } from '../../services';
import { MapService } from '../../services';
import { OrderService } from '../../services';
import { OrganisationSpecificStepsService } from '../../services';
import { OrganisationTaskTypesService } from '../../services';
import { OrganisationsService } from '../../services';
import { PcaService } from '../../services';
import { SettingsService } from '../../services';
import { TaggedLogger } from '../../services';
import { TaskTypeService } from '../../services';
import { TaskService } from '../../services';
import { TermsConditionsService } from '../../services';
import { VehicleService } from '../../services';
import { flatten } from '../../utils/flatten';
import { CheckMotTax } from '../../utils/mot-tax-status.helper';
import { JobDetailsComponent } from './job-details.component';
import { TaskType } from '../../enums/task.type';
import { MarkerPoint } from '../map-control/marker.point';
import { VehicleAddressService } from '../../services';
import moment from 'moment';
import { DailyMovementLimitService } from '../../services/daily-movement-limit.service';
import { SiteOpeningHoursService } from '../../services/site-opening-hours.service';
import { InputHelper } from '../../utils/input.helper';
import { VehicleLifecycleService } from '../../services/vehicle-lifecycle.service';
import { IVehicleLifeCycleNewOrderDetails } from '../../interfaces/vehicle-life-cycle/vehicle-life-cycle-new-order-details';
import { AddressAutoCompletionService } from '../../services/address-auto-completion.service';
import { CustomerSiteEditorSource } from '../customer-sites/customer-sites-editor.component';
import { vehicleKerbWeight } from './vehicle-kerb-weight-input/vehicle-kerb-weight-input.component';
import { isValidUKPostcodeFormat } from '../../utils/postcode-format-validation';
import {
  AnalyticsCreateOrderComponent,
  CreateOrderAnalyticsService,
  AnalyticsOrderEvent,
} from '../../services/product-analytics/create-order-analytics.service';
import { IsDisabledForDrivenMovementsVehicleBodyType } from '../../utils/is-disabled-for-driven-movements-vehicle-body-type';

export enum JobType {
  Driven = 1,
  Transported = 2,
  Recovered = 3,
  Inspection = 14,
  InspectAndCollect = 5,
}

export enum FormType {
  Create = 1,
  Copy = 2,
}

export enum TaskRequirement {
  IsCarDriveable = 1,
  WouldYouLikeCarDriven = 2,
  WouldYouLikeCarTransported = 3,
  WouldYouLikeCarCovered = 4,
  IsCarMOTed = 5,
  IsCarRoadTaxed = 6,
  IsCarInsured = 7,
  IsCarRollable = 8,
  IsCarPrestige = 9,
  IsCarVeryLowToGround = 10,
  HowManySkatesRequired = 11,
  IsVehicleLaden = 12,
  IsGroundClearanceModifications = 13,
}

//isShowJobPrevieselectedChecklistTaskTypew
export enum CreateMovementJobSteps {
  CreateTask = 0,
  JobPreview = 1,
  SelectSupplier = 2,
}

@Component({
  selector: 'create-movement-job',
  templateUrl: './create-movement-job.component.html',
  styleUrls: ['./create-movement-job.component.scss'],
  encapsulation: ViewEncapsulation.None, // todo: check why view encapsulation is off here
  providers: [InputHelper],
})
export class CreateMovementJobComponent implements OnInit {
  private readonly logger: TaggedLogger;
  private extraOptionSelected: boolean = false;
  private agreementAgreed: boolean = false;
  private isProduction: boolean = false;

  isJobTaggingEnforced: boolean = false;

  pickupSiteHoursFormGroup: FormArray<FormGroup<SiteOpeningHoursForm>>;

  dropOffSiteHoursFormGroup: FormArray<FormGroup<SiteOpeningHoursForm>>;

  public specificStepGroups: SelectItem[];
  public selectedGroupId: number;
  // todo: this could be renamed to engineiusSteps to distinguish between "default" and "custom" better.
  public selectedTaskTypeSteps: ITaskStep[] = [];

  isReturnJourney: boolean = false;
  isFollowOnJourney: boolean = false;

  //Recovered Data Objects
  //Driven Options
  private vehicleCachedData: IStep1Vehicle;
  private routeandtimings: IStep3Location;
  public currValidStep: number;
  public displayCalculatePrice: boolean = false;
  public calculatedPrice: any = null;
  private originalTask: ITaskInfo;
  private originalOrders: IOrderInfo[];
  public systemSettings: ISystemSettings;
  public minutesInterval: number = 30; //Default 30 min

  public isFirstAction: boolean = false;
  public isCopy: boolean = false;
  public isDebug: boolean = false;
  public isRoyalMail: boolean = false;

  public page: IPageResult<ICustomerSites> = {
    items: [],
    total: 0,
  };

  selectedSites: ICustomerSites;

  public filterVal: ICustomerSitesFilter;
  public filter: Subject<ICustomerSitesFilter>;

  public IsBusy: boolean = false;
  @Output() createMovementJobStepChange: EventEmitter<CreateMovementJobSteps>;
  public _createMovementJobStep: CreateMovementJobSteps = CreateMovementJobSteps.CreateTask;
  private defaultChecklistSteps: IOrganisationSpecificSteps[];
  showDuplicateTaskDialog = false;
  duplicateTasks: ITaskWithJobInfo[] = [];
  checkingDuplicates = false;
  private _isInspection: boolean;
  private customerDepartmentId: any;
  private customerTeamId: any;

  submitOrderClicker = new Subject();
  submitOrderClicker$ = this.submitOrderClicker.asObservable();

  @Input('createMovementJobStep')
  public set createMovementJobStep(value: CreateMovementJobSteps) {
    this._createMovementJobStep = value;
    this.isCreateCustomJob = false;
    this.createMovementJobStepChange.emit(value);
  }

  public newPickupCustomActionChange: EventEmitter<string>;
  public newDropoffCustomActionChange: EventEmitter<string>;

  public get createMovementJobStep(): CreateMovementJobSteps {
    return this._createMovementJobStep;
  }

  public dataRecoveryDisplay: boolean = false;
  public simpledataRecoveryDisplay: boolean = false;
  public cachedStep: any = null;

  locationsform: UntypedFormGroup;
  public control: any;

  @Output() newJobsChange: EventEmitter<Array<IOrderInfo>>;
  public newJobs: Array<IOrderInfo> = [];

  public isCreateCustomJob: boolean = false;
  public draggedTask: ITaskInfo;
  public draggedFromJob: IOrderInfo;
  public selectVehicle: IVehicle = null;

  public formType: FormType;

  public _typeJob: number;
  @Output() typeJobChange: EventEmitter<number>;

  @Input('typeJob')
  public set typeJob(value: number) {
    this._typeJob = value;
    this.typeJobChange.emit(value);
  }

  public get typeJob(): number {
    return this._typeJob;
  }

  public get showCarryoverWarning() {
    if (this.pickupEarliestDateTime == null || this.dropoffEarliestDateTime == null) {
      return false;
    }

    if (this.pickupEarliestDateTime.getDate() == this.dropoffEarliestDateTime.getDate()) {
      return false;
    }
    return true;
  }

  public _isPlated: boolean = false;
  @Output() isPlatedChange: EventEmitter<boolean>;

  @Input('isPlated')
  public set isPlated(value: boolean) {
    if (this._isPlated == value) {
      return;
    }
    this._isPlated = value;
    if (value == true) {
      this.isDriverInsured = false;
      this.isCustomerInsured = false;
      this.isPrestige = false;
      this.isCovered = false;
      this.isEngineiusGo = false;
      this.isTurnaround = false;
      this.isUncovered = false;
      this.isRecoveryStandard = false;
      this.isInspection = false;
      this.isFullLiftOnly = false;
      this.isMoreEquipmentNeeded = false;
      this.isInspection = false;
      this.isDrivenInsuredInspection = false;
      this.isDrivenPlatedInspection = false;
      this.isPrestigeTransported = false;
      this.calculateTaskType();
    }
    this.isPlatedChange.emit(value);
  }

  public get isPlated(): boolean {
    return this._isPlated;
  }

  public _isCustomerInsured: boolean = false;
  @Output() isCustomerInsuredChange: EventEmitter<boolean>;

  @Input('isCustomerInsured')
  public set isCustomerInsured(value: boolean) {
    if (this._isCustomerInsured == value) {
      return;
    }
    this._isCustomerInsured = value;
    if (value == true) {
      this.isPlated = false;
      this.isDriverInsured = false;
      this.isPrestige = false;
      this.isCovered = false;
      this.isEngineiusGo = false;
      this.isTurnaround = false;
      this.isUncovered = false;
      this.isRecoveryStandard = false;
      this.isMoreEquipmentNeeded = false;
      this.isInspection = false;
      this.isDrivenInsuredInspection = false;
      this.isDrivenPlatedInspection = false;
      this.isPrestigeTransported = false;
      this.calculateTaskType();
    }
    this.isCustomerInsuredChange.emit(value);
  }

  public get isCustomerInsured(): boolean {
    return this._isCustomerInsured;
  }

  public _isDriverInsured: boolean = false;
  @Output() isDriverInsuredChange: EventEmitter<boolean>;

  @Input('isDriverInsured')
  public set isDriverInsured(value: boolean) {
    if (this._isDriverInsured == value) {
      return;
    }
    this._isDriverInsured = value;
    if (value == true) {
      this.isPlated = false;
      this.isCustomerInsured = false;
      this.isPrestige = false;
      this.isCovered = false;
      this.isEngineiusGo = false;
      this.isTurnaround = false;
      this.isUncovered = false;
      this.isRecoveryStandard = false;
      this.isMoreEquipmentNeeded = false;
      this.isInspection = false;
      this.isDrivenInsuredInspection = false;
      this.isDrivenPlatedInspection = false;
      this.isPrestigeTransported = false;
      this.calculateTaskType();
    }
    this.isDriverInsuredChange.emit(value);
  }

  public get isDriverInsured(): boolean {
    return this._isDriverInsured;
  }

  SelectePrestige() {
    this.isPrestige = true;
  }

  public _isPrestige: boolean = false;
  @Output() isPrestigeChange: EventEmitter<boolean>;

  @Input('isPrestige')
  public set isPrestige(value: boolean) {
    if (this._isPrestige == value) {
      return;
    }
    this._isPrestige = value;
    if (value == true) {
      this.isPlated = false;
      this.isDriverInsured = false;
      this.isCustomerInsured = false;
      this.isCovered = false;
      this.isEngineiusGo = false;
      this.isUncovered = false;
      this.isTurnaround = false;
      this.isRecoveryStandard = false;
      this.isMoreEquipmentNeeded = false;
      this.isInspection = false;
      this.isDrivenInsuredInspection = false;
      this.isDrivenPlatedInspection = false;
      this.isPrestigeTransported = false;
      this.calculateTaskType();
    }
    this.isPrestigeChange.emit(value);
  }

  public get isPrestige(): boolean {
    return this._isPrestige;
  }

  private _isEngineiusGo: boolean = false;
  @Output() isEngineiusGoChange: EventEmitter<boolean>;

  @Input('isEngineiusGo') set isEngineiusGo(value: boolean) {
    if (this._isEngineiusGo == value) {
      return;
    }
    this._isEngineiusGo = value;
    if (value) {
      this.isPlated = false;
      this.isDriverInsured = false;
      this.isCustomerInsured = false;
      this.isCovered = false;
      this.isPrestige = false;
      this.isUncovered = false;
      this.isTurnaround = false;
      this.isRecoveryStandard = false;
      this.isMoreEquipmentNeeded = false;
      this.isInspection = false;
      this.isDrivenInsuredInspection = false;
      this.isDrivenPlatedInspection = false;
      this.isPrestigeTransported = false;
      this.calculateTaskType();
    }
    this.isEngineiusGoChange.emit(value);
  }

  get isEngineiusGo(): boolean {
    return this._isEngineiusGo;
  }

  private _isTurnaround: boolean = false;
  @Output() isTurnaroundChange: EventEmitter<boolean>;

  @Input('isTurnaround') set isTurnaround(value: boolean) {
    if (this._isTurnaround == value) {
      return;
    }
    this._isTurnaround = value;
    if (value) {
      this.isPlated = false;
      this.isDriverInsured = false;
      this.isCustomerInsured = false;
      this.isCovered = false;
      this.isPrestige = false;
      this.isUncovered = false;
      this.isRecoveryStandard = false;
      this.isMoreEquipmentNeeded = false;
      this.isInspection = false;
      this.isDrivenInsuredInspection = false;
      this.isDrivenPlatedInspection = false;
      this.isPrestigeTransported = false;
      this.calculateTaskType();
    }
    this.isTurnaroundChange.emit(value);
  }

  get isTurnaround(): boolean {
    return this._isTurnaround;
  }

  public _isUncovered: boolean = false;
  @Output() isUncoveredChange: EventEmitter<boolean>;

  @Input('isUncovered')
  public set isUncovered(value: boolean) {
    if (this._isUncovered == value) {
      return;
    }
    this._isUncovered = value;
    if (value == true) {
      this.isCovered = false;
      this.isPlated = false;
      this.isDriverInsured = false;
      this.isCustomerInsured = false;
      this.isPrestige = false;
      this.isEngineiusGo = false;
      this.isTurnaround = false;
      this.isRecoveryStandard = false;
      this.isMoreEquipmentNeeded = false;
      this.isInspection = false;
      this.isDrivenInsuredInspection = false;
      this.isDrivenPlatedInspection = false;
      this.isPrestigeTransported = false;
      this.calculateTaskType();
    }
    this.isUncoveredChange.emit(value);
  }

  public get isUncovered(): boolean {
    return this._isUncovered;
  }

  public _isCovered: boolean = false;
  @Output() isCoveredChange: EventEmitter<boolean>;

  @Input('isCovered')
  public set isCovered(value: boolean) {
    if (this._isCovered == value) {
      return;
    }
    this._isCovered = value;
    if (value == true) {
      this.isUncovered = false;
      this.isPlated = false;
      this.isDriverInsured = false;
      this.isCustomerInsured = false;
      this.isPrestige = false;
      this.isEngineiusGo = false;
      this.isTurnaround = false;
      this.isRecoveryStandard = false;
      this.isMoreEquipmentNeeded = false;
      this.isDrivenInsuredInspection = false;
      this.isDrivenPlatedInspection = false;
      this.isPrestigeTransported = false;
      this.calculateTaskType();
    }
    this.isCoveredChange.emit(value);
  }

  public get isPrestigeTransported(): boolean {
    return this._isPrestigeTransported;
  }

  public _isPrestigeTransported: boolean = false;
  @Output() isPrestigeTransportedChange: EventEmitter<boolean>;

  @Input('isPrestigeTransported')
  public set isPrestigeTransported(value: boolean) {
    if (this._isPrestigeTransported == value) {
      return;
    }
    this._isPrestigeTransported = value;
    if (value == true) {
      this.isUncovered = false;
      this.isCovered = false;
      this.isPlated = false;
      this.isDriverInsured = false;
      this.isCustomerInsured = false;
      this.isPrestige = false;
      this.isEngineiusGo = false;
      this.isTurnaround = false;
      this.isRecoveryStandard = false;
      this.isMoreEquipmentNeeded = false;
      this.isDrivenInsuredInspection = false;
      this.isDrivenPlatedInspection = false;
      this.calculateTaskType();
    }
    this.isPrestigeTransportedChange.emit(value);
  }

  public get isCovered(): boolean {
    return this._isCovered;
  }

  public _isSkatesOnly: boolean = false;
  @Output() isSkatesOnlyChange: EventEmitter<boolean>;

  @Input('isSkatesOnly')
  public set isSkatesOnly(value: boolean) {
    if (this._isSkatesOnly == value) {
      return;
    }
    this._isSkatesOnly = value;
    if (value == true) {
      this.isFullLiftOnly = !value;
      this.isMoreEquipmentNeeded = !value;
      this.calculateTaskType();
    }
    this.isSkatesOnlyChange.emit(value);
  }

  public get isSkatesOnly(): boolean {
    return this._isSkatesOnly;
  }

  //New Recovery Option
  SelectedRecoveryStandard() {
    this.isRecoveryStandard = true;
  }

  public _isRecoveryStandard: boolean = false;
  @Output() isRecoveryStandardChange: EventEmitter<boolean>;

  @Input('isRecoveryStandard')
  public set isRecoveryStandard(value: boolean) {
    if (this._isRecoveryStandard == value) {
      return;
    }
    this._isRecoveryStandard = value;
    if (value == true) {
      this.isCovered = false;
      this.isUncovered = false;
      this.isPlated = false;
      this.isDriverInsured = false;
      this.isCustomerInsured = false;
      this.isPrestige = false;
      this.isMoreEquipmentNeeded = false;
      this.isEngineiusGo = false;
      this.isTurnaround = false;
      this.isInspection = false;
      this.isDrivenInsuredInspection = false;
      this.isDrivenPlatedInspection = false;
      this.isPrestigeTransported = false;
      this.calculateTaskType();
    }
    this.isRecoveryStandardChange.emit(value);
  }

  @Output() isInspectionChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input('isInspection')
  public set isInspection(value: boolean) {
    if (this._isInspection == value) {
      return;
    }
    this._isInspection = value;
    if (value == true) {
      this.isCovered = false;
      this.isUncovered = false;
      this.isPlated = false;
      this.isDriverInsured = false;
      this.isCustomerInsured = false;
      this.isPrestige = false;
      this.isMoreEquipmentNeeded = false;
      this.isEngineiusGo = false;
      this.isTurnaround = false;
      this.isRecoveryStandard = false;
      this.isDrivenInsuredInspection = false;
      this.isDrivenPlatedInspection = false;
      this.isPrestigeTransported = false;
      this.calculateTaskType();
    }
    this.isInspectionChange.emit(value);
  }

  public get isInspection(): boolean {
    return this._isInspection;
  }

  public get isRecoveryStandard(): boolean {
    return this._isRecoveryStandard;
  }

  public _isFullLiftOnly: boolean = false;
  @Output() isFullLiftOnlyChange: EventEmitter<boolean>;

  @Input('isFullLiftOnly')
  public set isFullLiftOnly(value: boolean) {
    if (this._isFullLiftOnly == value) {
      return;
    }
    this._isFullLiftOnly = value;
    if (value == true) {
      this.isSkatesOnly = !value;
      this.isMoreEquipmentNeeded = !value;
      this.calculateTaskType();
    }
    this.isFullLiftOnlyChange.emit(value);
  }

  public get isFullLiftOnly(): boolean {
    return this._isFullLiftOnly;
  }

  SelecteMoreEquipmentNeeded() {
    this.isMoreEquipmentNeeded = true;
  }

  public _isMoreEquipmentNeeded: boolean = false;
  @Output() isMoreEquipmentNeededChange: EventEmitter<boolean>;

  @Input('isMoreEquipmentNeeded')
  public set isMoreEquipmentNeeded(value: boolean) {
    if (this._isMoreEquipmentNeeded == value) {
      return;
    }
    this._isMoreEquipmentNeeded = value;
    if (value == true) {
      this.isCovered = false;
      this.isUncovered = false;
      this.isPlated = false;
      this.isDriverInsured = false;
      this.isRecoveryStandard = false;
      this.isCustomerInsured = false;
      this.isPrestige = false;
      this.isEngineiusGo = false;
      this.isTurnaround = false;
      this.isSkatesOnly = !value;
      this.isInspection = false;
      this.isDrivenInsuredInspection = false;
      this.isDrivenPlatedInspection = false;
      this.isPrestigeTransported = false;
      this.calculateTaskType();
    }
    this.isMoreEquipmentNeededChange.emit(value);
  }

  public get isMoreEquipmentNeeded(): boolean {
    return this._isMoreEquipmentNeeded;
  }

  public _isDrivenInsuredInspection: boolean = false;
  @Output() isDrivenInsuredInspectionChange: EventEmitter<boolean>;

  @Input('isDrivenInsuredInspection')
  public set isDrivenInsuredInspection(value: boolean) {
    if (this._isDrivenInsuredInspection == value) {
      return;
    }
    this._isDrivenInsuredInspection = value;
    if (value == true) {
      this.isDriverInsured = false;
      this.isPlated = false;
      this.isCustomerInsured = false;
      this.isPrestige = false;
      this.isCovered = false;
      this.isEngineiusGo = false;
      this.isTurnaround = false;
      this.isUncovered = false;
      this.isRecoveryStandard = false;
      this.isMoreEquipmentNeeded = false;
      this.isInspection = false;
      this.isDrivenPlatedInspection = false;
      this.isPrestigeTransported = false;
      this.calculateTaskType();
    }
    this.isDrivenInsuredInspectionChange.emit(value);
  }

  public get isDrivenInsuredInspection(): boolean {
    return this._isDrivenInsuredInspection;
  }

  public _isDrivenPlatedInspection: boolean = false;
  @Output() isDrivenPlatedInspectionChange: EventEmitter<boolean>;

  @Input('isDrivenPlatedInspection')
  public set isDrivenPlatedInspection(value: boolean) {
    if (this._isDrivenPlatedInspection == value) {
      return;
    }
    this._isDrivenPlatedInspection = value;
    if (value == true) {
      this.isDriverInsured = false;
      this.isPlated = false;
      this.isCustomerInsured = false;
      this.isPrestige = false;
      this.isCovered = false;
      this.isEngineiusGo = false;
      this.isTurnaround = false;
      this.isUncovered = false;
      this.isRecoveryStandard = false;
      this.isMoreEquipmentNeeded = false;
      this.isInspection = false;
      this.isDrivenInsuredInspection = false;
      this.isPrestigeTransported = false;
      this.calculateTaskType();
    }
    this.isDrivenPlatedInspectionChange.emit(value);
  }

  public get isDrivenPlatedInspection(): boolean {
    return this._isDrivenPlatedInspection;
  }

  //---------------------------------
  public _taskType: number;
  @Output() taskTypeChange: EventEmitter<TaskType>;

  @Input('taskType')
  public set taskType(value: TaskType) {
    console.log('TTV ', value);
    this._taskType = value;
    this.task.taskTypeId = value;
    this.taskTypeChange.emit(value);
  }

  public get taskType(): TaskType {
    return this._taskType;
  }

  calculateTaskType() {
    if (this.isPlated) {
      this.taskType = TaskType.DrivenPlated;
      return;
    }

    if (this.isCustomerInsured) {
      this.taskType = TaskType.DrivenUninsured;
      return;
    }

    if (this.isDriverInsured) {
      this.taskType = TaskType.DriverInsured;
      return;
    }

    if (this.isEngineiusGo) {
      this.taskType = TaskType.DrivenEngineiusGo;
      return;
    }

    if (this.isPrestige) {
      this.taskType = TaskType.DrivenPrestige;
      return;
    }

    if (this.isTurnaround) {
      this.taskType = TaskType.DrivenTurnaround;
      return;
    }

    if (this.isUncovered) {
      this.taskType = TaskType.UncoveredTransportedMovement;
      return;
    }

    if (this.isCovered) {
      this.taskType = TaskType.CoveredTransportedMovement;
      return;
    }

    if (this.isSkatesOnly) {
      this.taskType = TaskType.RecoveredSkates;
      return;
    }

    if (this.isFullLiftOnly) {
      this.taskType = TaskType.RecoveredFullLiftOnly;
      return;
    }

    if (this.isMoreEquipmentNeeded) {
      this.taskType = TaskType.RecoveredMoreEquipmentNeeded;
      return;
    }

    if (this.isRecoveryStandard) {
      this.taskType = TaskType.RecoveryStandard;
      return;
    }

    if (this.isInspection) {
      this.taskType = TaskType.Inspection;
      return;
    }

    if (this.isDrivenInsuredInspection) {
      this.taskType = TaskType.DrivenInsuredInspection;
      return;
    }

    if (this.isDrivenPlatedInspection) {
      this.taskType = TaskType.DrivenPlatedInspection;
      return;
    }

    if (this.isPrestigeTransported) {
      this.taskType = TaskType.PrestigeTransported;
      return;
    }
  }

  getJobType(taskType: number): JobType {
    switch (taskType) {
      case TaskType.DrivenPlated:
      case TaskType.DrivenUninsured:
      case TaskType.DriverInsured:
      case TaskType.DrivenPrestige:
      case TaskType.DrivenEngineiusGo:
      case TaskType.DrivenTurnaround:
        return JobType.Driven;
      case TaskType.UncoveredTransportedMovement:
      case TaskType.CoveredTransportedMovement:
        return JobType.Transported;
      case TaskType.RecoveredSkates:
      case TaskType.RecoveredFullLiftOnly:
      case TaskType.RecoveredMoreEquipmentNeeded:
      case TaskType.RecoveryStandard:
        return JobType.Recovered;
      case TaskType.Inspection:
        return JobType.Inspection;
      case TaskType.DrivenInsuredInspection:
      case TaskType.DrivenPlatedInspection:
        return JobType.InspectAndCollect;
      default:
        return JobType.Driven;
    }
  }

  public createTaskSteps: Array<any>;
  public activeStepIndex: number;
  public YesNo: Array<any>;
  public carTypes: Array<any>;

  /* Specific Steps*/
  public specificSteps: Array<IOrganisationSpecificSteps>;
  public pickupSpecificSteps: Array<IOrganisationSpecificSteps>;
  public dropoffSpecificSteps: Array<IOrganisationSpecificSteps>;

  @Output() selectedPickupSpecificStepsChange: EventEmitter<Array<string>>;
  private _selectedPickupSpecificSteps: Array<string>;

  /**
   * todo: initially the steps are not selected
   * todo: why is this an input?
   * @param value
   */
  @Input('selectedPickupSpecificSteps')
  public set selectedPickupSpecificSteps(value: Array<string>) {
    this._selectedPickupSpecificSteps = value;
    this.changeSelectedSteps(value, true);
    this.selectedPickupSpecificStepsChange.emit(value);
  }

  public get selectedPickupSpecificSteps(): Array<string> {
    return this._selectedPickupSpecificSteps;
  }

  @Output() selectedDropoffSpecificStepsChange: EventEmitter<Array<string>>;
  private _selectedDropoffSpecificSteps: Array<string>;
  @Input('selectedDropoffSpecificSteps')
  public set selectedDropoffSpecificSteps(value: Array<string>) {
    this._selectedDropoffSpecificSteps = value;
    this.changeSelectedSteps(value, false);
    this.selectedDropoffSpecificStepsChange.emit(value);
  }

  public get selectedDropoffSpecificSteps(): Array<string> {
    return this._selectedDropoffSpecificSteps;
  }

  changeSelectedSteps(values: Array<string>, isPickup: boolean) {
    let existId = [];

    // Looks like "Remove the step"? Honestly not certain atm what the intention is here, too much going on at once.
    for (let i = this.task.taskOrganisationSpecificSteps.length - 1; i >= 0; i--) {
      if (
        this.task.taskOrganisationSpecificSteps[i].isPickUp == isPickup &&
        values.indexOf(
          this.task.taskOrganisationSpecificSteps[i].organisationSpecificStepId.toString(),
        ) < 0
      ) {
        this.task.taskOrganisationSpecificSteps.splice(i, 1);
      } else {
        existId.push(this.task.taskOrganisationSpecificSteps[i].organisationSpecificStepId);
      }
    }

    // Looks like "Add the step"
    // todo: this could probably be a more efficient filter then map.
    for (let i = 0; i < values.length; i++) {
      try {
        const stepId = parseInt(values[i], 10);

        // todo: what is the purpose of this bit?
        if (existId.indexOf(stepId) < 0) {
          const stepTypeTaskDetails = this.selectedChecklistTaskType.stepsTaskTypeDetails.find(
            (step) => step.id === stepId,
          );
          if (stepTypeTaskDetails) {
            //console.log("*** Adding stepId: ", stepId, " - task details: ", stepTypeTaskDetails)

            const orgStep = stepTypeTaskDetails.organisationSpecificStep;

            const existed = this.task.taskOrganisationSpecificSteps.find(
              (x) => x.organisationSpecificStepId === orgStep.id,
            );
            if (!existed) {
              this.task.taskOrganisationSpecificSteps.push({
                id: 0,
                isPickUp: orgStep.isPickUp,
                name: orgStep.name,
                order: stepTypeTaskDetails.order,
                organisationId: orgStep.organisationId,
                organisationSpecificStepId: orgStep.id,
                ancillaryStepId: orgStep.ancillaryStepId,
                completedDateTime: null,
                pauses: [],
                parentEngineiusStepId: stepTypeTaskDetails.parentEngineiusStepId,
                organisationSpecificStepsTaskTypeId:
                  stepTypeTaskDetails.organisationSpecificStepsTaskTypeId,
                stepOrder: stepTypeTaskDetails.order,
                answers: orgStep.answerTemplates.map((val: IAnswerTemplate, index: number) => {
                  return <ITaskStepAnswer>{
                    stepId: val.stepId,
                    answer: val.answer,
                    displayOrder: val.displayOrder,
                    allowPhotos: val.allowPhotos,
                    minimumNumberOfPhotos: val.minimumNumberOfPhotos,
                    answerId: val.answer.id,
                  };
                }),
              });
            } else {
              this.logger.error(
                'duplicated checklist occured',
                values,
                this.task.taskOrganisationSpecificSteps,
              );
            }
          } else {
            // this.logger.debug(`Will Check defaults for ${stepId}:`, this.defaultChecklistSteps);
            const step = this.defaultChecklistSteps.find((s) => s.id === stepId);
            const existed = this.task.taskOrganisationSpecificSteps.find(
              (x) => x.organisationSpecificStepId === step.id,
            );
            if (!existed) {
              this.task.taskOrganisationSpecificSteps.push({
                id: 0, // todo: should it be?
                isPickUp: step.isPickUp,
                name: step.name,
                order: step.order,
                organisationId: step.organisationId,
                organisationSpecificStepId: step.id,
                ancillaryStepId: step.ancillaryStepId,
                completedDateTime: null,
                pauses: [],
              });
            } else {
              this.logger.error(
                'duplicated checklist occured',
                values,
                this.task.taskOrganisationSpecificSteps,
              );
            }
          }
        }
      } catch (error) {
        this.logger.error(`Error changing selected step ${values[i]}`, error);
      }
    }
  }

  /* Custom Action*/
  private customActionId: number;

  public pickupCustomActions: Array<ICustomTaskAction>;
  public dropoffCustomActions: Array<ICustomTaskAction>;

  @Output() selectedPickupCustomActionsChange: EventEmitter<Array<string>>;
  private _selectedPickupCustomActions: Array<string>;
  @Input('selectedPickupCustomActions')
  public set selectedPickupCustomActions(value: Array<string>) {
    this._selectedPickupCustomActions = value;
    this.ChangeCustomActions(value, true);
    this.selectedPickupCustomActionsChange.emit(value);
  }

  public get selectedPickupCustomActions(): Array<string> {
    return this._selectedPickupCustomActions;
  }

  @Output() selectedDropoffCustomActionsChange: EventEmitter<Array<string>>;
  private _selectedDropoffCustomActions: Array<string>;
  @Input('selectedDropoffCustomActions')
  public set selectedDropoffCustomActions(value: Array<string>) {
    this._selectedDropoffCustomActions = value;
    this.ChangeCustomActions(value, false);
    this.selectedDropoffCustomActionsChange.emit(value);
  }

  public get selectedDropoffCustomActions(): Array<string> {
    return this._selectedDropoffCustomActions;
  }

  ChangeCustomActions(values: Array<string>, isPickup: boolean) {
    let existId = [];
    for (let i = this.task.customTaskActions.length - 1; i >= 0; i--) {
      if (
        this.task.customTaskActions[i].isPickUp == isPickup &&
        values.indexOf(this.task.customTaskActions[i].id.toString()) < 0
      ) {
        this.task.customTaskActions.splice(i, 1);
      } else {
        existId.push(this.task.customTaskActions[i].id);
      }
    }

    for (let i = 0; i < values.length; i++) {
      if (existId.indexOf(Number(values[i])) < 0) {
        let customAction = this.pickupCustomActions.find((val, index) => {
          return val.id == Number(values[i]);
        });
        if (customAction) {
          this.task.customTaskActions.push({
            completed: false,
            id: customAction.id,
            name: customAction.name,
            order: customAction.id,
            taskid: 0,
            isPickUp: true,
            completedDate: null,
            allowPhotos: customAction.allowPhotos,
            allowComments: customAction.allowComments,
            parentEngineiusStepId: customAction.parentEngineiusStepId,
          });
        } else {
          customAction = this.dropoffCustomActions.find((val, index) => {
            return val.id == Number(values[i]);
          });
          if (customAction) {
            this.task.customTaskActions.push({
              completed: false,
              id: customAction.id,
              name: customAction.name,
              order: customAction.id,
              taskid: 0,
              isPickUp: false,
              completedDate: null,
              allowPhotos: customAction.allowPhotos,
              allowComments: customAction.allowComments,
              parentEngineiusStepId: customAction.parentEngineiusStepId,
            });
          }
        }
      }
    }
  }

  //additionalInformation
  @Output() additionalInformationChange: EventEmitter<string>;
  private _additionalInformation: string;
  @Input('additionalInformation')
  public set additionalInformation(value: string) {
    this._additionalInformation = value;
    this.task.additionalInformation = value;
    this.additionalInformationChange.emit(value);
  }

  public get additionalInformation(): string {
    return this._additionalInformation;
  }

  public get originMarkerPoint(): MarkerPoint {
    return !this.pickupLocation
      ? null
      : new MarkerPoint(this.pickupLocation.latitude, this.pickupLocation.longitude);
  }

  public set originMarkerPoint(value: MarkerPoint) {
    if (
      value &&
      value.longitude != get(this.pickupLocation, 'longitude') &&
      value.latitude != get(this.pickupLocation, 'latitude')
    ) {
      this.isSearchPickup = true;
      this.vehicleAddressService.GetFromCoord(value.latitude, value.longitude).then((address) => {
        this.pickupLocation = address;
        this.isSearchPickup = false;
        this.getSuggestedCustomerDropOffLocations();
      });
    }
  }

  public get destinationMarkerPoint(): MarkerPoint {
    return !this.dropoffLocation
      ? null
      : new MarkerPoint(this.dropoffLocation.latitude, this.dropoffLocation.longitude);
  }

  public set destinationMarkerPoint(value: MarkerPoint) {
    if (
      value &&
      value.longitude != get(this.dropoffLocation, 'longitude') &&
      value.latitude != get(this.dropoffLocation, 'latitude')
    ) {
      this.isSearchDropoff = true;
      this.vehicleAddressService.GetFromCoord(value.latitude, value.longitude).then((address) => {
        this.dropoffLocation = address;
        this.isSearchDropoff = false;
        this.task.vehicleLifeCycleSiteId = null;
      });
    }
  }

  public routeTime: number = null;
  public isSearchPickup: boolean = false;

  public get isPickupLocation(): boolean {
    return this.pickupLocation != null;
  }

  public set pickupLocation(value: IVehicleAddress) {
    if (this.objectComparer(value, this.task.pickupLocation)) {
      return;
    }

    this.addressSearchPickupLocation = { ...value };
    this.displayAddressSearchPickupLocationManualSave = false;

    this.task.pickupLocation = value;
    this.CalculateRouteTime();
  }

  public get pickupLocation(): IVehicleAddress {
    return this.task.pickupLocation;
  }

  public isSearchDropoff: boolean = false;

  public get isDropoffLocation(): boolean {
    return this.dropoffLocation != null;
  }

  public set dropoffLocation(value: IVehicleAddress) {
    if (this.objectComparer(value, this.task.dropoffLocation)) {
      return;
    }

    this.addressSearchDropoffLocation = { ...value };
    this.displayAddressSearchDropoffLocationManualSave = false;

    this.task.dropoffLocation = value;
    this.CalculateRouteTime();
  }

  public get dropoffLocation(): IVehicleAddress {
    return this.task.dropoffLocation;
  }

  public get isPickupEarliestTime(): boolean {
    return this.pickupEarliestDateTime != undefined;
  }

  @Output() pickupEarliestDateTimeChange: EventEmitter<Date>;
  private _pickupEarliestDateTime: Date;
  @Input('pickupEarliestDateTime')
  public set pickupEarliestDateTime(value: Date) {
    if (value) {
      value.setSeconds(0);
      value.setMilliseconds(0);
    }
    this._pickupEarliestDateTime = value;
    this.task.pickupEarliestDateTime = value;
    this.pickupEarliestDateTimeChange.emit(value);

    // force validation on the dropoff times
    this.reconcileEarliestDropoff(this.dropoffEarliestDateTime);
    this.reconcileLatestDropoff(this.dropoffLatestDateTime);
  }

  public get pickupEarliestDateTime(): Date {
    return this._pickupEarliestDateTime;
  }

  public get isPickupLatestTime(): boolean {
    return this.pickupLatestDateTime != undefined;
  }

  @Output() pickupLatestDateTimeChange: EventEmitter<Date>;
  private _pickupLatestDateTime: Date;
  @Input('pickupLatestDateTime')
  public set pickupLatestDateTime(value: Date) {
    if (value) {
      value.setSeconds(0);
      value.setMilliseconds(0);
    }

    this._pickupLatestDateTime = value;
    this.task.pickupLatestDateTime = value;
  }

  public get pickupLatestDateTime(): Date {
    return this._pickupLatestDateTime;
  }

  public get isDropoffEarliestTime(): boolean {
    return this.dropoffEarliestDateTime != undefined;
  }

  @Output() dropoffEarliestDateTimeChange: EventEmitter<Date>;
  private _dropoffEarliestDateTime: Date;
  @Input('dropoffEarliestDateTime')
  public set dropoffEarliestDateTime(value: Date) {
    this.reconcileEarliestDropoff(value);
  }

  private reconcileEarliestDropoff(value: Date) {
    if (!this.dropoffLocation) return;

    let setToDefault = false;
    // On fly validation
    if (this.pickupEarliestDateTime && value < this.pickupEarliestDateTime) {
      setToDefault = true;
      this.messageService.add(
        Message.Warning(
          'The earliest dropoff time cannot be before before the earliest pickup time. The earliest dropoff time has been rectified.',
        ),
      );
    }

    if (setToDefault) {
      value = this._getDefaultDropoffEarliestDateTime(this.pickupEarliestDateTime);
      value = this.roundUpTime(value);
    }

    this._dropoffEarliestDateTime = value;
    this.task.dropoffEarliestDateTime = value;
    this.dropoffEarliestDateTimeChange.emit(value);
  }

  public get dropoffEarliestDateTime(): Date {
    return this._dropoffEarliestDateTime;
  }

  public get isDropoffLatestTime(): boolean {
    return this.dropoffLatestDateTime != undefined;
  }

  @Output() dropoffLatestDateTimeChange: EventEmitter<Date>;
  private _dropoffLatestDateTime: Date;
  @Input('dropoffLatestDateTime')
  public set dropoffLatestDateTime(value: Date) {
    this.reconcileLatestDropoff(value);
  }

  private reconcileLatestDropoff(value: Date) {
    if (!this.dropoffLocation) return;

    let setToDefault = false;

    let earliestPickupPlusRouteTime = moment(this.pickupLatestDateTime)
      .add(this.routeTime, 's')
      .toDate();

    // if dropoff earlier than pickup time, set it to pickup time + route time
    if (
      (this.pickupLatestDateTime && value < this.pickupLatestDateTime) ||
      (this.pickupEarliestDateTime && value < this.pickupEarliestDateTime)
    ) {
      setToDefault = true;
      this.messageService.add(
        Message.Warning(
          'The latest dropoff time cannot be before before the pickup times. The latest dropoff time has been rectified.',
        ),
      );
    } else if (this.dropoffEarliestDateTime && value < this.dropoffEarliestDateTime) {
      setToDefault = true;
      this.messageService.add(
        Message.Warning(
          'The latest dropoff time cannot be before the earliest dropoff time. The latest dropoff time has been rectified.',
        ),
      );
    } else if (value < earliestPickupPlusRouteTime) {
      setToDefault = true;
      this.messageService.add(
        Message.Warning(
          'The latest dropoff time cannot be before the earliest pickup plus the movement duration. The latest dropoff time has been rectified.',
        ),
      );
    }

    if (setToDefault) {
      value = this._getValidDropoffLatestDateTime(this.pickupLatestDateTime);
      value = this.roundUpTime(value);
    }
    this._dropoffLatestDateTime = value;
    this.task.dropoffLatestDateTime = value;
    this.dropoffLatestDateTimeChange.emit(value);
  }

  public get dropoffLatestDateTime(): Date {
    return this._dropoffLatestDateTime;
  }

  // PICKUP NOTIFICATION

  private _pickupNotification: boolean;

  public get pickupNotification(): boolean {
    return this._pickupNotification;
  }

  public set pickupNotification(value: boolean) {
    this.task.pickupNotification = value;
    this._pickupNotification = value;
  }

  //  PICKUP FORENAME

  private _pickupForename: string;

  public get pickupForename(): string {
    return this._pickupForename;
  }

  public set pickupForename(value: string) {
    this.task.pickupForename = value;
    this._pickupForename = value;
  }

  // PICKUP CONTACT

  public get isPickupContact(): boolean {
    return (
      (this._pickupSurname && this._pickupSurname.trim().length > 0) ||
      (this._pickupForename && this._pickupForename.trim().length > 0)
    );
  }

  //  PICKUP SURNAME

  private _pickupSurname: string;

  public get pickupSurname(): string {
    return this._pickupSurname;
  }

  public set pickupSurname(value: string) {
    this.task.pickupSurname = value;
    this._pickupSurname = value;
  }

  //  PICKUP EMAIL

  private _pickupEmail: string = '';

  public get isPickupEmail(): boolean {
    let isPickupEmail: boolean = this._pickupEmail && this._pickupEmail.trim().length > 0;

    return isPickupEmail;
  }

  public get pickupEmail(): string {
    return this._pickupEmail;
  }

  public set pickupEmail(value: string) {
    this.task.pickupEmail = value;
    this._pickupEmail = value;
  }

  private _pickupSecondaryEmail: string = '';

  public get pickupSecondaryEmail(): string {
    return this._pickupSecondaryEmail;
  }

  public set pickupSecondaryEmail(value: string) {
    this.task.pickupSecondaryEmail = value;
    this._pickupSecondaryEmail = value;
  }

  //  PICKUP PHONE 1

  private _pickupPhone1: string;

  public get isPickupPhone1(): boolean {
    return this._pickupPhone1 && this._pickupPhone1.trim().length > 0;
  }

  public get pickupPhone1(): string {
    return this._pickupPhone1;
  }

  public set pickupPhone1(value: string) {
    this.task.pickupPhone1 = value;
    this._pickupPhone1 = value;
  }

  //  PICKUP PHONE 2

  private _pickupPhone2: string;

  public get isPickupPhone2(): boolean {
    return this.pickupPhone2 && this.pickupPhone2.trim().length > 0;
  }

  public get pickupPhone2(): string {
    return this._pickupPhone2;
  }

  public set pickupPhone2(value: string) {
    this.task.pickupPhone2 = value;
    this._pickupPhone2 = value;
  }

  private _inspectionContactFullName: string;

  public get inspectionContactFullName(): string {
    return this._inspectionContactFullName;
  }

  public set inspectionContactFullName(value: string) {
    this.task.inspectionContactFullName = value;
    this._inspectionContactFullName = value;
  }

  private _inspectionContactEmail: string;

  public get inspectionContactEmail(): string {
    return this._inspectionContactEmail;
  }

  public set inspectionContactEmail(value: string) {
    this.task.inspectionContactEmail = value;
    this._inspectionContactEmail = value;
  }

  //  DROPOFF FORENAME

  private _dropoffForename: string;

  public get dropoffForename(): string {
    return this._dropoffForename;
  }

  public set dropoffForename(value: string) {
    this.task.dropoffForename = value;
    this._dropoffForename = value;
  }

  //  DROPOFF SURNAME

  private _dropoffSurname: string;

  public get isDropoffContact(): boolean {
    return (
      (this._dropoffSurname && this._dropoffSurname.trim().length > 0) ||
      (this._dropoffForename && this._dropoffForename.trim().length > 0)
    );
  }

  public get dropoffSurname(): string {
    return this._dropoffSurname;
  }

  public set dropoffSurname(value: string) {
    this.task.dropoffSurname = value;
    this._dropoffSurname = value;
  }

  //  DROPOFF EMAIL

  public get isDropoffEmail(): boolean {
    return this._dropoffEmail && this._dropoffEmail.trim().length > 0;
  }

  private _dropoffEmail: string;

  public get dropoffEmail(): string {
    return this._dropoffEmail;
  }

  public set dropoffEmail(value: string) {
    this.task.dropoffEmail = value;
    this._dropoffEmail = value;
  }

  private _dropoffSecondaryEmail: string = '';

  public get dropoffSecondaryEmail(): string {
    return this._dropoffSecondaryEmail;
  }

  public set dropoffSecondaryEmail(value: string) {
    this.task.dropoffSecondaryEmail = value;
    this._dropoffSecondaryEmail = value;
  }

  //  DROPOFF PHONE 1

  private _dropoffPhone1: string;

  public get isDropoffPhone1(): boolean {
    return this._dropoffPhone1 && this._dropoffPhone1.trim().length > 0;
  }

  public get dropoffPhone1(): string {
    return this._dropoffPhone1;
  }

  public set dropoffPhone1(value: string) {
    this.task.dropoffPhone1 = value;
    this._dropoffPhone1 = value;
  }

  //  DROPOFF PHONE 2

  private _dropoffPhone2: string;

  public get isDropoffPhone2(): boolean {
    return this._dropoffPhone2 && this._dropoffPhone2.trim().length > 0;
  }

  public get dropoffPhone2(): string {
    return this._dropoffPhone2;
  }

  public set dropoffPhone2(value: string) {
    this.task.dropoffPhone2 = value;
    this._dropoffPhone2 = value;
  }

  // PICKUP NOTES

  public get isPickupNotes(): boolean {
    return this.pickupNotes && this.pickupNotes.trim().length > 0;
  }

  // PICKUP NOTIFICATION

  private _dropoffNotification: boolean;

  public get dropoffNotification(): boolean {
    return this._dropoffNotification;
  }

  public set dropoffNotification(value: boolean) {
    this.task.dropoffNotification = value;
    this._dropoffNotification = value;
  }

  // Is MoDel PIN Unknown

  private _isMoDelPinUnknown: boolean;

  public get isMoDelPinUnknown(): boolean {
    return this._isMoDelPinUnknown;
  }

  public set isMoDelPinUnknown(value: boolean) {
    this._isMoDelPinUnknown = value;
  }

  //  DROPOFF BUSINESS

  private _dropoffBusinessName: string;

  public get isDropoffBusinessName(): boolean {
    return this._dropoffBusinessName && this._dropoffBusinessName.trim().length > 0;
  }

  public get dropoffBusinessName(): string {
    return this._dropoffBusinessName;
  }

  public set dropoffBusinessName(value: string) {
    this.task.dropoffBusinessName = value;
    this._dropoffBusinessName = value;
  }

  //  PICKUP BUSINESS

  private _pickupBusinessName: string;

  public get isPickupBusinessName(): boolean {
    return this._pickupBusinessName && this._pickupBusinessName.trim().length > 0;
  }

  public get pickupBusinessName(): string {
    return this._pickupBusinessName;
  }

  public set pickupBusinessName(value: string) {
    this.task.pickupBusinessName = value;
    this._pickupBusinessName = value;
  }

  @Output() pickupNotesChange: EventEmitter<string>;
  private _pickupNotes: string;
  @Input('pickupNotes')
  public set pickupNotes(value: string) {
    this._pickupNotes = value;
    if (!this.task.notes) {
      this.task.notes = [];
    }
    let pickupNote = null;
    for (let i = 0; i < this.task.notes.length; i++) {
      let note = this.task.notes[i];
      if (note.isPickUp) {
        pickupNote = note;
        break;
      }
    }
    if (pickupNote == null) {
      if (value && value.length > 0) {
        this.task.notes.push({
          created: new Date(Date.now()),
          description: value,
          isPickUp: true,
          userId: '',
        });
      }
    } else {
      if (value && value.length > 0) {
        pickupNote.description = value;
      } else {
        let index = this.task.notes.indexOf(pickupNote);
        if (index >= 0) {
          this.task.notes.splice(index, 1);
        }
      }
    }
    this.pickupNotesChange.emit(value);
  }

  public get pickupNotes(): string {
    if (!this.task.notes) {
      return '';
    }

    let pickupNote = null;
    for (let i = 0; i < this.task.notes.length; i++) {
      let note = this.task.notes[i];
      if (note.isPickUp) {
        pickupNote = note;
        break;
      }
    }
    return pickupNote ? pickupNote.description : '';
  }

  @ViewChild('vcPickupNotes') vcPickupNotes: ElementRef;
  public isPickupNotesFocus: boolean = false;

  pickupNotesFocus() {
    this.isPickupNotesFocus = true;
    setTimeout(() => {
      if (this.vcPickupNotes) {
        this.vcPickupNotes.nativeElement.focus();
      }
    }, 5);
  }

  pickupNotesUnfocus() {
    this.isPickupNotesFocus = false;
  }

  public get isDropoffNotes(): boolean {
    return this.dropoffNotes && this.dropoffNotes.trim().length > 0;
  }

  @Output() dropoffNotesChange: EventEmitter<string>;
  private _dropoffNotes: string;
  @Input('dropoffNotes')
  public set dropoffNotes(value: string) {
    this._dropoffNotes = value;
    if (!this.task.notes) {
      this.task.notes = [];
    }
    let dropoffNote = null;
    for (let i = 0; i < this.task.notes.length; i++) {
      let note = this.task.notes[i];
      if (note.isPickUp == false) {
        dropoffNote = note;
        break;
      }
    }
    if (dropoffNote == null) {
      if (value && value.length > 0) {
        this.task.notes.push({
          created: new Date(Date.now()),
          description: value,
          isPickUp: false,
          userId: '',
        });
      }
    } else {
      if (value && value.length > 0) {
        dropoffNote.description = value;
      } else {
        let index = this.task.notes.indexOf(dropoffNote);
        if (index >= 0) {
          this.task.notes.splice(index, 1);
        }
      }
    }

    this.dropoffNotesChange.emit(value);
  }

  public get dropoffNotes(): string {
    if (!this.task.notes) {
      return '';
    }
    let dropoffNote = null;
    for (let i = 0; i < this.task.notes.length; i++) {
      let note = this.task.notes[i];
      if (note.isPickUp == false) {
        dropoffNote = note;
        break;
      }
    }

    return dropoffNote ? dropoffNote.description : '';
  }

  @ViewChild('vcDropoffNotes') vcDropoffNotes: ElementRef;
  public isDropoffNotesFocus: boolean = false;

  dropoffNotesFocus() {
    this.isDropoffNotesFocus = true;
    setTimeout(() => {
      if (this.vcDropoffNotes) {
        this.vcDropoffNotes.nativeElement.focus();
      }
    }, 5);
  }

  dropoffNotesUnfocus() {
    this.isDropoffNotesFocus = false;
  }

  // Vehicle
  public vehicleMsgs: Array<string> = [];
  public registrationNumber: string;
  public vin: string;
  @Output() vehicleChange: EventEmitter<IVehicle>;
  private _vehicle: IVehicle;
  @Input('vehicle')
  public set vehicle(value: IVehicle) {
    this._vehicle = value;
    this.task.vehicle = value;
    this.vehicleChange.emit(value);
  }

  public get vehicle(): IVehicle {
    return this._vehicle;
  }

  public isShowWeightEditor: boolean = false;
  public isSearchVehicle: boolean = false;
  public isShowVehicleDetail: boolean = false;
  public isShowSaerchByVin: boolean = false;
  public isShowSaerchManual: boolean = false;
  @ViewChild('vehicleDetailForm') vehicleDetailForm: NgForm;

  // Task
  @Output() taskChange: EventEmitter<ITaskInfo>;
  private _task: ITaskInfo;
  @Input('task')
  public set task(value: ITaskInfo) {
    // console
    this._task = value;
    this.taskChange.emit(value);
  }

  public get task(): ITaskInfo {
    return this._task;
  }

  taskTypeIsAllowed(type: TaskType): boolean {
    return this.allowedTaskTypes && this.allowedTaskTypes[type];
  }

  jobTypeIsAllowed(type: JobType): boolean {
    if (type == JobType.Driven) {
      return (
        this.allowedTaskTypes &&
        (this.allowedTaskTypes[TaskType.DrivenPlated] ||
          this.allowedTaskTypes[TaskType.DriverInsured] ||
          this.allowedTaskTypes[TaskType.DrivenUninsured] ||
          this.allowedTaskTypes[TaskType.DrivenPrestige] ||
          this.allowedTaskTypes[TaskType.DrivenEngineiusGo] ||
          this.allowedTaskTypes[TaskType.DrivenTurnaround])
      );
    } else if (type == JobType.Transported) {
      return (
        this.allowedTaskTypes &&
        (this.allowedTaskTypes[TaskType.CoveredTransportedMovement] ||
          this.allowedTaskTypes[TaskType.UncoveredTransportedMovement] ||
          this.allowedTaskTypes[TaskType.PrestigeTransported])
      );
    } else if (type == JobType.Inspection) {
      return this.allowedTaskTypes && this.allowedTaskTypes[TaskType.Inspection];
    } else if (type == JobType.InspectAndCollect) {
      return (
        this.allowedTaskTypes &&
        (this.allowedTaskTypes[TaskType.DrivenInsuredInspection] ||
          this.allowedTaskTypes[TaskType.DrivenPlatedInspection])
      );
    } else {
      // Recovered
      return (
        this.allowedTaskTypes &&
        (this.allowedTaskTypes[TaskType.RecoveredFullLiftOnly] ||
          this.allowedTaskTypes[TaskType.RecoveredMoreEquipmentNeeded] ||
          this.allowedTaskTypes[TaskType.RecoveredSkates] ||
          this.allowedTaskTypes[TaskType.RecoveryStandard])
      );
    }
  }

  private allowedTaskTypes: { [key: number]: boolean };

  taskTypeEnum = TaskType;
  jobTypeEnum = JobType;

  private pcaKey: string;

  private editTask: ITaskInfo = null;

  public topMsgs: any[];

  public createOrderMessage: string;
  public showOrderCreationMessage: boolean;
  private checklistMappingList: IChecklistTaskTypeStep[];
  // todo: a rename might be useful, this contains checklistSteps.
  private selectedChecklistTaskType: IChecklistTaskTypeStep;
  public isShowAdditionalStepForm: boolean = false;
  public workflow: IMovementTaskStep;
  public defaultTaskStepsChecked: boolean = true;
  public addCustomStepForm: UntypedFormGroup = null;
  public isVmeUser: boolean = false;
  public isUserImpersonate = false;
  public bypassOrderLimitations = false;

  @Output() showAllPickupStepsEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  private _showAllPickupSteps: boolean;
  @Input('showAllPickupSteps')
  public set showAllPickupSteps(value: boolean) {
    this._showAllPickupSteps = value;
    if (value) {
      this.workflow.pickupSteps.map((val, index) => {
        val.showDetails = true;
      });
    } else {
      if (this.workflow && this.workflow.pickupSteps) {
        this.workflow.pickupSteps.map((val, index) => {
          val.showDetails = false;
        });
      }
    }
    this.showAllPickupStepsEvent.emit(value);
  }

  public get showAllPickupSteps() {
    return this._showAllPickupSteps;
  }

  @Output() showAllDropOffStepsEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  private _showAllDropOffSteps: boolean;
  @Input('showAllDropOffSteps')
  public set showAllDropOffSteps(value: boolean) {
    this._showAllDropOffSteps = value;
    if (value) {
      this.workflow.dropoffSteps.map((val, index) => {
        val.showDetails = true;
      });
    } else {
      if (this.workflow && this.workflow.dropoffSteps) {
        this.workflow.dropoffSteps.map((val, index) => {
          val.showDetails = false;
        });
      }
    }
    this.showAllDropOffStepsEvent.emit(value);
  }

  public get showAllDropOffSteps() {
    return this._showAllDropOffSteps;
  }

  public suggestedCustomerDropOffLocations: ICustomerSitesDistanceAndDetails[];
  public loadingSuggestedCustomerDropOffLocations: boolean = false;
  private autoSuggestPickUpLocationEnabled: boolean = false;
  public autoSuggestNearestDropOffLocationsEnabled: boolean = false;

  get suggestedDropOffLocationCapacityExceeded(): boolean {
    if (!this.suggestedCustomerDropOffLocations) {
      return false;
    }

    const selectedSite = this.suggestedCustomerDropOffLocations.find(
      (site) => site.selected === true,
    );

    if (!selectedSite) {
      return false;
    }

    if (selectedSite.siteDetails.vehicleLifeCycleMaxCapacity > 0) {
      return (
        selectedSite.siteDetails.vehicleLifeCycleRefurbsOnSiteCount >=
        selectedSite.siteDetails.vehicleLifeCycleMaxCapacity
      );
    } else {
      return false;
    }
  }

  public vehicleLifeCycleRefurbId: number = 0;
  public vehicleLifeCycleRefurbDetailsForNewOrder: IVehicleLifeCycleNewOrderDetails;

  public addressSearchPickupLocation: IVehicleAddress = null;
  public addressSearchDropoffLocation: IVehicleAddress = null;
  public displayAddressSearchPickupLocationManualSave: boolean = false;
  public displayAddressSearchDropoffLocationManualSave: boolean = false;
  public disableAddressSearchPickupFields: boolean = false;
  public disableAddressSearchDropoffFields: boolean = false;
  public addressSearchPickupSiteEditor: boolean = false;
  public addressSearchDropoffSiteEditor: boolean = false;
  public siteEditorContactInfo: ICustomerSitesContact;
  public pickupAddressMatchedSite: ICustomerSites;
  public dropoffAddressMatchedSite: ICustomerSites;
  public isPickupPostcodeValidUKPostcodeFormat = true;
  public isDropoffPostcodeValidUKPostcodeFormat = true;

  protected readonly CustomerSiteEditorSource = CustomerSiteEditorSource;

  isDrivenDisabled = false;

  constructor(
    private taskService: TaskService,
    private mapService: MapService,
    private fb: UntypedFormBuilder,
    private router: Router,
    private vehicleService: VehicleService,
    private orderService: OrderService,
    private settingsService: SettingsService,
    private organisationSpecificStepsService: OrganisationSpecificStepsService,
    public tcService: TermsConditionsService,
    private confirmationService: ConfirmationService,
    private activatedRoute: ActivatedRoute,
    public messageService: MessageService,
    private location: Location,
    private agreementService: AgreementService,
    private accountCodeService: AccountCodeService,
    private organisationsService: OrganisationsService,
    private organisationTaskTypesService: OrganisationTaskTypesService,
    public csService: CustomerSitesService,
    private taskTypeService: TaskTypeService,
    private vehicleAddressService: VehicleAddressService,
    private pcaService: PcaService,
    private environmentService: EnvironmentService,
    private userService: UserService,
    private movementLimitService: DailyMovementLimitService,
    private siteOpeningHoursService: SiteOpeningHoursService,
    public inputHelper: InputHelper,
    loggerService: LoggerService,
    private vehicleLifeCycleService: VehicleLifecycleService,
    private addressAutoCompletionService: AddressAutoCompletionService,
    private createOrderAnalyticsService: CreateOrderAnalyticsService,
    private datadogRumService: DatadogRumService,
  ) {
    // TODO: Remove after 29/09/2024
    this.RemoveCache();

    this.logger = loggerService.taggedLogger('component:create-movement-job');
    this.newJobsChange = new EventEmitter<any>();

    this.taskChange = new EventEmitter<ITaskInfo>();
    this.taskTypeChange = new EventEmitter<number>();
    this.vehicleChange = new EventEmitter<IVehicle>();
    this.pickupEarliestDateTimeChange = new EventEmitter<Date>();
    this.pickupLatestDateTimeChange = new EventEmitter<Date>();
    this.dropoffEarliestDateTimeChange = new EventEmitter<Date>();
    this.dropoffLatestDateTimeChange = new EventEmitter<Date>();
    this.additionalInformationChange = new EventEmitter<string>();
    this.createMovementJobStepChange = new EventEmitter<CreateMovementJobSteps>();
    this.selectedPickupSpecificStepsChange = new EventEmitter<Array<string>>();
    this.selectedDropoffSpecificStepsChange = new EventEmitter<Array<string>>();
    this.selectedPickupCustomActionsChange = new EventEmitter<Array<string>>();
    this.selectedDropoffCustomActionsChange = new EventEmitter<Array<string>>();
    this.newPickupCustomActionChange = new EventEmitter<string>();
    this.newDropoffCustomActionChange = new EventEmitter<string>();

    this.pickupNotesChange = new EventEmitter<string>();
    this.dropoffNotesChange = new EventEmitter<string>();

    this.typeJobChange = new EventEmitter<number>();
    this.isPlatedChange = new EventEmitter<boolean>();
    this.isCustomerInsuredChange = new EventEmitter<boolean>();
    this.isDriverInsuredChange = new EventEmitter<boolean>();
    this.isEngineiusGoChange = new EventEmitter<boolean>();
    this.isTurnaroundChange = new EventEmitter<boolean>();
    this.isUncoveredChange = new EventEmitter<boolean>();
    this.isCoveredChange = new EventEmitter<boolean>();
    this.isPrestigeTransportedChange = new EventEmitter<boolean>();
    this.isSkatesOnlyChange = new EventEmitter<boolean>();
    this.isFullLiftOnlyChange = new EventEmitter<boolean>();
    this.isMoreEquipmentNeededChange = new EventEmitter<boolean>();
    this.isRecoveryStandardChange = new EventEmitter<boolean>();
    this.isInspectionChange = new EventEmitter<boolean>();
    this.isPrestigeChange = new EventEmitter<boolean>();
    this.isDrivenInsuredInspectionChange = new EventEmitter<boolean>();
    this.isDrivenPlatedInspectionChange = new EventEmitter<boolean>();
    this.isProduction = this.environmentService.isProduction();

    this.pickupSiteHoursFormGroup = this.siteOpeningHoursService.createForm([], true);
    this.dropOffSiteHoursFormGroup = this.siteOpeningHoursService.createForm([], true);

    this.pickupSiteHoursFormGroup.valueChanges.subscribe(() => {
      if (!this.task) {
        return;
      }
      this.task.pickupSiteOpeningHours = this.siteOpeningHoursService.getOpeningHours(
        this.pickupSiteHoursFormGroup,
      );
    });

    this.dropOffSiteHoursFormGroup.valueChanges.subscribe(() => {
      if (!this.task) {
        return;
      }
      this.task.dropOffSiteOpeningHours = this.siteOpeningHoursService.getOpeningHours(
        this.dropOffSiteHoursFormGroup,
      );
    });
  }

  private backFromLastScreen;
  public userOrgLevel: IUserOrganisationLevel;

  ngOnInit() {
    this.currValidStep = 0;

    this.initRoles();

    this.submitOrderClicker$.pipe(debounceTime(500)).subscribe(() => {
      this.SubmitOrders();
    });

    this.initDefaultFilter();
    this.fuelTypes.push({ value: null, label: 'Please select a fuel type' });
    this.vehicleService.GetFuelTypes().then((res) => {
      res.forEach((x) => {
        this.fuelTypes.push({ value: x, label: x });
      });
    });
    this.filter = new Subject<ICustomerSitesFilter>();

    const currentOrgPromise = this.userService.getCurrentUserOrg();
    currentOrgPromise.then((org) => {
      this.isVmeUser = org.organisationTypeId == 1;
      this.bypassOrderLimitations = org.bypassOrderLimitations;
    });

    this.userService.isUserImpersonating().then((res) => {
      var resultData: any;
      resultData = res;
      if (resultData != null) {
        this.isUserImpersonate = resultData.isImpersonating;
      }
    });

    this.userService.isUserInRole('CVLC').then((result) => {
      this.autoSuggestPickUpLocationEnabled = result;
      this.autoSuggestNearestDropOffLocationsEnabled = result;
    });

    this.filter.pipe(debounceTime(500)).subscribe((f) => {
      this.load(f);
      this.filterVal = f;
    });

    // set default filter
    this.filter.next(this.filterVal);

    //this.page.items = [{ "id": 1, "siteName": "Site1", "businessName": "Business1", "address1": "30 Stamford Street", "address2": "Add2", "address3": "Add2", "city": "London", "postcode": "SE1 9LQ", "latitude": 51.5073, "longitude": -0.106701, "contactNo": "", "customerId": 37, "primaryAddress": "" }, { "id": 2, "siteName": "Tram Depot", "businessName": "Tram Depot", "address1": "1 Myreton Drive", "address2": "Addr2", "address3": "Add2", "city": "Edinburgh", "postcode": "EH12 9GF", "latitude": 55.9398, "longitude": -3.3266, "contactNo": "", "customerId": 37, "primaryAddress": "" }, { "id": 3, "siteName": "West Bromwich Bldg Soc", "businessName": "West Bromwich Bldg Soc", "address1": "1F High Street", "address2": "London", "address3": "Add2", "city": "Dudley", "postcode": "DY3 1RP", "latitude": 52.5417, "longitude": -2.12232, "contactNo": "", "customerId": 0 , "primaryAddress": ""}];
    //this.page.total = 4;

    this.backFromLastScreen = false;
    //this.jobs = [];
    //this.tasks = [];

    this.agreementService.agreementAgreed().then((res) => {
      this.agreementAgreed = res;

      if (!this.agreementAgreed) {
        this.messageService.add(
          Message.Error('Please confirm Engineius agreement before continuing.'),
        );
      }
    });

    this.settingsService.GetSystemSettings().then((data: ISystemSettings) => {
      this.systemSettings = data;
      this.minutesInterval = data.createOrderTimeDayInterval;
      this.createOrderMessage = (data && data.orderCreationNotificationMessage) || '';
      this.showOrderCreationMessage =
        this.createOrderMessage && this.createOrderMessage.trim() != '';
    });

    this.organisationsService.getCurrentUserOrgName().then((x) => {
      // Alex Kavanaugh: This is a very bad decision, and I do not like it.
      if (x) {
        if (x.name == 'Royal Mail') {
          this.isRoyalMail = true;
        }
      }
    });

    this.organisationsService.getUserOrganisationLevel().then((level) => {
      this.userOrgLevel = level;
    });

    this.organisationTaskTypesService.getAllowedTaskTypes().then((res) => {
      this.allowedTaskTypes = Object.assign({}, ...res.map((i) => ({ [i]: true })));
      console.log('ATT', this.allowedTaskTypes);
    });

    this.activatedRoute.params.subscribe((params: Params) => {
      let typeJob = params['type'];
      let copyOrderId = params['orderId'];

      this.formType = FormType.Create;
      if (copyOrderId != null) {
        this.formType = FormType.Copy;
      }

      if (this.formType == FormType.Create) {
        typeJob = Number(typeJob);
        copyOrderId = null;
        switch (typeJob) {
          case JobType.Driven:
          case JobType.Transported:
          case JobType.Recovered:
            this.typeJob = typeJob;
            break;
          default:
            this.typeJob = 0;
            return;
        }
      } else {
        copyOrderId = Number(copyOrderId);
        typeJob = null;
        this.GetOrderData(copyOrderId);
      }

      this.newJobs = [];
      this.fillNewJobsSelectItems();

      this.specificSteps = [];

      this.pickupSpecificSteps = [];
      this.dropoffSpecificSteps = [];

      this.customActionId = 0;
      this.pickupCustomActions = [];
      this.dropoffCustomActions = [];

      this.createNewTask();

      this.accountCodeService.getForCustomerUser().then((res) => {
        if (res) {
          this.task.furtherInformation.accountCode = res.id;
        }
      });
    });

    this.carTypes = [
      { label: 'Driven', value: 1 },
      { label: 'Transported', value: 2 },
      {
        label: 'Covered Transported',
        value: 3,
      },
    ];

    this.locationsform = this.fb.group({
      pickUpWindowUnderLimit: new UntypedFormControl(true, (validator: UntypedFormControl) => {
        return validator.value ? null : { error: 'invalid' };
      }),
      isPickupLocation: new UntypedFormControl({ disabled: true }),
      isPickupEarliestTime: new UntypedFormControl({ disabled: true }),
      isPickupLatestTime: new UntypedFormControl({ disabled: true }),
      isPickupNotes: new UntypedFormControl({ disabled: true }),
      pickupNotes: new UntypedFormControl(''),
      isDropoffEarliestTime: new UntypedFormControl({ disabled: true }),
      isDropoffLatestTime: new UntypedFormControl({ disabled: true }),
      isDropoffNotes: new UntypedFormControl({ disabled: true }),
      dropoffNotes: new UntypedFormControl(''),

      isPickupEmail: new UntypedFormControl({ disabled: true }),
      isDropoffEmail: new UntypedFormControl({ disabled: true }),
      isPickupPhone1: new UntypedFormControl({ disabled: true }),
      isDropoffPhone1: new UntypedFormControl({ disabled: true }),
      isPickupPhone2: new UntypedFormControl({ disabled: true }),
      isDropoffPhone2: new UntypedFormControl({ disabled: true }),
      isPickupContact: new UntypedFormControl({ disabled: true }),
      isDropoffContact: new UntypedFormControl({ disabled: true }),

      pickupEmail: new UntypedFormControl(''),
      pickupSecondaryEmail: new UntypedFormControl(null, [Validators.email]),
      pickupForename: new UntypedFormControl(''),
      pickupSurname: new UntypedFormControl(''),
      pickupNotification: new UntypedFormControl(''),

      dropoffEmail: new UntypedFormControl(''),
      dropoffSecondaryEmail: new UntypedFormControl(null, [Validators.email]),
      dropoffForename: new UntypedFormControl(''),
      dropoffSurname: new UntypedFormControl(''),
      dropoffNotification: new UntypedFormControl(''),
      isMoDelPinUnknown: new UntypedFormControl(''),
      moDelPin: new UntypedFormControl(''),
      releaseCode: new UntypedFormControl(''),

      isPickupSpecificStepGroup: new UntypedFormControl(''),
      pickupSpecificStepGroup: new UntypedFormControl(''),
      isDropoffSpecificStepGroup: new UntypedFormControl(''),
      dropoffSpecificStepGroup: new UntypedFormControl(''),
      newPickupCustomAction: new UntypedFormControl(''),
      isSelectedPickupCustomActions: new UntypedFormControl(''),
      selectedPickupCustomActions: new UntypedFormControl(),
      newDropoffCustomAction: new UntypedFormControl(''),
      isSelectedDropoffCustomActions: new UntypedFormControl(''),
      selectedDropoffCustomActions: new UntypedFormControl(),

      pickupPhone1: new UntypedFormControl('', (validator: UntypedFormControl) => {
        this.pickupPhone1Error = '';

        if (
          validator.value &&
          !this.validMobileNumber(validator.value) &&
          !this.validPhoneNumber(validator.value)
        ) {
          let error = 'Invalid Phone Number';
          this.pickupPhone1Error = error;

          return { valid: false, error: error };
        }

        return null;
      }),

      pickupPhone2: new UntypedFormControl('', (validator: UntypedFormControl) => {
        this.pickupPhone2Error = '';

        if (validator.value && !this.validPhoneNumber(validator.value)) {
          let error = 'Invalid Phone Number';
          this.pickupPhone2Error = error;

          return { valid: false, error: error };
        }

        return null;
      }),

      dropoffPhone1: new UntypedFormControl('', (validator: UntypedFormControl) => {
        this.dropoffPhone1Error = '';

        if (
          validator.value &&
          !this.validMobileNumber(validator.value) &&
          !this.validPhoneNumber(validator.value)
        ) {
          let error = 'Invalid Phone Number';
          this.dropoffPhone1Error = error;

          return { valid: false, error: error };
        }

        return null;
      }),

      dropoffPhone2: new UntypedFormControl('', (validator: UntypedFormControl) => {
        this.dropoffPhone2Error = '';

        if (validator.value && !this.validPhoneNumber(validator.value)) {
          let error = 'Invalid Phone Number';
          this.dropoffPhone2Error = error;

          return { valid: false, error: error };
        }

        return null;
      }),

      pickupEarliestDateTime: new UntypedFormControl('', (validator: UntypedFormControl) => {
        this.taxMotPickupEarliestError = '';

        if (!validator.value) {
          return { valid: false, error: 'Is required' };
        }

        if (validator.value.getTime() + 30 * 60000 < Date.now()) {
          return { valid: false, error: 'This value can not be less than the current date' };
        }

        let motExpiryDate = new Date(this.vehicle.motExpiryDate);
        let taxDueDate = new Date(this.vehicle.taxDueDate);
        let val = new Date(validator.value);

        let validMOTTax = this.taxAndMOTValid(val, taxDueDate, motExpiryDate);
        if (validMOTTax != null) return validMOTTax;

        if (!validator.parent) return null;

        let pickupLatestDateTime = validator.parent.controls['pickupLatestDateTime'];
        let dropoffEarliestDateTime = validator.parent.controls['dropoffEarliestDateTime'];
        let dropoffLatestDateTime = validator.parent.controls['dropoffLatestDateTime'];

        // if (pickupLatestDateTime.value) {
        //     pickupLatestDateTime.setValue(pickupLatestDateTime.value)
        // }

        if (dropoffEarliestDateTime.value) {
          dropoffEarliestDateTime.setValue(dropoffEarliestDateTime.value);
        }

        if (dropoffLatestDateTime.value) {
          dropoffLatestDateTime.setValue(dropoffLatestDateTime.value);
        }

        return null;
      }),
      pickupLatestDateTime: new UntypedFormControl('', (validator: UntypedFormControl) => {
        this.taxMotPickupLatestError = '';

        if (!validator.value) {
          return { valid: false, error: 'Is required' };
        }

        if (validator.value.getTime() < Date.now()) {
          return { valid: false, error: 'This value can not be less than the current date' };
        }

        let motExpiryDate = new Date(this.vehicle.motExpiryDate);
        let taxDueDate = new Date(this.vehicle.taxDueDate);
        let val = new Date(validator.value);

        let validMOTTax = this.taxAndMOTValid(val, taxDueDate, motExpiryDate);
        if (validMOTTax != null) return validMOTTax;

        if (!validator.parent) return null;

        let pickupEarliestDateTime = validator.parent.controls['pickupEarliestDateTime'];
        let dropoffEarliestDateTime = validator.parent.controls['dropoffEarliestDateTime'];
        let dropoffLatestDateTime = validator.parent.controls['dropoffLatestDateTime'];

        //if (pickupEarliestDateTime.value && validator.value <= pickupEarliestDateTime.value) {
        //    var date = moment(pickupEarliestDateTime.value).add(12, 'h').toDate();
        //    this.pickupLatestDateTime = date;
        //}

        if (pickupEarliestDateTime.value && validator.value < pickupEarliestDateTime.value) {
          validator.markAsDirty();
          return { valid: false, error: 'This value must be greater than Pick-up Earliest' };
        }

        if (dropoffEarliestDateTime.value) {
          dropoffEarliestDateTime.setValue(dropoffEarliestDateTime.value);
        }

        if (dropoffLatestDateTime.value) {
          dropoffLatestDateTime.setValue(dropoffLatestDateTime.value);
        }

        if (
          this.isTaxMotFound &&
          val > motExpiryDate &&
          !this.isNoMotDetails &&
          !this.isCovered &&
          !this.isUncovered &&
          !this.isRecoveryStandard &&
          !this.isPrestigeTransported
        ) {
          this.taxMotPickupLatestError = 'Date must be before MOT expiry date';
          //return { valid: true, error: 'Date must be before MOT expiry date' };
        }

        return null;
      }),
      dropoffEarliestDateTime: new UntypedFormControl('', (validator: UntypedFormControl) => {
        this.taxMotDropoffEarliestError = '';

        if (!validator.value) {
          return { valid: false, error: 'Is required' };
        }

        if (validator.value.getTime() < Date.now()) {
          return { valid: false, error: 'This value can not be less than the current date' };
        }

        if (!validator.parent) return null;

        let pickupEarliestDateTime = validator.parent.controls['pickupEarliestDateTime'];

        let dropoffLatestDateTime = validator.parent.controls['dropoffLatestDateTime'];

        if (pickupEarliestDateTime.value && validator.value < pickupEarliestDateTime.value) {
          validator.markAsDirty();
          return { valid: false, error: 'This value must be greater than Pick-up Earliest' };
        }

        let motExpiryDate = new Date(this.vehicle.motExpiryDate);
        let taxDueDate = new Date(this.vehicle.taxDueDate);
        let val = new Date(validator.value);

        let validMOTTax = this.taxAndMOTValid(val, taxDueDate, motExpiryDate);
        if (validMOTTax != null) return validMOTTax;

        if (dropoffLatestDateTime.value) {
          dropoffLatestDateTime.setValue(dropoffLatestDateTime.value);
        }

        return null;
      }),
      dropoffLatestDateTime: new UntypedFormControl('', (validator: UntypedFormControl) => {
        this.taxMotDropoffLatestError = '';

        if (!validator.value) {
          return { valid: false, error: 'Is required' };
        }

        if (validator.value.getTime() < Date.now()) {
          return { valid: false, error: 'This value can not be less than the current date' };
        }

        if (!validator.parent) return null;

        let pickupEarliestDateTime = validator.parent.controls['pickupEarliestDateTime'];
        let pickupLatestDateTime = validator.parent.controls['pickupLatestDateTime'];
        let dropoffEarliestDateTime = validator.parent.controls['dropoffEarliestDateTime'];

        if (pickupEarliestDateTime.value && validator.value <= pickupEarliestDateTime.value) {
          validator.markAsDirty();
          return { valid: false, error: 'This value must be greater than Pick-up Earliest' };
        }

        if (pickupLatestDateTime.value && validator.value < pickupLatestDateTime.value) {
          validator.markAsDirty();
          return { valid: false, error: 'This value must be greater than Pick-up Latest' };
        }

        if (dropoffEarliestDateTime.value && validator.value <= dropoffEarliestDateTime.value) {
          validator.markAsDirty();
          return { valid: false, error: 'This value must be greater than Drop-off Earliest' };
        }

        let motExpiryDate = new Date(this.vehicle.motExpiryDate);
        let taxDueDate = new Date(this.vehicle.taxDueDate);
        let val = new Date(validator.value);

        let validMOTTax = this.taxAndMOTValid(val, taxDueDate, motExpiryDate);
        if (validMOTTax != null) return validMOTTax;

        return null;
      }),
    });

    this.createTaskSteps = [
      { label: 'Vehicle' },
      { label: 'Route & Timings' },
      { label: 'Review' },
      { label: 'Order Submitted' },
    ];
    this.YesNo = [
      { label: 'Yes', value: 1 },
      { label: 'No', value: 0 },
    ];

    let that = this;
    this.mapService
      .GetPCAKey()
      .then((result) => {
        that.pcaKey = result.key;
      })
      .catch(() => {
        that.pcaKey = null;
      });

    this.pcaService.Init().then();
    this.cachedStep = JSON.parse(localStorage.getItem('stepPos_saved_key' + this.typeJob));

    if (this.cachedStep != null && !this.dataRecoveryDisplay) {
      this.simpledataRecoveryDisplay = false; //disable recovery process otherwise is true;
    }

    this.activatedRoute.queryParams.subscribe((params) => {
      if (params && params['vlcRefurbId']) {
        this.vehicleLifeCycleRefurbId = params['vlcRefurbId'];
        this.vehicleLifeCycleService
          .getRefurbInfoForNewOrderCreation(this.vehicleLifeCycleRefurbId)
          .then((refurbDetails) => {
            this.vehicleLifeCycleRefurbDetailsForNewOrder = refurbDetails;
            if (refurbDetails && refurbDetails.refurbRef != null) {
              this.registrationNumber = refurbDetails.vehicleReg;
              this.SearchVehicle();
            }
          });
      } else {
        this.vehicleLifeCycleRefurbId = 0;
      }
    });
  }

  taxAndMOTValid(dateVal: Date, taxDueDate: Date, motExpiryDate: Date) {
    if (!this.isTaxValid) {
      if (
        this.isTaxMotFound &&
        dateVal > taxDueDate &&
        !this.isPlated &&
        !this.isCovered &&
        !this.isUncovered &&
        !this.isRecoveryStandard &&
        !this.isDrivenPlatedInspection &&
        !this.isPrestigeTransported
      ) {
        return { valid: true, error: 'Date must be before TAX expiry date' };
      }
    }

    if (
      !this.isMotValid &&
      this.isTaxMotFound &&
      dateVal > motExpiryDate &&
      !this.isNoMotDetails &&
      !this.isTaxValid &&
      dateVal > taxDueDate &&
      !this.isPlated &&
      !this.isCovered &&
      !this.isUncovered &&
      !this.isRecoveryStandard &&
      !this.isPrestigeTransported &&
      !this.isDrivenPlatedInspection
    ) {
      return { valid: true, error: 'Date must be before TAX&MOT expiry date' };
    }

    if (
      !this.isMotValid &&
      dateVal > motExpiryDate &&
      !this.isNoMotDetails &&
      !this.isCovered &&
      !this.isUncovered &&
      !this.isRecoveryStandard &&
      !this.isPrestigeTransported
    ) {
      if (this.isTaxMotFound && dateVal > motExpiryDate && !this.isNoMotDetails) {
        this.taxMotPickupEarliestError = 'Date must be before MOT expiry date';
      }
    }
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: 'siteName',
      sortOrder: 1,
      filters: {
        siteName: {},
        businessName: {},
        address1: {},
        city: {},
        postcode: {},
        excludeDisabled: { value: true },
      },
    };
  }

  load(filter: ICustomerSitesFilter) {
    this.csService.getPage(flatten(filter)).then((result) => {
      this.selectedSites = null;
      this.page.items = result.items;
      this.page.total = result.total;
    });
  }

  validPhoneNumber(phoneNumber: string) {
    return phoneNumber.match(
      /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/,
    );
  }

  validMobileNumber(phoneNumber: string) {
    return phoneNumber.match(
      /^(((\+44\s?7\d{3}|\(?07\d{3}\)?)\s?\d{3}\s?\d{3})|((\+44\s?7\d{2}|\(?07\d{2}\)?)\s?\d{3}\s?\d{4})|((\+44\s?7\d{1}|\(?07\d{1}\)?)\s?\d{4}\s?\d{4}))?$/,
    );
  }

  private oldHeightEntry: number;

  limitHeight(element) {
    let max_chars = 6;
    if (element.target.value === '' && element.key !== 'Backspace') {
      this.vehicle.height = this.oldHeightEntry;
    }
    this.oldHeightEntry = this.vehicle.height;

    if (element.target.value.length > max_chars) {
      this.vehicle.height = element.target.value.substr(0, max_chars);
    }
  }

  private oldKerbWeightEntry: number;

  limitKerbWeight(element) {
    let max_chars = 6;
    if (element.target.value === '' && element.key !== 'Backspace') {
      this.vehicle.kerbWeight = this.oldKerbWeightEntry;
    }
    this.oldKerbWeightEntry = this.vehicle.kerbWeight;

    if (element.target.value.length > max_chars) {
      this.vehicle.kerbWeight = element.target.value.substr(0, max_chars);
    }
  }

  private oldSizeEngineEntry: number;

  limitSizeEngine(element) {
    let max_chars = 6;
    if (element.target.value === '' && element.key !== 'Backspace') {
      this.vehicle.sizeEngine = this.oldSizeEngineEntry;
    }
    this.oldSizeEngineEntry = this.vehicle.sizeEngine;

    if (element.target.value.length > max_chars) {
      this.vehicle.sizeEngine = element.target.value.substr(0, max_chars);
    }
  }

  private oldCarLengthEntry: number;

  limitCarLength(element) {
    let max_chars = 6;
    if (element.target.value === '' && element.key !== 'Backspace') {
      this.vehicle.carLength = this.oldCarLengthEntry;
    }
    this.oldCarLengthEntry = this.vehicle.carLength;

    if (element.target.value.length > max_chars) {
      this.vehicle.carLength = element.target.value.substr(0, max_chars);
    }
  }

  private oldWidthEntry: number;

  limitWidth(element) {
    let max_chars = 6;
    if (element.target.value === '' && element.key !== 'Backspace') {
      this.vehicle.width = this.oldWidthEntry;
    }
    this.oldWidthEntry = this.vehicle.width;

    if (element.target.value.length > max_chars) {
      this.vehicle.width = element.target.value.substr(0, max_chars);
    }
  }

  private oldNumberOfAxlesEntry: number;

  limitNumberOfAxles(element) {
    let max_chars = 6;
    if (element.target.value === '' && element.key !== 'Backspace') {
      this.vehicle.numberOfAxles = this.oldNumberOfAxlesEntry;
    }
    this.oldNumberOfAxlesEntry = this.vehicle.numberOfAxles;

    if (element.target.value.length > max_chars) {
      this.vehicle.numberOfAxles = element.target.value.substr(0, max_chars);
    }
  }

  setActiveStep(stepIndex) {
    this.activeStepIndex = stepIndex;
    this.currValidStep = stepIndex;
  }

  GetOrderData(orderId) {
    this.orderService
      .copy(orderId)
      .then((result) => {
        if (result != null) {
          if (result.tasks && result.tasks.length > 0) {
            this.typeJob = this.getJobType(result.tasks[0].taskTypeId);
          }

          result.id = 0;
          result.customerPrice = 0;
          result.customerPriceMin = 0;
          result.customerPriceMax = 0;
          result.orderNumber = '';
          result.supplierId = null;
          let dateIsValid = true;
          result.tasks.forEach((x) => {
            x.id = 0;
            x.completeTaskSteps = [];
            x.customerInfo = null;
            x.customTaskActions.forEach((y) => {
              y.id = 0;
            });
            x.taskOrganisationSpecificSteps.forEach((y) => {
              y.id = 0;
            });
            x.driver = null;
            x.driverMessages = [];
            x.dropoffEarliestDateTime = new Date(x.dropoffEarliestDateTime);
            dateIsValid = dateIsValid && x.dropoffEarliestDateTime.getTime() >= Date.now();
            x.dropoffLatestDateTime = new Date(x.dropoffLatestDateTime);
            dateIsValid = dateIsValid && x.dropoffLatestDateTime.getTime() >= Date.now();
            x.pickupEarliestDateTime = new Date(x.pickupEarliestDateTime);
            dateIsValid = dateIsValid && x.pickupEarliestDateTime.getTime() >= Date.now();
            x.pickupLatestDateTime = new Date(x.pickupLatestDateTime);
            dateIsValid = dateIsValid && x.pickupLatestDateTime.getTime() >= Date.now();

            x.dropoffLocation.id = 0;
            x.dropoffLocationId = 0;
            x.jobId = 0;
            x.jobNumber = '';
            x.pickupLocation.id = 0;
            x.pickupLocationId = 0;
            x.taskPhotographs = [];
            x.truck = null;
            x.vehicleId = 0;
            x.vehicle.id = 0;
            x.furtherInformation = {};
            x.furtherInformation.customerDepartmentId = result.customerDepartmentId;
            x.furtherInformation.customerTeamId = result.customerTeamId;
            x.furtherInformation.orderTags = result.orderTagIds;
            x.furtherInformation.accountCode = result.accountCodeListId;
            x.furtherInformation.purchaseOrderNo = result.purchaseOrderNo;
            x.notes = x.notes ? x.notes.map((n) => ({ ...n, id: 0 })) : [];
          });
          result.isOverridePrice = false;

          this.newJobs = [result];
          this.fillNewJobsSelectItems();

          if (result.tasks.length == 1) {
            this.createMovementJobStep = CreateMovementJobSteps.CreateTask;
            let task = result.tasks[0];
            this.edit(task);
            this.setRouteTime();
            this.activeStepIndex = 0;
          } else {
            this.createMovementJobStep = CreateMovementJobSteps.JobPreview;
            this.activeStepIndex = 2;
          }
          this.isCopy = true;
          this.isFirstAction = true;

          // Fetch all checklists from database
          console.log('Get Order Data');
          this.getMappedChecklists(result.tasks[0].taskTypeId, true, result.tasks[0].checklistId);

          // Arrange them into select list
          this.setSelectedChecklistForTaskType(result.tasks[0].taskTypeId);

          if (result.tasks[0].checklistId) {
            this.checklistChanged(result.tasks[0].checklistId, result.tasks[0].taskTypeId);
          }
          if (result.tasks.some((x) => !x?.vehicle?.kerbWeight)) {
            this.isShowWeightEditor = true;
          }
        } else {
          this.messageService.add(Message.Error('Order not found.', 'Copy Order'));
          this.createNewTask();
        }
      })
      .catch((ex) => {
        this.messageService.add(
          Message.Error(
            'An error occurred while loading the order. Please try again or contact your administrator.',
            'Error',
          ),
        );
        this.createNewTask();
      });
  }

  RemoveCache() {
    for (const typeJob of [JobType.Driven, JobType.Transported, JobType.Recovered]) {
      localStorage.removeItem('jobs_saved_key' + typeJob);
      localStorage.removeItem('task_saved_key' + typeJob);
      localStorage.removeItem('vehicle_saved_key' + typeJob);
      localStorage.removeItem('requirementsCachedData_saved_key' + typeJob);
      localStorage.removeItem('routeandtimingsCachedData_saved_key' + typeJob);
      localStorage.removeItem('stepPos_saved_key' + typeJob);
    }
  }

  addCustomAction(formValues: ICustomTaskAction) {
    if (!formValues) {
      return;
    }
    formValues.name = formValues.name.trim();
    if (formValues.isPickUp) {
      this.pickupCustomActions.push(formValues);
      this.selectedPickupCustomActions.push(this.customActionId.toString());
      this.selectedPickupCustomActions = this.selectedPickupCustomActions;
    } else {
      this.dropoffCustomActions.push(formValues);
      this.selectedDropoffCustomActions.push(this.customActionId.toString());
      this.selectedDropoffCustomActions = this.selectedDropoffCustomActions;
    }
    this.customActionId++;
    this.isShowAdditionalStepForm = false;
    this.buildWorkflowForChecklist();
  }

  dragStart(event, task: any, job: any) {
    if (!this.isCreateCustomJob) return;
    this.draggedTask = task;
    this.draggedFromJob = job;
  }

  drop(event, toJob: any) {
    if (!this.isCreateCustomJob) return;

    if (this.draggedTask && this.draggedFromJob && toJob) {
      let oldIndex = this.draggedFromJob.tasks.indexOf(this.draggedTask);
      if (
        oldIndex >= 0 &&
        toJob.tasks.length > 0 &&
        toJob.tasks[0].taskTypeId == this.draggedTask.taskTypeId
      ) {
        this.draggedFromJob.tasks.splice(oldIndex, 1);
        toJob.tasks.push(this.draggedTask);

        if (this.draggedFromJob.tasks.length == 0) {
          let jobs = this.newJobs.slice(0);
          let jobIndex = jobs.indexOf(this.draggedFromJob);

          if (jobIndex >= 0) {
            jobs.splice(jobIndex, 1);
            this.newJobs = jobs;
            this.fillNewJobsSelectItems();
            this.newJobsChange.emit(jobs);
          }
        }
      }

      this.draggedTask = null;
      this.draggedFromJob = null;
    }
  }

  dropNewJob(event) {
    if (!this.isCreateCustomJob) return;

    if (this.draggedTask && this.draggedFromJob) {
      let oldIndex = this.draggedFromJob.tasks.indexOf(this.draggedTask);
      if (oldIndex >= 0) {
        this.draggedFromJob.tasks.splice(oldIndex, 1);
        this.newJobs.push({
          tasks: [this.draggedTask],
          customerId: 0,
          id: 0,
          supplierId: 0,
          orderNumber: '',
          lastUpdated: null,
          selectedSuppliers: [],
          customerPrice: null,
          customerPriceMin: null,
          customerPriceMax: null,
          accountCodeListId: this.draggedTask.furtherInformation.accountCode,
          purchaseOrderNo: this.draggedTask.furtherInformation.purchaseOrderNo,
          orderTagIds: this.draggedTask.furtherInformation.orderTags,

          customerDepartmentId: this.draggedTask.furtherInformation.customerDepartmentId,
          customerTeamId: this.draggedTask.furtherInformation.customerTeamId,
        });

        if (this.draggedFromJob.tasks.length == 0) {
          let jobs = this.newJobs.slice(0);
          let jobIndex = jobs.indexOf(this.draggedFromJob);

          if (jobIndex >= 0) {
            jobs.splice(jobIndex, 1);
            this.newJobs = jobs;
            this.fillNewJobsSelectItems();
            this.newJobsChange.emit(jobs);
          }
        }
      }

      this.draggedTask = null;
      this.draggedFromJob = null;
    }

    this.fillNewJobsSelectItems();
  }

  dragEnd(event) {
    this.draggedTask = null;
    this.draggedFromJob = null;
  }

  /**
   * Creates a new Task
   */
  createNewTask() {
    //Reset following options settins as not needed for this selected option
    this.isFollowOnJourney = false;
    this.isReturnJourney = false;

    this.backFromLastScreen = false;
    this.createMovementJobStep = CreateMovementJobSteps.CreateTask;

    if (this.locationsform) {
      this.locationsform.reset();
    }

    this.editTask = null;

    this.task = {
      jobId: 0,
      pickupEarliestDateTime: null,
      pickupLatestDateTime: null,
      dropoffEarliestDateTime: null,
      dropoffLatestDateTime: null,
      pickupLocationId: 0,
      pickupLocation: null,
      dropoffLocationId: 0,
      dropoffLocation: null,
      additionalInformation: '',
      vehicleId: 0,
      vehicle: null,
      taskSteps: [],
      taskTypeId: 0,
      jobNumber: '',
      customerInfo: null,
      id: 0,
      taskOrganisationSpecificSteps: [],
      overNightParkingPhotoTaskSteps: [],
      customTaskActions: [],
      notes: [],
      taskPhotographs: [],
      driverMessages: [],
      completeTaskSteps: [],
      driver: null,
      truck: null,
      furtherInformation: {},
      pickupOdometer: 0,
      dropoffOdometer: 0,
      pickupFuel: 0,
      dropoffFuel: 0,
      requiredPhotoAreas: [],
      customSteps: [],

      pickupForename: null,
      pickupSurname: null,
      pickupEmail: null,
      pickupSecondaryEmail: null,
      pickupPhone1: null,
      pickupPhone2: null,
      pickupNotification: null,
      pickupBusinessName: null,

      dropoffForename: null,
      dropoffSurname: null,
      dropoffEmail: null,
      dropoffSecondaryEmail: null,
      dropoffPhone1: null,
      dropoffPhone2: null,
      dropoffBusinessName: null,
      departmentInfo: null,
      teamInfo: null,
      dropoffNotification: null,
      estimateTime: '00:00',
      dropOffSiteOpeningHours: [],
      pickupSiteOpeningHours: [],
    };

    let selectedPickupSpecificSteps = [];
    let selectedDropoffSpecificSteps = [];

    // todo: check here that this makes sense.

    for (let i = 0; i < this.pickupSpecificSteps.length; i++) {
      selectedPickupSpecificSteps.push(this.pickupSpecificSteps[i].id.toString());
    }

    for (let i = 0; i < this.dropoffSpecificSteps.length; i++) {
      selectedDropoffSpecificSteps.push(this.dropoffSpecificSteps[i].id.toString());
    }
    this.logger.debug('createNewTask: Setting selected pickup & Dropoff steps:');
    this.logger.debug('selectedPickupSpecificSteps:', selectedPickupSpecificSteps);
    this.logger.debug('selectedDropoffSpecificSteps:', selectedDropoffSpecificSteps);
    this.selectedPickupSpecificSteps = selectedPickupSpecificSteps;
    this.selectedDropoffSpecificSteps = selectedDropoffSpecificSteps;

    this.pickupCustomActions = [];
    this.dropoffCustomActions = [];
    this.selectedPickupCustomActions = [];
    this.selectedDropoffCustomActions = [];

    this.activeStepIndex = 0;

    switch (this.typeJob) {
      case JobType.Driven:
      case JobType.Transported:
      case JobType.Recovered:
        this.isPlated = false;
        this.isCustomerInsured = false;
        this.isDriverInsured = false;
        this.isEngineiusGo = false;
        this.isTurnaround = false;
        this.isPrestige = false;
        this.isUncovered = false;
        this.isPrestigeTransported = false;
        this.isCovered = false;
        this.isSkatesOnly = false;
        this.isFullLiftOnly = false;
        this.isMoreEquipmentNeeded = false;
        this.isRecoveryStandard = false;
        this.isInspection = false;
        this.isDrivenInsuredInspection = false;
        this.isDrivenPlatedInspection = false;
        break;
      default:
        return;
    }

    this.additionalInformation = '';

    this.pickupLocation = null;
    this.addressSearchPickupLocation = null;
    this.pickupEarliestDateTime = undefined;
    this.pickupLatestDateTime = undefined;

    this.dropoffLocation = null;
    this.addressSearchDropoffLocation = null;
    this.dropoffEarliestDateTime = undefined;
    this.dropoffLatestDateTime = undefined;

    this.pickupNotes = null;
    this.dropoffNotes = null;

    this.pickupNotification = null;
    this.dropoffNotification = null;
    this.isMoDelPinUnknown = null;

    this.pickupForename = null;
    this.dropoffForename = null;

    this.pickupSurname = null;
    this.dropoffSurname = null;

    this.pickupEmail = null;
    this.dropoffEmail = null;

    this.pickupSecondaryEmail = null;
    this.dropoffSecondaryEmail = null;

    this.pickupPhone1 = null;
    this.pickupPhone2 = null;

    this.dropoffPhone1 = null;
    this.dropoffPhone2 = null;

    this.vehicle = null;
    this.registrationNumber = '';
    this.isShowSaerchByVin = false;
    this.isShowSaerchManual = false;
    this.isShowVehicleDetail = false;

    this.createOrderAnalyticsService.sendEvent(
      this.getAnalyticsCreateOrderObject(AnalyticsOrderEvent.new_task_order),
    );
  }

  private getAnalyticsCreateOrderObject(
    triggerEvent: AnalyticsOrderEvent,
  ): AnalyticsCreateOrderComponent {
    return {
      triggerEvent: triggerEvent,
      vehicle: this.vehicle,
      isFollowOnJourney: this.isFollowOnJourney,
      isReturnJourney: this.isReturnJourney,
      newJobs: this.newJobs,
      task: this.task,
      pickupLocation: this.pickupLocation,
      dropoffLocation: this.dropoffLocation,
      taskCount: this.getCurrentTaskCount(),
      taskType: this.taskType,
      specificStepGroups: this.specificStepGroups,
      selectedGroupId: this.selectedGroupId,
      selectedOrder: this.selectedNewJob?.id,
    } as AnalyticsCreateOrderComponent;
  }

  /**
   * Edits something? The task maybe.
   * @param task The Task
   */
  edit(task: ITaskInfo) {
    if (!task) return;

    if (this.locationsform) {
      this.locationsform.reset();
    }

    this.editTask = task;
    this.task = Object.assign({}, task);

    this.activeStepIndex = 0;

    let pickupSpecificSteps = [];
    let dropoffSpecificSteps = [];
    for (let i = 0; i < this.task.taskOrganisationSpecificSteps.length; i++) {
      if (this.task.taskOrganisationSpecificSteps[i].isPickUp == true) {
        pickupSpecificSteps.push(
          this.task.taskOrganisationSpecificSteps[i].organisationSpecificStepId.toString(),
        );
      } else {
        dropoffSpecificSteps.push(
          this.task.taskOrganisationSpecificSteps[i].organisationSpecificStepId.toString(),
        );
      }
    }

    this.logger.debug('edit: setting selected pcikup/dropoff steps:');
    this.logger.debug('pickupSpecificSteps');
    this.logger.debug('dropoffSpecificSteps');
    this.selectedPickupSpecificSteps = pickupSpecificSteps;
    this.selectedDropoffSpecificSteps = dropoffSpecificSteps;

    this._pickupForename = this.task.pickupForename;
    this._pickupSurname = this.task.pickupSurname;
    this._pickupEmail = this.task.pickupEmail;
    this._pickupSecondaryEmail = this.task.pickupSecondaryEmail;
    this._pickupPhone1 = this.task.pickupPhone1;
    this._pickupPhone2 = this.task.pickupPhone2;

    this._dropoffForename = this.task.dropoffForename;
    this._dropoffSurname = this.task.dropoffSurname;
    this._dropoffEmail = this.task.dropoffEmail;
    this._dropoffSecondaryEmail = this.task.dropoffSecondaryEmail;
    this._dropoffPhone1 = this.task.dropoffPhone1;
    this._dropoffPhone2 = this.task.dropoffPhone2;

    this._inspectionContactFullName = this.task.inspectionContactFullName;
    this._inspectionContactEmail = this.task.inspectionContactEmail;

    this.addressSearchPickupLocation = { ...this.task.pickupLocation };
    this.addressSearchDropoffLocation = { ...this.task.dropoffLocation };

    let pickupCustomActions = [];
    let dropoffCustomActions = [];
    let selectedPickupCustomActions = [];
    let selectedDropoffCustomActions = [];

    for (let i = 0; i < this.task.customTaskActions.length; i++) {
      if (this.task.customTaskActions[i].isPickUp == true) {
        pickupCustomActions.push({
          id: this.task.customTaskActions[i].id,
          name: this.task.customTaskActions[i].name,
        });
        selectedPickupCustomActions.push(this.task.customTaskActions[i].id.toString());
      } else {
        dropoffCustomActions.push({
          id: this.task.customTaskActions[i].id,
          name: this.task.customTaskActions[i].name,
        });
        selectedDropoffCustomActions.push(this.task.customTaskActions[i].id.toString());
      }
    }

    this.pickupCustomActions = pickupCustomActions;
    this.dropoffCustomActions = dropoffCustomActions;

    this.selectedPickupCustomActions = selectedPickupCustomActions;
    this.selectedDropoffCustomActions = selectedDropoffCustomActions;

    this.SetVarsFromTaskType(this.task.taskTypeId);

    this.createOrderAnalyticsService.sendEvent(
      this.getAnalyticsCreateOrderObject(AnalyticsOrderEvent.edit_task_order),
    );
  }

  SetVarsFromTaskType(taskType) {
    switch (taskType) {
      case TaskType.DrivenPlated:
        this.isPlated = true;
        break;
      case TaskType.DrivenUninsured:
        this.isCustomerInsured = true;
        break;
      case TaskType.DriverInsured:
        this.isDriverInsured = true;
        break;
      case TaskType.DrivenEngineiusGo:
        this.isEngineiusGo = true;
        break;
      case TaskType.DrivenTurnaround:
        this.isTurnaround = true;
        break;
      case TaskType.DrivenPrestige:
        this.isPrestige = true;
        break;
      case TaskType.UncoveredTransportedMovement:
        this.isUncovered = true;
        break;
      case TaskType.CoveredTransportedMovement:
        this.isCovered = true;
        break;
      case TaskType.PrestigeTransported:
        this.isPrestigeTransported = true;
        break;
      case TaskType.RecoveredSkates:
        this.isSkatesOnly = true;
        break;
      case TaskType.RecoveredFullLiftOnly:
        this.isFullLiftOnly = true;
        break;
      case TaskType.RecoveredMoreEquipmentNeeded:
        this.isMoreEquipmentNeeded = true;
        break;
      case TaskType.RecoveryStandard:
        this.isRecoveryStandard = true;
        break;
      case TaskType.Inspection:
        this.isInspection = true;
        break;
      case TaskType.DrivenInsuredInspection:
        this.isDrivenInsuredInspection = true;
        break;
      case TaskType.DrivenPlatedInspection:
        this.isDrivenPlatedInspection = true;
        break;
    }

    this.additionalInformation = this.task.additionalInformation;

    this.pickupLocation = this.task.pickupLocation;
    this.pickupEarliestDateTime = this.task.pickupEarliestDateTime;
    this.pickupLatestDateTime = this.task.pickupLatestDateTime;

    this.dropoffLocation = this.task.dropoffLocation;
    this.dropoffEarliestDateTime = this.task.dropoffEarliestDateTime;
    this.dropoffLatestDateTime = this.task.dropoffLatestDateTime;

    if (this.editTask) {
      this.dropoffEarliestDateTime = this.editTask.dropoffEarliestDateTime;
      this.dropoffLatestDateTime = this.editTask.dropoffLatestDateTime;
    }

    if (this.locationsform) {
      this.locationsform.controls['pickupEarliestDateTime'].markAsDirty();
      this.locationsform.controls['pickupLatestDateTime'].markAsDirty();
      this.locationsform.controls['dropoffEarliestDateTime'].markAsDirty();
      this.locationsform.controls['dropoffLatestDateTime'].markAsDirty();
    }

    this.isShowSaerchByVin = false;
    this.isShowSaerchManual = false;
    this.isShowVehicleDetail = false;
    this.vehicle = this.task.vehicle;
    this.registrationNumber = this.task.vehicle.registrationNumber;

    this.analyzeTaxMot(this.vehicle);

    this.createMovementJobStep = CreateMovementJobSteps.CreateTask;
  }

  /**
   * Copies Something? The task maybe?
   * @param task The Task
   */
  copy(task: ITaskInfo) {
    if (!task) return;

    if (this.locationsform) {
      this.locationsform.reset();
    }

    this.editTask = null;

    this.task = Object.assign({}, task);

    this.activeStepIndex = 0;

    let pickupSpecificSteps = [];
    let dropoffSpecificSteps = [];
    for (let i = 0; i < this.task.taskOrganisationSpecificSteps.length; i++) {
      if (this.task.taskOrganisationSpecificSteps[i].isPickUp == true) {
        pickupSpecificSteps.push(
          this.task.taskOrganisationSpecificSteps[i].organisationSpecificStepId.toString(),
        );
      } else {
        dropoffSpecificSteps.push(
          this.task.taskOrganisationSpecificSteps[i].organisationSpecificStepId.toString(),
        );
      }
    }

    this.selectedPickupSpecificSteps = pickupSpecificSteps;
    this.selectedDropoffSpecificSteps = dropoffSpecificSteps;

    let pickupCustomActions = [];
    let dropoffCustomActions = [];
    let selectedPickupCustomActions = [];
    let selectedDropoffCustomActions = [];

    for (let i = 0; i < this.task.customTaskActions.length; i++) {
      if (this.task.customTaskActions[i].isPickUp == true) {
        pickupCustomActions.push({
          id: this.task.customTaskActions[i].id,
          name: this.task.customTaskActions[i].name,
        });
        selectedPickupCustomActions.push(this.task.customTaskActions[i].id.toString());
      } else {
        dropoffCustomActions.push({
          id: this.task.customTaskActions[i].id,
          name: this.task.customTaskActions[i].name,
        });
        selectedDropoffCustomActions.push(this.task.customTaskActions[i].id.toString());
      }
    }

    this.pickupCustomActions = pickupCustomActions;
    this.dropoffCustomActions = dropoffCustomActions;

    this.selectedPickupCustomActions = selectedPickupCustomActions;
    this.selectedDropoffCustomActions = selectedDropoffCustomActions;

    let taskType = this.task.taskTypeId;

    switch (taskType) {
      case TaskType.DrivenPlated:
        this.isPlated = true;
        break;
      case TaskType.DrivenUninsured:
        this.isCustomerInsured = true;
        break;
      case TaskType.DriverInsured:
        this.isDriverInsured = true;
        break;
      case TaskType.DrivenEngineiusGo:
        this.isEngineiusGo = true;
        break;
      case TaskType.DrivenTurnaround:
        this.isTurnaround = true;
        break;
      case TaskType.UncoveredTransportedMovement:
        this.isUncovered = true;
        break;
      case TaskType.CoveredTransportedMovement:
        this.isCovered = true;
        break;
      case TaskType.RecoveredSkates:
        this.isSkatesOnly = true;
        break;
      case TaskType.RecoveredFullLiftOnly:
        this.isFullLiftOnly = true;
        break;
      case TaskType.RecoveredMoreEquipmentNeeded:
        this.isMoreEquipmentNeeded = true;
        break;
      case TaskType.RecoveryStandard:
        this.isRecoveryStandard = true;
        break;
      case TaskType.Inspection:
        this.isInspection = true;
        break;
      case TaskType.DrivenInsuredInspection:
        this.isDrivenInsuredInspection = true;
        break;
      case TaskType.DrivenPlatedInspection:
        this.isDrivenPlatedInspection = true;
        break;
      case TaskType.PrestigeTransported:
        this.isPrestigeTransported = true;
        break;
    }

    this.additionalInformation = this.task.additionalInformation;

    this.pickupLocation = this.task.pickupLocation;
    this.pickupEarliestDateTime = this.task.pickupEarliestDateTime;
    this.pickupLatestDateTime = this.task.pickupLatestDateTime;

    this.dropoffLocation = this.task.dropoffLocation;
    this.dropoffEarliestDateTime = this.task.dropoffEarliestDateTime;
    this.dropoffLatestDateTime = this.task.dropoffLatestDateTime;

    this.isShowSaerchByVin = false;
    this.isShowSaerchManual = false;
    this.isShowVehicleDetail = false;
    this.vehicle = this.task.vehicle;
    this.registrationNumber = this.task.vehicle.registrationNumber;

    this.createMovementJobStep = CreateMovementJobSteps.CreateTask;
  }

  /**
   * Adds a follow on journey to the Order?
   * @param task The task
   */
  addFollowOnJourney(task: ITaskInfo) {
    if (!task) return;

    this.isReturnJourney = false;
    if (
      this.task.taskTypeId == TaskType.DrivenPlated ||
      this.task.taskTypeId == TaskType.DrivenUninsured ||
      this.task.taskTypeId == TaskType.DriverInsured ||
      this.task.taskTypeId == TaskType.DrivenPrestige ||
      this.task.taskTypeId == TaskType.DrivenEngineiusGo
    )
      this.isFollowOnJourney = true;

    if (this.locationsform) {
      this.locationsform.reset();
    }

    this.editTask = null;

    this.task = Object.assign({}, task);
    this.task.notes = [];
    this.activeStepIndex = 0;

    let taskType = this.task.taskTypeId;

    let pickupSpecificSteps = [];
    let dropoffSpecificSteps = [];
    for (let i = 0; i < this.task.taskOrganisationSpecificSteps.length; i++) {
      if (this.task.taskOrganisationSpecificSteps[i].isPickUp == true) {
        pickupSpecificSteps.push(
          this.task.taskOrganisationSpecificSteps[i].organisationSpecificStepId.toString(),
        );
      } else {
        dropoffSpecificSteps.push(
          this.task.taskOrganisationSpecificSteps[i].organisationSpecificStepId.toString(),
        );
      }
    }

    this.selectedPickupSpecificSteps = pickupSpecificSteps;
    this.selectedDropoffSpecificSteps = dropoffSpecificSteps;

    let pickupCustomActions = [];
    let dropoffCustomActions = [];
    let selectedPickupCustomActions = [];
    let selectedDropoffCustomActions = [];

    for (let i = 0; i < this.task.customTaskActions.length; i++) {
      if (this.task.customTaskActions[i].isPickUp == true) {
        pickupCustomActions.push({
          id: this.task.customTaskActions[i].id,
          name: this.task.customTaskActions[i].name,
        });
        selectedPickupCustomActions.push(this.task.customTaskActions[i].id.toString());
      } else {
        dropoffCustomActions.push({
          id: this.task.customTaskActions[i].id,
          name: this.task.customTaskActions[i].name,
        });
        selectedDropoffCustomActions.push(this.task.customTaskActions[i].id.toString());
      }
    }

    this.pickupCustomActions = pickupCustomActions;
    this.dropoffCustomActions = dropoffCustomActions;

    this.selectedPickupCustomActions = selectedPickupCustomActions;
    this.selectedDropoffCustomActions = selectedDropoffCustomActions;

    this.SetVarsFromTaskType(taskType);

    this.additionalInformation = this.task.additionalInformation;

    this.pickupEarliestDateTime = moment(this.task.dropoffEarliestDateTime).toDate();
    this.pickupLatestDateTime = moment(this.task.dropoffLatestDateTime).toDate();
    this.pickupLocation = this.task.dropoffLocation;

    // Dereference the task so "this" and "this.task" doesn't get mixed up during reassignment
    let clone = { ...this.task };

    this.pickupForename = clone.dropoffForename;
    this.pickupSurname = clone.dropoffSurname;
    this.pickupPhone1 = clone.dropoffPhone1;
    this.pickupPhone2 = clone.dropoffPhone2;
    this.pickupEmail = clone.dropoffEmail;
    this.pickupSecondaryEmail = clone.dropoffSecondaryEmail;

    this.dropoffForename = null;
    this.dropoffSurname = null;
    this.dropoffPhone1 = null;
    this.dropoffPhone2 = null;
    this.dropoffEmail = null;
    this.dropoffSecondaryEmail = null;

    this.dropoffLocation = null;
    this.dropoffEarliestDateTime = null;
    this.dropoffLatestDateTime = null;

    this.isShowSaerchByVin = false;
    this.isShowSaerchManual = false;
    this.isShowVehicleDetail = false;
    this.vehicle = null;
    this.registrationNumber = '';
    this.pickupNotes = null;
    this.dropoffNotes = null;

    this.createMovementJobStep = CreateMovementJobSteps.CreateTask;
  }

  /**
   * Adds a return journey to the task
   * @param task The Task
   */
  addReturnJourney(task: ITaskInfo) {
    if (!task) return;

    this.isFollowOnJourney = false;

    if (
      this.task.taskTypeId == TaskType.DrivenPlated ||
      this.task.taskTypeId == TaskType.DrivenUninsured ||
      this.task.taskTypeId == TaskType.DriverInsured ||
      this.task.taskTypeId == TaskType.DrivenPrestige ||
      this.task.taskTypeId == TaskType.DrivenEngineiusGo ||
      this.task.taskTypeId == TaskType.DrivenTurnaround
    )
      this.isReturnJourney = true;

    if (this.locationsform) {
      this.locationsform.reset();
    }

    this.editTask = null;
    this.task = Object.assign({}, task);
    this.task.notes = [];
    this.activeStepIndex = 0;

    let taskType = this.task.taskTypeId;

    let pickupSpecificSteps = [];
    let dropoffSpecificSteps = [];
    for (let i = 0; i < this.task.taskOrganisationSpecificSteps.length; i++) {
      if (this.task.taskOrganisationSpecificSteps[i].isPickUp == true) {
        pickupSpecificSteps.push(
          this.task.taskOrganisationSpecificSteps[i].organisationSpecificStepId.toString(),
        );
      } else {
        dropoffSpecificSteps.push(
          this.task.taskOrganisationSpecificSteps[i].organisationSpecificStepId.toString(),
        );
      }
    }

    this.selectedPickupSpecificSteps = pickupSpecificSteps;
    this.selectedDropoffSpecificSteps = dropoffSpecificSteps;

    let pickupCustomActions = [];
    let dropoffCustomActions = [];
    let selectedPickupCustomActions = [];
    let selectedDropoffCustomActions = [];

    for (let i = 0; i < this.task.customTaskActions.length; i++) {
      if (this.task.customTaskActions[i].isPickUp == true) {
        pickupCustomActions.push({
          id: this.task.customTaskActions[i].id,
          name: this.task.customTaskActions[i].name,
        });
        selectedPickupCustomActions.push(this.task.customTaskActions[i].id.toString());
      } else {
        dropoffCustomActions.push({
          id: this.task.customTaskActions[i].id,
          name: this.task.customTaskActions[i].name,
        });
        selectedDropoffCustomActions.push(this.task.customTaskActions[i].id.toString());
      }
    }

    this.pickupCustomActions = pickupCustomActions;
    this.dropoffCustomActions = dropoffCustomActions;

    this.selectedPickupCustomActions = selectedPickupCustomActions;
    this.selectedDropoffCustomActions = selectedDropoffCustomActions;

    this.SetVarsFromTaskType(taskType);

    this.additionalInformation = this.task.additionalInformation;

    let pickupLocation = this.task.pickupLocation;

    this.pickupEarliestDateTime = this.task.dropoffEarliestDateTime;
    this.pickupLatestDateTime = this.task.dropoffLatestDateTime;
    this.pickupLocation = this.task.dropoffLocation;

    this.dropoffEarliestDateTime = undefined;
    this.dropoffLatestDateTime = undefined;
    this.dropoffLocation = pickupLocation;

    this.isShowSaerchByVin = false;
    this.isShowSaerchManual = false;
    this.isShowVehicleDetail = false;
    this.vehicle = this.task.vehicle;
    this.registrationNumber = this.task.vehicle.registrationNumber;
    this.pickupNotes = null;
    this.dropoffNotes = null;

    // Dereference the task so "this" and "this.task" doesn't get mixed up during reassignment
    let clone = { ...this.task };

    this.pickupForename = clone.dropoffForename;
    this.pickupSurname = clone.dropoffSurname;
    this.pickupPhone1 = clone.dropoffPhone1;
    this.pickupPhone2 = clone.dropoffPhone2;
    this.pickupEmail = clone.dropoffEmail;
    this.pickupSecondaryEmail = clone.dropoffSecondaryEmail;

    this.dropoffForename = clone.pickupForename;
    this.dropoffSurname = clone.pickupSurname;
    this.dropoffPhone1 = clone.pickupPhone1;
    this.dropoffPhone2 = clone.pickupPhone2;
    this.dropoffEmail = clone.pickupEmail;
    this.dropoffSecondaryEmail = clone.pickupSecondaryEmail;

    this.createMovementJobStep = CreateMovementJobSteps.CreateTask;
  }

  @ViewChild('jobDetailsView')
  jobDetailsView: JobDetailsComponent;

  public showDeleteTaskDialog: boolean = false;
  public deleteTask: ITaskInfo = null;
  public deleteFromOrder: IOrderInfo = null;

  Delete(order: IOrderInfo, task: ITaskInfo) {
    this.showDeleteTaskDialog = true;

    this.deleteFromOrder = order;
    this.deleteTask = task;
  }

  acceptDeleteTask() {
    //Cancel button is activated only when there is at least 1 order set
    if (this.newJobsSelectItems.length == 1) {
      this.extraOptionSelected = false;
    }

    this.showDeleteTaskDialog = false;

    let order = this.deleteFromOrder;
    let task = this.deleteTask;

    //this.deleteFromOrder = null;
    //this.deleteTask = null;

    if (!order || !task) return;

    let indexTask = order.tasks.indexOf(task);
    if (indexTask < 0) return;

    order.tasks.splice(indexTask, 1);
    try {
      if (this.jobDetailsView) {
        this.jobDetailsView.refreshJobTasks();
      }
    } catch (exception) {
      console.error('job details do not existed', exception);
    }

    if (order.tasks.length == 0) {
      let indexJob = this.newJobs.indexOf(order);
      if (indexJob >= 0) {
        this.newJobs.splice(indexJob, 1);
      }
      this.fillNewJobsSelectItems();
    }

    this.updateTaskSequencingFlagForTasksInJob();

    if (this.newJobs.length == 0) {
      this.createNewTask();
      return;
    }
  }

  cancelDeleteTask() {
    this.showDeleteTaskDialog = false;
    this.deleteFromOrder = null;
    this.deleteTask = null;
  }

  ShowDetailsForSelectVehicle(event, vehicle: IVehicle, overlaypanel: OverlayPanel) {
    this.selectVehicle = vehicle;
    overlaypanel.toggle(event);
  }

  CancelCreateTask() {
    if (this.isCopy) {
      this.createMovementJobStep = CreateMovementJobSteps.JobPreview;
      this.activeStepIndex = this.createTaskSteps.length - 2;
      return;
    }

    this.currValidStep = 0;
    this.isFirstAction = false;
    this.editTask = null;

    this.isReturnJourney = false;
    this.isFollowOnJourney = false;
    this.resetChecklist();

    if (this.newJobs.length == 0) {
      this.createNewTask();
    } else {
      this.createNewTask();
      this.createMovementJobStep = CreateMovementJobSteps.JobPreview;
      this.activeStepIndex = 2;
      //this.UpdateSelectedJobButtons();
    }
  }

  BackStep() {
    if (this.isCopy && this.activeStepIndex == 0) {
      this.location.back();
      return;
    }

    if (this.activeStepIndex > 0) {
      this.activeStepIndex--;
    }

    if (this.activeStepIndex == 1) {
      this.initStep2();
    }
  }

  closeMoDelDialog() {
    this.isShowMoDelDialog = false;
  }

  private resetChecklist() {
    this.selectedGroupId = undefined;
    this.pickupSpecificSteps = [];
    this.dropoffSpecificSteps = [];
    this.workflow = undefined;
  }

  checkForDuplicatesBeforeProceeding() {
    if (this.activeStepIndex !== 0) {
      this.CheckOrgStepReqModelPinOrActionNextStep();
      return;
    }

    console.log('CHECKING.. ');

    this.checkingDuplicates = true;

    this.taskService
      .checkForDuplicateMovements({
        registrationNumber: this.registrationNumber,
        taskType: this.taskType,
      })
      .then((response: { duplicateExists: boolean; tasks?: ITaskWithJobInfo[] }) => {
        this.checkingDuplicates = false;

        if (response.duplicateExists === true) {
          // Prompt to continue

          this.showDuplicateTaskDialog = true;
          this.duplicateTasks = response.tasks;
          console.log('DUPLICATE EXISTS');
        } else {
          console.log('NO DUPLICATE EXISTS');
          this.CheckOrgStepReqModelPinOrActionNextStep();
        }
      });
  }

  CheckOrgStepReqModelPinOrActionNextStep() {
    const organisationSpecificSteps = this.task.taskOrganisationSpecificSteps;
    const step = organisationSpecificSteps.find((o) => o.ancillaryStepId === 2);

    const isFirstStep = this.activeStepIndex === 1;
    const isMoDelPinMissing =
      !this.task.moDelPin || this.task.moDelPin === '' || this.task.moDelPin === ' ';

    const noPickupNumber =
      (!this.pickupPhone1 || this.pickupPhone1Error != '') && !this.pickupPhone2;
    const noDropoffNumber =
      (!this.dropoffPhone1 || this.dropoffPhone1Error != '') && !this.dropoffPhone2;
    const noContactNumbers = noPickupNumber || noDropoffNumber;

    if (isFirstStep && noContactNumbers) {
      this.contactNumberDialogHeader =
        noPickupNumber && noDropoffNumber
          ? 'No Pickup or Drop-off contact'
          : noPickupNumber
          ? 'No Pickup Contact'
          : 'No Drop-off contact';
      this.showContactNumberDialog = true;
      return;
    }

    if (step && isFirstStep) {
      if (isMoDelPinMissing && this.isMoDelPinUnknown) {
        this.isShowMoDelDialog = true;
      } else if (isMoDelPinMissing && !this.isMoDelPinUnknown) {
        this.isShowMoDelContainerError = true;
      } else {
        this.NextStep();
      }
    } else {
      this.NextStep();
    }
  }

  get showMoDelPinContainer(): boolean {
    const organisationSpecificSteps = this.task.taskOrganisationSpecificSteps;
    const step = organisationSpecificSteps.find((o) => o.ancillaryStepId === 2);
    return step !== undefined;
  }

  closeModelPinDialog() {
    this.isShowMoDelDialog = false;
    this.NextStep();
  }

  closeContactNumberWarningDialog(nextStep: boolean) {
    this.showContactNumberDialog = false;

    if (nextStep) {
      this.NextStep();
    }
  }

  NextStep() {
    const eventToTrigger: AnalyticsOrderEvent = this.activeStepIndex as AnalyticsOrderEvent;
    this.createOrderAnalyticsService.sendEvent(this.getAnalyticsCreateOrderObject(eventToTrigger));
    this.messageService.clear();
    if (
      this.activeStepIndex == 0 &&
      this.vehicle.kerbWeight >= 3500 &&
      (this.taskType == TaskType.CoveredTransportedMovement ||
        this.taskType == TaskType.UncoveredTransportedMovement)
    ) {
      this.messageService.add(Message.Error('Vehicle Weight Exceeds Maximum Transported Weight'));
      return;
    }

    if (this.activeStepIndex == 1 && !this.isMotDatesOnStep2Valid() && !this.taxMotDatesConfirm) {
      this.motWarningType = MotWarningType.PickupDropoffDates;
      this.isShowMotWarning = true;
      return;
    }

    if (this.activeStepIndex < this.createTaskSteps.length - 1) {
      this.activeStepIndex++;
    }

    if (this.activeStepIndex == 1) {
      window.scrollTo(0, 0);
      this.initStep2();
    }

    //Save Previous Step Data to cache
    if (this.activeStepIndex > this.currValidStep) {
      this.currValidStep = this.activeStepIndex;
    }
  }

  InitializeDatesTimes(ignoreDropoff: boolean = false) {
    //When you edit task, not necessary to initializa dates.
    if (this.editTask) return;

    if (!this.systemSettings || !this.systemSettings.autoCalculateOrderDates) return;

    // set defaults
    let pickupEarliestDateTime =
      this.pickupEarliestDateTime || this._getDefaultPickupEarliestDateTime();
    let pickupLatestDateTime: Date =
      this.pickupLatestDateTime || this._getDefaultPickupLatestDateTime(pickupEarliestDateTime);

    let dropoffEarliestDateTime: Date;
    let dropoffLatestDateTime: Date;

    if (!ignoreDropoff) {
      dropoffEarliestDateTime = this._getDefaultDropoffEarliestDateTime(
        this.pickupEarliestDateTime,
      );
      dropoffLatestDateTime = this._getDefaultDropoffLatestDateTime(this.pickupLatestDateTime);
    }

    if (pickupEarliestDateTime) {
      this.pickupEarliestDateTime = this.roundUpTime(pickupEarliestDateTime);
    }
    if (pickupLatestDateTime) {
      this.pickupLatestDateTime = this.roundUpTime(pickupLatestDateTime);
    }
    if (dropoffEarliestDateTime) {
      this.dropoffEarliestDateTime = this.roundUpTime(dropoffEarliestDateTime);
    }
    if (dropoffLatestDateTime) {
      this.dropoffLatestDateTime = this.roundUpTime(dropoffLatestDateTime);
    }
  }

  public _getDefaultPickupEarliestDateTime(): Date {
    let earliestDate: Date = new Date();
    earliestDate.setDate(earliestDate.getDate() + 1);
    earliestDate.setHours(this.systemSettings.createOrderDefaultEarliestPickupHour, 0, 0, 0);
    return earliestDate;
  }

  private _getDefaultPickupLatestDateTime(pickupEarliestDateTime: Date): Date {
    let latestDate: Date = new Date(pickupEarliestDateTime);
    latestDate.setDate(latestDate.getDate() + this.systemSettings.createOrderDefaultWindowDays);
    latestDate.setHours(this.systemSettings.createOrderDefaultLatestPickupHour, 0, 0, 0);
    return latestDate;
  }

  public _getDefaultDropoffEarliestDateTime(pickupEarliestDateTime: Date): Date {
    let earliestDate: Date = new Date(pickupEarliestDateTime);
    earliestDate = moment(earliestDate).add(this.routeTime, 's').toDate();
    earliestDate = this.roundUpTime(earliestDate);

    if (!this.isWithinDefaultDropoffHours(earliestDate)) {
      earliestDate = moment(earliestDate).add(1, 'd').toDate();
      earliestDate.setHours(this.systemSettings.createOrderDefaultEarliestDropoffHour, 0, 0, 0);
    }
    return earliestDate;
  }

  private _getValidDropoffLatestDateTime(pickupLatestDateTime: Date) {
    let latestDate: Date = new Date(pickupLatestDateTime);
    latestDate = moment(latestDate).add(this.routeTime, 's').toDate();
    latestDate = this.roundUpTime(latestDate);
    return latestDate;
  }

  private _getDefaultDropoffLatestDateTime(pickupLatestDateTime: Date): Date {
    let latestDate: Date = this._getValidDropoffLatestDateTime(pickupLatestDateTime);

    if (!this.isWithinDefaultDropoffHours(latestDate)) {
      latestDate = moment(latestDate).add(1, 'd').toDate();
      latestDate.setHours(this.systemSettings.createOrderDefaultLatestDropoffHour, 0, 0, 0);
    }
    return latestDate;
  }

  protected isWithinDefaultDropoffHours(time: Date) {
    if (
      time.getHours() >= this.systemSettings.createOrderDefaultEarliestDropoffHour &&
      time.getHours() <= this.systemSettings.createOrderDefaultLatestDropoffHour
    ) {
      return true;
    }
    return false;
  }

  roundUpTime(time: Date) {
    // For 60 min interval
    if (this.minutesInterval == 60) {
      if (time.getMinutes() != 0) {
        time.setMinutes(60);
      }

      return time;
    }

    if (time.getMinutes() % this.minutesInterval == 0 || time.getMinutes() == 0) {
      return time;
    }

    let min = this.minutesInterval;
    while (min < 60) {
      if (min >= time.getMinutes()) {
        break;
      }

      min += this.minutesInterval;
    }

    if (min > 60) {
      time.setMinutes(60);
    } else {
      time.setMinutes(min);
    }

    return time;
  }

  initPickupOpeningHoursForm() {}

  initDropOffOpeningHoursForm() {}

  initStep2() {
    const fieldsPickUp = [
      {
        element: 'searchPickUp',
        field: '',
        parentContainer: 'searchPickUpContainer',
        showSavedSites: true,
      },
    ];

    this.addressAutoCompletionService.useWithVehicleAddressConverter(
      fieldsPickUp,
      (address) => {
        this.pickupLocation = address;
        this.siteOpeningHoursService.resetForm(this.pickupSiteHoursFormGroup);
        this.getSuggestedCustomerDropOffLocations();
        this.disableAddressSearchPickupFields = false;
        this.pickupAddressMatchedSite = null;
      },
      (site: ICustomerSites) => {
        this.selectSite(site, true);
      },
      () => {
        this.pickupLocation = {
          addressLine1: null,
          addressLine2: null,
          addressLine3: null,
          businessName: null,
          city: null,
          country: null,
          id: 0,
          postal_town: null,
          postcode: null,
          primaryAddress: null,
          route: null,
          secondary: null,
          street_number: null,
          latitude: null,
          longitude: null,
          manualEntry: true,
        };
        this.siteOpeningHoursService.resetForm(this.pickupSiteHoursFormGroup);
        this.disableAddressSearchPickupFields = false;
        this.pickupAddressMatchedSite = null;
      },
    );

    const fieldsDropOff = [
      {
        element: 'searchDropoff',
        field: '',
        parentContainer: 'searchDropoffContainer',
        showSavedSites: true,
      },
    ];
    this.addressAutoCompletionService.useWithVehicleAddressConverter(
      fieldsDropOff,
      (address) => {
        this.dropoffLocation = address;
        this.siteOpeningHoursService.resetForm(this.dropOffSiteHoursFormGroup);
        this.task.vehicleLifeCycleSiteId = null;
        this.disableAddressSearchDropoffFields = false;
        this.dropoffAddressMatchedSite = null;
      },
      (site: ICustomerSites) => {
        this.selectSite(site, false);
      },
      () => {
        this.dropoffLocation = {
          addressLine1: null,
          addressLine2: null,
          addressLine3: null,
          businessName: null,
          city: null,
          country: null,
          id: 0,
          postal_town: null,
          postcode: null,
          primaryAddress: null,
          route: null,
          secondary: null,
          street_number: null,
          latitude: null,
          longitude: null,
          manualEntry: true,
        };
        this.siteOpeningHoursService.resetForm(this.dropOffSiteHoursFormGroup);
        this.task.vehicleLifeCycleSiteId = null;
        this.disableAddressSearchDropoffFields = false;
        this.dropoffAddressMatchedSite = null;
      },
    );

    this.checkIfVehicleHasPreviousDropOffLocation();
    this.populatePickUpAddressWithVehicleLifeCycleRefurbSite();
  }

  private populatePickUpAddressWithVehicleLifeCycleRefurbSite(): void {
    if (
      this.vehicleLifeCycleRefurbId > 0 &&
      this.vehicleLifeCycleRefurbDetailsForNewOrder &&
      this.vehicleLifeCycleRefurbDetailsForNewOrder.currentSite > 0
    ) {
      this.selectSite(this.vehicleLifeCycleRefurbDetailsForNewOrder.customerSiteDetails, true);
    }
  }

  CalculateRouteTime() {
    let pickup = this.pickupLocation;
    let dropoff = this.dropoffLocation;
    this.routeTime = null;

    if (!this.editTask) {
      this.dropoffEarliestDateTime = undefined;
      this.dropoffLatestDateTime = undefined;
    }

    if (
      pickup &&
      dropoff &&
      typeof pickup.latitude == 'number' &&
      typeof pickup.longitude == 'number' &&
      typeof dropoff.latitude == 'number' &&
      typeof dropoff.longitude == 'number'
    ) {
      const dto = this.mapService.GetRouteDTO(pickup, dropoff, this.pickupEarliestDateTime);

      return this.mapService.GetRoute(dto).then((route) => {
        if (route != null) {
          this.routeTime = route.duration;
          this.InitializeDatesTimes();
        }

        return route;
      });
    } else if (pickup) {
      this.InitializeDatesTimes(true);
    }
  }

  /*
    Search Vehicle
     */

  public isTaxValid: boolean = false;
  public isMotValid: boolean = false;
  public isNoMotDetails: boolean = false;
  public motNotRequired: boolean = false;
  public isTaxMotFound: boolean = true;
  public isShowMotWarning: boolean = false;
  private vinRegPattern = new RegExp(/^[A-Z]{2}\d{6}$/);

  isMotDatesOnStep2Valid() {
    return (
      this.taxMotPickupEarliestError == '' &&
      this.taxMotPickupLatestError == '' &&
      this.taxMotDropoffEarliestError == '' &&
      this.taxMotDropoffLatestError == ''
    );
  }

  AddVehicleMessage(msg) {
    this.vehicleMsgs = [];
    this.vehicleMsgs.push(msg);
    setTimeout(() => {
      this.vehicleMsgs = [];
    }, 1500);
  }

  SearchVehicle() {
    this.isSearchVehicle = true;
    this.vehicle = null;
    this.isShowSaerchByVin = false;
    this.isShowSaerchManual = false;
    this.isShowVehicleDetail = false;
    this.isShowWeightEditor = false;
    this.isTaxValid = false;
    this.isMotValid = false;
    this.isTaxMotFound = true;
    this.oldKerbWeightEntry = null;
    this.isDrivenDisabled = false;
    let that = this;
    let tempRegNumber = this.registrationNumber.trim().toUpperCase();
    if (tempRegNumber == 'TBC' || this.vinRegPattern.test(tempRegNumber)) {
      this.isTaxMotFound = false;

      that.vehicle = {
        id: 0,
        vin: '',
        transmissionType: '',
        fuelType: '',
        registrationNumber: this.registrationNumber,
        make: '',
        model: '',
        kerbWeight: null,
        color: '',
        carLength: 0,
        height: 0,
        width: 0,
        numberOfAxles: 0,
        sizeEngine: 0,
        wheelbaseLength: '',
        registrationDate: null,
        body: null,
        isVinReg: this.vinRegPattern.test(tempRegNumber),
        actualFuelType: '',
      };
      this.isShowWeightEditor = true;
      that.isSearchVehicle = false;
      this.showVehicleDetailsIfApplicable();
    } else {
      this.vehicleService
        .GetByRegNum(this.registrationNumber)
        .then((vehicle) => {
          if (IsDisabledForDrivenMovementsVehicleBodyType(vehicle.body)) {
            this.isDrivenDisabled = true;
          }

          if (vehicle.registrationDate) {
            vehicle.registrationDate = new Date(vehicle.registrationDate);
          }

          if (vehicle.kerbWeight <= 0) {
            this.isShowWeightEditor = true;
          }

          this.analyzeTaxMot(vehicle);

          that.vehicle = vehicle;
          this.showVehicleDetailsIfApplicable();

          if (vehicle == null) {
            that.AddVehicleMessage({ severity: 'warn', summary: '', detail: 'Vehicle not Found' });
          }
          that.isSearchVehicle = false;
        })
        .catch(() => {
          that.vehicle = null;
          that.isSearchVehicle = false;
          that.AddVehicleMessage({ severity: 'warn', summary: '', detail: 'Vehicle not Found.' });
        });
    }
  }

  private showVehicleDetailsIfApplicable(): void {
    if (
      !this.vehicle ||
      !this.vehicle.registrationNumber ||
      this.vehicle.registrationNumber.trim() == '' ||
      !this.vehicle.fuelType
    ) {
      this.ShowVehicleDetails();
    }
  }

  SearchVehicleByVin() {
    this.isSearchVehicle = true;
    this.isShowSaerchManual = false;
    this.isShowVehicleDetail = false;
    this.isTaxValid = false;
    this.isMotValid = false;
    this.isTaxMotFound = true;
    this.vehicle = null;
    let that = this;
    this.isDrivenDisabled = false;
    this.vehicleService
      .GetByVin(this.vin)
      .then((vehicle) => {
        that.vehicle = vehicle;
        if (vehicle == null) {
          that.AddVehicleMessage({ severity: 'warn', summary: '', detail: 'Vehicle not Found' });
        }

        if (IsDisabledForDrivenMovementsVehicleBodyType(vehicle?.body)) {
          this.isDrivenDisabled = true;
        }

        this.analyzeTaxMot(vehicle);

        that.isSearchVehicle = false;
      })
      .catch(() => {
        that.vehicle = null;
        that.isSearchVehicle = false;
        that.AddVehicleMessage({ severity: 'warn', summary: '', detail: 'Vehicle not Found.' });
      });
  }

  analyzeTaxMot(vehicle) {
    let response: IMotTaxStatus = CheckMotTax(vehicle);

    this.isTaxValid = response.isTaxValid;
    this.isNoMotDetails = response.isNoMotDetails;
    this.isMotValid = response.isMotValid;
    this.isTaxMotFound = response.isTaxMotFound;
    this.motNotRequired = response.motNotRequired;

    if (!this.isTaxValid) {
      this.isDriverInsured = false;
      this.isEngineiusGo = false;
      this.isTurnaround = false;
      this.isCustomerInsured = false;
      this.isPrestige = false;
    }

    this.chekhMovementTypeOnMotChanged();
  }

  ShowVehicleDetails() {
    this.isShowVehicleDetail = true;
    //this.isShowWeightEditor = false;
  }

  NoRegistration() {
    this.vehicle = null;
    this.isShowSaerchByVin = true;
    this.isShowSaerchManual = false;
    this.isShowWeightEditor = false;
  }

  NoVin() {
    this.vehicle = {
      id: 0,
      vin: '',
      transmissionType: '',
      fuelType: '',
      make: '',
      model: '',
      registrationNumber: 'No Reg',
      color: '',
      carLength: null,
      height: null,
      kerbWeight: null,
      numberOfAxles: null,
      width: null,
      body: '',
      registrationDate: undefined,
      sizeEngine: null,
      wheelbaseLength: '',
      actualFuelType: '',
    };

    this.vehicleDetailForm.reset();

    this.isShowSaerchByVin = true;
    this.isShowSaerchManual = true;
    this.isShowWeightEditor = true;
  }

  /*
    End
    Search Vehicle
     */

  /*
    Task Review
     */
  BackMovementJobStep() {
    this.backFromLastScreen = true;
    this.activeStepIndex = 3;
    this.createMovementJobStep = 0;
  }

  SaveDetails() {
    //if (!this.backFromLastScreen){
    this.AddCurrentTaskToJobs();
    //}

    //this.backFromLastScreen = false;
    //this.CreateNewTask();
    //this.createMovementJobStep = CreateMovementJobSteps.JobPreview;
    this.fillNewJobsSelectItems();
  }

  CreateAnotherTask() {
    //Reset following options settins as not needed for this selected option
    this.isFollowOnJourney = false;
    this.isReturnJourney = false;
    this.resetChecklist();

    this.isFirstAction = false;
    this.AddCurrentTaskToJobs();

    this.createNewTask();

    //Availability of cancel button
    this.extraOptionSelected = true;
  }

  CreateAddVehicleTask() {
    //Reset following options settins as not needed for this selected option
    this.isFollowOnJourney = false;
    this.isReturnJourney = false;

    this.isFirstAction = false;
    this.AddCurrentTaskToJobs();

    //backFromLastScreen added after AddCurrentTaskToJobs() to avoid last task for being duplicated
    this.backFromLastScreen = false;

    this.copy(this.task);

    this.vehicle = null;
    this.registrationNumber = '';

    this.messageService.add(
      Message.Info(
        'Please ensure that, for the best possible pricing, all vehicles on the same job will fit on most transporter trucks. We cannot guarantee fulfillment for jobs for more than 4 vehicles - we will confirm as soon as we have sourced a supplier',
        'Multiple Vehicles',
      ),
    );

    //Availability of cancel button
    this.extraOptionSelected = true;
  }

  CreateReturnJourneyTask() {
    this.isFirstAction = false;
    this.AddCurrentTaskToJobs();

    this.addReturnJourney(this.task);

    //Availability of cancel button
    this.extraOptionSelected = true;
  }

  CreateFollowOnJourneyTask() {
    this.isFirstAction = false;
    this.AddCurrentTaskToJobs();

    this.addFollowOnJourney(this.task);

    //Availability of cancel button
    this.extraOptionSelected = true;
  }

  isTaskEquals(tasks: Array<ITaskInfo>): boolean {
    if (!tasks || tasks.length < 2) return false;

    let firstTask = tasks[0];

    for (let i = 1; i < tasks.length; i++) {
      let distanceStart = this.GetDistance(
        firstTask.pickupLocation.longitude,
        firstTask.pickupLocation.latitude,
        tasks[i].pickupLocation.longitude,
        tasks[i].pickupLocation.latitude,
        null,
      );
      let distanceEnd = this.GetDistance(
        firstTask.dropoffLocation.longitude,
        firstTask.dropoffLocation.latitude,
        tasks[i].dropoffLocation.longitude,
        tasks[i].dropoffLocation.latitude,
        null,
      );
      if (
        distanceStart > 1 ||
        distanceEnd > 1 ||
        firstTask.pickupEarliestDateTime.getTime() != tasks[i].pickupEarliestDateTime.getTime() ||
        firstTask.pickupLatestDateTime.getTime() != tasks[i].pickupLatestDateTime.getTime() ||
        firstTask.dropoffEarliestDateTime.getTime() != tasks[i].dropoffEarliestDateTime.getTime() ||
        firstTask.dropoffLatestDateTime.getTime() != tasks[i].dropoffLatestDateTime.getTime()
      ) {
        return false;
      }
    }

    return true;
  }

  AddCurrentTaskToJobs() {
    let currentTask = cloneDeep(this.task);

    if (this.editTask) {
      for (let i = 0; i < this.newJobs.length; i++) {
        for (let j = 0; j < this.newJobs[i].tasks.length; j++) {
          if (this.editTask == this.newJobs[i].tasks[j]) {
            // edit task finded
            //if (this.newJobs[i].tasks.length == 1) {

            //}

            this.newJobs[i].tasks[j] = currentTask;

            this.newJobs[i].accountCodeListId = currentTask.furtherInformation.accountCode;
            this.newJobs[i].purchaseOrderNo = currentTask.furtherInformation.purchaseOrderNo;

            this.newJobs[i].customerDepartmentId =
              currentTask.furtherInformation.customerDepartmentId;
            this.newJobs[i].customerTeamId = currentTask.furtherInformation.customerTeamId;
            return;
          }
        }
      }
    }

    this.editTask = null;

    if (
      (this.newJobs.length == 0 ||
        (currentTask.taskTypeId != TaskType.UncoveredTransportedMovement &&
          currentTask.taskTypeId != TaskType.CoveredTransportedMovement &&
          currentTask.taskTypeId != TaskType.DrivenPlated &&
          currentTask.taskTypeId != TaskType.DrivenUninsured &&
          currentTask.taskTypeId != TaskType.DriverInsured &&
          currentTask.taskTypeId != TaskType.DrivenPrestige &&
          currentTask.taskTypeId != TaskType.DrivenEngineiusGo)) &&
      !this.backFromLastScreen
    ) {
      this.newJobs.push({
        tasks: [currentTask],
        customerId: 0,
        id: 0,
        supplierId: 0,
        orderNumber: '',
        lastUpdated: null,
        selectedSuppliers: [],
        customerPrice: null,
        customerPriceMin: null,
        customerPriceMax: null,
        accountCodeListId: currentTask.furtherInformation.accountCode,
        purchaseOrderNo: currentTask.furtherInformation.purchaseOrderNo,
        orderTagIds: currentTask.furtherInformation.orderTags,

        customerDepartmentId: currentTask.furtherInformation.customerDepartmentId,
        customerTeamId: currentTask.furtherInformation.customerTeamId,
      });
      this.fillNewJobsSelectItems();
      return;
    }

    let goodJobs = [];

    for (let i = 0; i < this.newJobs.length; i++) {
      let job = this.newJobs[i];

      let lastTask = job.tasks[job.tasks.length - 1];

      // don't comment out these two lines or multiple orders will be created for follow-on and return journeys
      lastTask.dropoffLatestDateTime.setSeconds(0);
      lastTask.dropoffEarliestDateTime.setSeconds(0);

      if (lastTask.taskTypeId != currentTask.taskTypeId) continue;

      if (
        job.tasks.length == 1 &&
        (currentTask.taskTypeId == TaskType.UncoveredTransportedMovement ||
          currentTask.taskTypeId == TaskType.CoveredTransportedMovement ||
          currentTask.taskTypeId == TaskType.DrivenPlated ||
          currentTask.taskTypeId == TaskType.DrivenUninsured ||
          currentTask.taskTypeId == TaskType.DriverInsured ||
          currentTask.taskTypeId == TaskType.DrivenEngineiusGo ||
          currentTask.taskTypeId == TaskType.DrivenTurnaround ||
          currentTask.taskTypeId == TaskType.DrivenPrestige)
      ) {
        let distance1 = this.GetDistance(
          lastTask.dropoffLocation.longitude,
          lastTask.dropoffLocation.latitude,
          currentTask.pickupLocation.longitude,
          currentTask.pickupLocation.latitude,
          null,
        );

        //console.log(distance1)
        let tttt = currentTask.dropoffEarliestDateTime.getTime();

        if (
          distance1 < 1 &&
          lastTask.dropoffEarliestDateTime.getTime() ==
            currentTask.pickupEarliestDateTime.getTime() &&
          lastTask.dropoffLatestDateTime.getTime() == currentTask.pickupLatestDateTime.getTime()
        ) {
          goodJobs = [];
          goodJobs.push({ job: job, priority: 10, type: 1 });
          break;
        }

        let distance2 = this.GetDistance(
          currentTask.dropoffLocation.longitude,
          currentTask.dropoffLocation.latitude,
          lastTask.pickupLocation.longitude,
          lastTask.pickupLocation.latitude,
          null,
        );

        if (
          distance2 < 1 &&
          lastTask.pickupEarliestDateTime.getTime() ==
            currentTask.dropoffEarliestDateTime.getTime() &&
          lastTask.pickupLatestDateTime.getTime() == currentTask.dropoffLatestDateTime.getTime()
        ) {
          goodJobs = [];
          goodJobs.push({ job: job, priority: 10, type: 2 });
          break;
        }

        if (
          distance1 < 5 &&
          lastTask.dropoffEarliestDateTime.getTime() <=
            currentTask.pickupEarliestDateTime.getTime() &&
          lastTask.dropoffLatestDateTime.getTime() >= currentTask.pickupEarliestDateTime.getTime()
        ) {
          goodJobs.push({ job: job, priority: 1, type: 1 });
        }

        if (
          distance2 < 5 &&
          lastTask.pickupEarliestDateTime.getTime() >=
            currentTask.dropoffEarliestDateTime.getTime() &&
          lastTask.pickupEarliestDateTime.getTime() <= currentTask.dropoffLatestDateTime.getTime()
        ) {
          goodJobs.push({ job: job, priority: 1, type: 2 });
        }
      }

      if (
        job.tasks.length < 7 &&
        (currentTask.taskTypeId == TaskType.UncoveredTransportedMovement ||
          currentTask.taskTypeId == TaskType.CoveredTransportedMovement)
      ) {
        if (
          job.tasks.every((element, index, array) => {
            let distanceStart = this.GetDistance(
              element.pickupLocation.longitude,
              element.pickupLocation.latitude,
              currentTask.pickupLocation.longitude,
              currentTask.pickupLocation.latitude,
              null,
            );

            let distanceEnd = this.GetDistance(
              element.dropoffLocation.longitude,
              element.dropoffLocation.latitude,
              currentTask.dropoffLocation.longitude,
              currentTask.dropoffLocation.latitude,
              null,
            );

            return (
              distanceStart < 1 &&
              distanceEnd < 1 &&
              element.pickupEarliestDateTime.getTime() ==
                currentTask.pickupEarliestDateTime.getTime() &&
              element.pickupLatestDateTime.getTime() ==
                currentTask.pickupLatestDateTime.getTime() &&
              element.dropoffEarliestDateTime.getTime() ==
                currentTask.dropoffEarliestDateTime.getTime() &&
              element.dropoffLatestDateTime.getTime() == currentTask.dropoffLatestDateTime.getTime()
            );
          })
        ) {
          goodJobs = [];
          goodJobs.push({ job: job, priority: 10, type: 3 });
          break;
        }
      }
    }

    if (goodJobs.length == 0) {
      if (!this.backFromLastScreen) {
        this.newJobs.push({
          tasks: [currentTask],
          customerId: 0,
          id: 0,
          supplierId: 0,
          orderNumber: '',
          lastUpdated: null,
          selectedSuppliers: [],
          customerPrice: null,
          customerPriceMin: null,
          customerPriceMax: null,
          accountCodeListId: currentTask.furtherInformation.accountCode,
          purchaseOrderNo: currentTask.furtherInformation.purchaseOrderNo,
          orderTagIds: currentTask.furtherInformation.orderTags,

          customerDepartmentId: currentTask.furtherInformation.customerDepartmentId,
          customerTeamId: currentTask.furtherInformation.customerTeamId,
        });
      }
      this.fillNewJobsSelectItems();
      return;
    }

    if (goodJobs.length == 1) {
      if (goodJobs[0].type == 1 || goodJobs[0].type == 3) {
        if (!this.backFromLastScreen) {
          goodJobs[0].job.tasks.push(currentTask);
        }
      } else if (goodJobs[0].type == 2) {
        if (!this.backFromLastScreen) {
          goodJobs[0].job.tasks.unshift(currentTask);
        }
      }
      return;
    }

    goodJobs.sort((a, b) => {
      return b.priority - a.priority;
    });

    if (goodJobs[0].type == 1 || goodJobs[0].type == 3) {
      if (!this.backFromLastScreen) {
        goodJobs[0].job.tasks.push(currentTask);
      }
    } else if (goodJobs[0].type == 2) {
      if (!this.backFromLastScreen) {
        goodJobs[0].job.tasks.unshift(currentTask);
      }
    }
  }

  isSameRoute(job, currentTask) {
    if (
      job.tasks.length < 7 &&
      (currentTask.taskTypeId == TaskType.UncoveredTransportedMovement ||
        currentTask.taskTypeId == TaskType.CoveredTransportedMovement ||
        currentTask.taskTypeId == TaskType.DrivenPlated ||
        currentTask.taskTypeId == TaskType.DrivenUninsured ||
        currentTask.tasTypeID == TaskType.DriverInsured ||
        currentTask.tasTypeID == TaskType.DrivenEngineiusGo)
    ) {
      if (
        job.tasks.every((element, index, array) => {
          let distanceStart = this.GetDistance(
            element.pickupLocation.longitude,
            element.pickupLocation.latitude,
            currentTask.pickupLocation.longitude,
            currentTask.pickupLocation.latitude,
            null,
          );

          let distanceEnd = this.GetDistance(
            element.dropoffLocation.longitude,
            element.dropoffLocation.latitude,
            currentTask.dropoffLocation.longitude,
            currentTask.dropoffLocation.latitude,
            null,
          );

          return (
            distanceStart < 1 &&
            distanceEnd < 1 &&
            element.pickupEarliestDateTime.getTime() ==
              currentTask.pickupEarliestDateTime.getTime() &&
            element.pickupLatestDateTime.getTime() == currentTask.pickupLatestDateTime.getTime() &&
            element.dropoffEarliestDateTime.getTime() ==
              currentTask.dropoffEarliestDateTime.getTime() &&
            element.dropoffLatestDateTime.getTime() == currentTask.dropoffLatestDateTime.getTime()
          );
        })
      ) {
        return true;
      }
    }

    return false;
  }

  /*
    End
    Task Review
     */

  OpenSelectSupplier() {
    this.createMovementJobStep = CreateMovementJobSteps.SelectSupplier;
  }

  OpenJobPreview() {
    this.createMovementJobStep = CreateMovementJobSteps.JobPreview;
    //this.UpdateSelectedJobButtons();
  }

  /*
     SaveAllJob
     */
  SaveAllJob() {
    this.IsBusy = true;

    //Date object added timezone to date which is ignored in server side. As result server save wrong date.
    //Convert to string fix this problem
    this.newJobs.forEach((job) => {
      job.tasks.forEach((t) => {
        t.pickupEarliestDateTime = moment(t.pickupEarliestDateTime).format('YYYY-MM-DD HH:mm');
        t.pickupLatestDateTime = moment(t.pickupLatestDateTime).format('YYYY-MM-DD HH:mm');
        t.dropoffEarliestDateTime = moment(t.dropoffEarliestDateTime).format('YYYY-MM-DD HH:mm');
        t.dropoffLatestDateTime = moment(t.dropoffLatestDateTime).format('YYYY-MM-DD HH:mm');
      });
    });

    this.taskService
      .SaveNewOrders(this.newJobs)
      .then(() => {
        this.messageService.add(Message.Success('Order created', ''));
        this.createOrderAnalyticsService.sendEvent(
          this.getAnalyticsCreateOrderObject(AnalyticsOrderEvent.order_price_toast_success),
        );
        this.IsBusy = false;
        this.newJobs = [];
        this.fillNewJobsSelectItems();
        this.router.navigate(['app/customerinbox']);
      })
      .catch((error) => {
        this.messageService.add(Message.Error('Order not created: ' + error.error.error, 'Error'));
        this.IsBusy = false;
      });
  }

  /*
      End

      SaveAllJob
     */

  /*

    Task Menu Items

    */

  getMenuItems(job, task): MenuItem[] {
    let items: MenuItem[];

    items = [
      {
        label: 'Actions',
        items: [
          {
            label: 'Add Follow on journey',
            icon: 'fa-follow-journey-black',
            command: (event) => {
              this.addFollowOnJourney(task);
            },
          },
          {
            label: 'Add Return journey',
            icon: 'fa-return-journey-black',
            command: (event) => {
              this.addReturnJourney(task);
            },
          },
          {
            label: 'Edit',
            icon: 'fa-edit-journey',
            command: (event) => {
              this.edit(task);
            },
          },
          {
            label: 'Delete',
            icon: 'fa-close',
            command: (event) => {
              this.Delete(job, task);
            },
          },
        ],
      },
    ];

    return items;
  }

  getCurrentTaskNumber(): number {
    if (!this.editTask) {
      return this.getCurrentTaskCount();
    }

    let number = 0;
    for (let i = 0; i < this.newJobs.length; i++) {
      let index = this.newJobs[i].tasks.indexOf(this.editTask);
      if (index < 0) {
        number += this.newJobs[i].tasks.length;
      } else {
        number += index + 1;
        break;
      }
    }

    return number;
  }

  getCurrentTaskCount(): number {
    let number = 0;
    for (let i = 0; i < this.newJobs.length; i++) {
      number += this.newJobs[i].tasks.length;
    }

    if (!this.editTask) {
      number += 1;
    }

    return number;
  }

  /*
    End Task Menu Items
     */
  ValidateTask(task: ITaskInfo): string[] {
    let errors = [];
    let dropoffEarliestDateTime = task.dropoffEarliestDateTime;
    let dropoffLatestDateTime = task.dropoffLatestDateTime;
    let pickupEarliestDateTime = task.pickupEarliestDateTime;
    let pickupLatestDateTime = task.pickupLatestDateTime;
    let currentDate = Date.now();

    if (!pickupEarliestDateTime) {
      errors.push('Pick-up Earliest is required.');
    } else {
      if (typeof pickupEarliestDateTime == 'string') {
        pickupEarliestDateTime = new Date(pickupEarliestDateTime);
      }

      if (pickupEarliestDateTime.getTime() + 30 * 60000 < currentDate) {
        errors.push('Pick-up Earliest must be greater than the current date');
      }
    }

    if (!pickupLatestDateTime) {
      errors.push('Pick-up Latest is required.');
    } else {
      if (typeof pickupLatestDateTime == 'string') {
        pickupLatestDateTime = new Date(pickupLatestDateTime);
      }

      if (pickupLatestDateTime.getTime() < currentDate) {
        errors.push('Pick-up Latest must be greater than the current date');
      }
    }

    if (!dropoffEarliestDateTime) {
      errors.push('Drop-off Earliest is required.');
    } else {
      if (typeof dropoffEarliestDateTime == 'string') {
        dropoffEarliestDateTime = new Date(dropoffEarliestDateTime);
      }

      if (dropoffEarliestDateTime.getTime() < currentDate) {
        errors.push('Drop-off Earliest must be greater than the current date');
      }
    }

    if (!dropoffLatestDateTime) {
      errors.push('Drop-off Latest is required.');
    } else {
      if (typeof dropoffLatestDateTime == 'string') {
        dropoffLatestDateTime = new Date(dropoffLatestDateTime);
      }

      if (dropoffLatestDateTime.getTime() < currentDate) {
        errors.push('Drop-off Latest must be greater than the current date');
      }
    }

    if (errors && errors.length > 0) {
      console.log('** ** Errors: ', errors);
    }

    return errors;
  }

  overwriteTaxDueDateIfValid(dropOffLatestDate: Date, task: ITaskInfo): Date | null {
    if (!task.vehicle.isTaxValid || dropOffLatestDate <= task.vehicle.taxDueDate) {
      return task.vehicle.taxDueDate;
    }

    const newTaxDueDate = new Date(dropOffLatestDate);
    newTaxDueDate.setDate(newTaxDueDate.getDate() + 1);

    return (task.vehicle.taxDueDate = newTaxDueDate);
  }

  ValidateTaxMot(task: ITaskInfo): string[] {
    let errors = [];

    let dropoffEarliestDateTime = new Date(task.dropoffEarliestDateTime);
    let dropoffLatestDateTime = new Date(task.dropoffLatestDateTime);
    let pickupEarliestDateTime = new Date(task.pickupEarliestDateTime);
    let pickupLatestDateTime = new Date(task.pickupLatestDateTime);

    let motExpiryDate = new Date(task.vehicle.motExpiryDate);
    const taxDueDate = this.overwriteTaxDueDateIfValid(dropoffLatestDateTime, task);

    if (
      this.isTaxMotFound &&
      task.taskTypeId !== TaskType.DrivenPlated &&
      task.taskTypeId !== TaskType.RecoveryStandard &&
      task.taskTypeId !== TaskType.RecoveredSkates &&
      task.taskTypeId !== TaskType.RecoveredFullLiftOnly &&
      task.taskTypeId !== TaskType.CoveredTransportedMovement &&
      task.taskTypeId !== TaskType.UncoveredTransportedMovement &&
      task.taskTypeId !== TaskType.RecoveredMoreEquipmentNeeded &&
      task.taskTypeId !== TaskType.DrivenPlatedInspection &&
      task.taskTypeId !== TaskType.PrestigeTransported &&
      (dropoffEarliestDateTime > taxDueDate ||
        dropoffLatestDateTime > taxDueDate ||
        pickupEarliestDateTime > taxDueDate ||
        pickupLatestDateTime > taxDueDate)
    ) {
      errors.push('Date must be before TAX expiry date');
    }

    if (
      this.isTaxMotFound &&
      !this.isNoMotDetails &&
      task.taskTypeId !== TaskType.DrivenPlated &&
      task.taskTypeId !== TaskType.RecoveryStandard &&
      task.taskTypeId !== TaskType.RecoveredSkates &&
      task.taskTypeId !== TaskType.RecoveredFullLiftOnly &&
      task.taskTypeId !== TaskType.CoveredTransportedMovement &&
      task.taskTypeId !== TaskType.UncoveredTransportedMovement &&
      task.taskTypeId !== TaskType.RecoveredMoreEquipmentNeeded &&
      task.taskTypeId !== TaskType.DrivenPlatedInspection &&
      task.taskTypeId !== TaskType.PrestigeTransported &&
      (dropoffEarliestDateTime > taxDueDate ||
        dropoffLatestDateTime > taxDueDate ||
        pickupEarliestDateTime > taxDueDate ||
        pickupLatestDateTime > taxDueDate) &&
      (dropoffEarliestDateTime > motExpiryDate ||
        dropoffLatestDateTime > motExpiryDate ||
        pickupEarliestDateTime > motExpiryDate ||
        pickupLatestDateTime > motExpiryDate)
    ) {
      errors.push('Date must be before TAX&MOT expiry date');
    }

    return errors;
  }

  AllTaxMotValid(): boolean {
    let result = true;
    //console.log("AllTaxMotValid");
    //console.log(this.newJobs);

    this.newJobs.forEach((order) => {
      order.tasks.forEach((task) => {
        if (this.editTask && this.editTask == task) {
          result = result && this.ValidateTaxMot(this.task).length == 0;
        } else {
          result = result && this.ValidateTaxMot(task).length == 0;
        }
      });
    });

    return result;
  }

  AllOrderValid(): boolean {
    let result = true;
    //console.log("ALL ORDER VALID");
    //console.log(this.newJobs);
    let hasFurtherInformationProvided = false;
    this.newJobs.forEach((order) => {
      order.tasks.forEach((task) => {
        if (this.editTask && this.editTask == task) {
          result = result && this.ValidateTask(this.task).length == 0;
        } else {
          result = result && this.ValidateTask(task).length == 0;
        }
        if (task.furtherInformation) {
          if (
            this.userOrgLevel &&
            task.furtherInformation.customerDepartmentId &&
            task.furtherInformation.customerTeamId
          ) {
            hasFurtherInformationProvided = true;
          }

          if (this.isJobTaggingEnforced && !task.furtherInformation.orderTags) {
            return false;
          }
        }
      });
    });

    if (this.isJobTaggingEnforced && !this.task.furtherInformation.orderTags?.length) {
      return false;
    }

    if (this.task.furtherInformation && !hasFurtherInformationProvided) {
      if (this.userOrgLevel && !this.task.furtherInformation.customerDepartmentId) {
        //console.log('** INVALID : further info 1');
        return false;
      }

      if (this.userOrgLevel && !this.task.furtherInformation.customerTeamId) {
        //console.log('** INVALID: further info 2');
        return false;
      }
    }

    //console.log("AllOrderValid: ", result);
    return result;
  }

  ValidateStep(stepIndex: number): boolean {
    //console.log("Validating step: ", stepIndex);

    switch (stepIndex) {
      case 0:
        const isValid: boolean = Boolean(
          this.agreementAgreed &&
            this.vehicle &&
            this.vehicle.registrationNumber?.trim() !== '' &&
            this.vehicle.kerbWeight >= vehicleKerbWeight.minimum &&
            this.vehicle.kerbWeight <= vehicleKerbWeight.maximum &&
            !!this.vehicle.fuelType &&
            (!this.vehicleDetailForm || this.vehicleDetailForm.valid) &&
            this.task.furtherInformation.customerDepartmentId &&
            this.task.furtherInformation.customerTeamId &&
            (this.isPlated ||
              this.isCustomerInsured ||
              this.isDriverInsured ||
              this.isEngineiusGo ||
              this.isMoreEquipmentNeeded ||
              this.isTurnaround ||
              this.isPrestige ||
              this.isUncovered ||
              this.isCovered ||
              this.isInspection ||
              this.isRecoveryStandard ||
              this.isPrestigeTransported ||
              this.isDrivenInsuredInspection ||
              this.isDrivenPlatedInspection),
        );

        return isValid;
      case 1:
        const checklistRequired = this.specificStepGroups && this.specificStepGroups.length >= 1;

        const isValid1: boolean = Boolean(
          this.pickupLocation != null &&
            this.dropoffLocation != null &&
            !this.isSearchPickup &&
            !this.isSearchDropoff &&
            this.locationsform.valid &&
            (!checklistRequired || (this.task?.checklistId && this.task.checklistId > 0)) &&
            this.isInspectionContactValid(),
        );

        return isValid1;
      default:
        return false;
    }
  }

  GetDistance(lat1: number, lng1: number, lat2: number, lng2: number, miles: boolean) {
    if (!miles) {
      miles = true;
    }

    let pi80 = Math.PI / 180;
    lat1 *= pi80;
    lng1 *= pi80;
    lat2 *= pi80;
    lng2 *= pi80;

    let r = 6372.797; // mean radius of Earth in km
    let dlat = lat2 - lat1;
    let dlng = lng2 - lng1;
    let a =
      Math.sin(dlat / 2) * Math.sin(dlat / 2) +
      Math.cos(lat1) * Math.cos(lat2) * Math.sin(dlng / 2) * Math.sin(dlng / 2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    let km = r * c;

    return miles ? km * 0.621371192 : km;
  }

  objectComparer(x, y) {
    if (x === y) return true;
    // if both x and y are null or undefined and exactly the same

    if (!(x instanceof Object) || !(y instanceof Object)) return false;
    // if they are not strictly equal, they both need to be Objects

    if (x.constructor !== y.constructor) return false;
    // they must have the exact same prototype chain, the closest we can do is
    // test there constructor.

    for (let p in x) {
      if (!x.hasOwnProperty(p)) continue;
      // other properties were tested using x.constructor === y.constructor

      if (!y.hasOwnProperty(p)) return false;
      // allows to compare x[ p ] and y[ p ] when set to undefined

      if (x[p] === y[p]) continue;
      // if they have the same strict value or identity then they are equal

      if (typeof x[p] !== 'object') return false;
      // Numbers, Strings, Functions, Booleans must be strictly equal

      if (!this.objectComparer(x[p], y[p])) return false;
      // Objects and Arrays must be tested recursively
    }

    for (let p in y) {
      if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) return false;
      // allows x[ p ] to be set to undefined
    }
    return true;
  }

  //UpdateSelectedJobButtons() {
  //    this.jobs = [];
  //    for (var i = 0; i < this.newJobs.length; i++) {
  //        this.jobs.push({ label: 'Job ' + (i + 1), value: this.newJobs[i] });
  //    }

  //    if (this.newJobs.length > 0) {
  //        this.selectedJob = this.newJobs[0];
  //    }
  //}

  //@Output() selectedJobChange: EventEmitter<IJobInfo>;
  //public _selectedJob: IJobInfo = null;
  //@Input('selectedJob')
  //public set selectedJob(value: IJobInfo) {
  //    this._selectedJob = value;
  //    if (value) {
  //        this.tasks = [];
  //        for (var i = 0; i < value.tasks.length; i++) {
  //            this.tasks.push({ label: 'Task ' + (i+1), value: value.tasks[i] });
  //        }
  //        if (value.tasks.length > 0) {
  //            this.selectedTask = value.tasks[0];
  //        }
  //    }
  //    this.selectedJobChange.emit(value);
  //}
  //public get selectedJob(): IJobInfo {
  //    return this._selectedJob;
  //}

  //jobs: SelectItem[];

  //tasks: SelectItem[];

  private _selectedNewJob: IOrderInfo;
  public set selectedNewJob(value: IOrderInfo) {
    this._selectedNewJob = value;
    if (this._selectedNewJob) {
      //this.jobTasks = [];
      //this._selectedNewJob.tasks.forEach(item => this.jobTasks.push({ label: item.vehicle.registrationNumber, value: item }));
      //this.selectedTask = this._selectedNewJob.tasks[0];
      //this.UpdateRouteInfo();
      this.refreshJobTasks();
    }
  }

  public get selectedNewJob(): IOrderInfo {
    return this._selectedNewJob;
  }

  selectedTask: ITaskInfo;
  orderSummarySelectedTask: ITaskInfo;
  //selectedNewJob: IJobInfo;
  newJobsSelectItems: SelectItem[];
  jobTasks: SelectItem[];
  routeInfo: any = { distanceMiles: null, time: null };

  //onJobChange(event) {
  //    this.selectedNewJob = event.value;
  //    this.refreshJobTasks();
  //}

  //onTaskChange(event) {
  //    this.selectedTask = event.value;
  //    this.UpdateRouteInfo();
  //}

  refreshJobTasks() {
    this.jobTasks = [];
    if (this.selectedNewJob) {
      this._selectedNewJob.tasks.forEach((item) =>
        this.jobTasks.push({
          label: item.vehicle.registrationNumber,
          value: item,
        }),
      );
      this.selectedTask = this._selectedNewJob.tasks[0];
      this.UpdateRouteInfo();
    }
  }

  fillNewJobsSelectItems() {
    this.newJobsSelectItems = [];
    this.newJobs.forEach((item) =>
      this.newJobsSelectItems.push({
        label: 'Order ' + (this.newJobs.indexOf(item) + 1),
        value: item,
      }),
    );
    this.selectedNewJob = this.newJobs[0];
    //this.refreshJobTasks();
  }

  UpdateRouteInfo() {
    this.routeInfo = { distanceMiles: null, time: null };

    if (
      !this.selectedTask ||
      !this.selectedTask.pickupLocation ||
      !this.selectedTask.dropoffLocation
    ) {
      return;
    }

    let origin = [];

    if (this.selectedTask.pickupLocation.latitude) {
      origin.push(this.selectedTask.pickupLocation.latitude);
    }

    if (this.selectedTask.pickupLocation.longitude) {
      origin.push(this.selectedTask.pickupLocation.longitude);
    }

    let destination = [];

    if (this.selectedTask.dropoffLocation.latitude) {
      destination.push(this.selectedTask.dropoffLocation.latitude);
    }

    if (this.selectedTask.dropoffLocation.longitude) {
      destination.push(this.selectedTask.dropoffLocation.longitude);
    }

    const dto = this.mapService.GetRouteDTO(
      this.selectedTask.pickupLocation,
      this.selectedTask.dropoffLocation,
      this.pickupEarliestDateTime,
    );
    this.mapService.GetRoute(dto).then((route) => {
      if (route != null) {
        this.routeInfo = {
          distanceMiles: this.mapService.getMiles(route.distance),
          time: this.mapService.getDateTime(route.duration),
        };
      }
    });
  }

  getTaskType() {
    switch (this.selectedTask.taskTypeId) {
      case null:
      case undefined:
        return '';
      case TaskType.DrivenPlated:
      case TaskType.DrivenUninsured:
      case TaskType.DriverInsured:
      case TaskType.DrivenPrestige:
      case TaskType.DrivenEngineiusGo:
      case TaskType.DrivenTurnaround:
        return 'Driven';
      case TaskType.UncoveredTransportedMovement:
      case TaskType.CoveredTransportedMovement:
        return 'Transported';
      case TaskType.RecoveredSkates:
      case TaskType.RecoveredFullLiftOnly:
      case TaskType.RecoveredMoreEquipmentNeeded:
      case TaskType.RecoveryStandard:
        return 'Recovered';
      case TaskType.Inspection:
        return 'Inspection';
      case TaskType.DrivenInsuredInspection:
      case TaskType.DrivenPlatedInspection:
        return 'Inspect & Collect';
      default:
        return '';
    }
  }

  isCanCancel(Step) {
    // https://ptsa.bbconsult.co.uk/issueEditor?type=2&id=158788
    // this.activeStepIndex = Step
    //console.log("Step: " + Step)

    if ((Step == 0 && this.extraOptionSelected) || Step != 0) {
      return true;
    } else {
      return false;
    }
  }

  isPriceButtonDisplay() {
    let tasksCount = 0;
    if (this.task && this.editTask == null) tasksCount++;

    this.newJobs.forEach((order) => {
      order.tasks.forEach((task) => {
        if (this.task != task) {
          tasksCount++;
        }
      });
    });

    if (tasksCount <= 1) return true;
    return false;
  }

  CalculatePrice() {
    let tempTask = Object.assign({}, this.task);

    console.log('TT ', tempTask);

    tempTask.pickupEarliestDateTime = moment(tempTask.pickupEarliestDateTime).format(
      'YYYY-MM-DD HH:mm',
    );
    tempTask.pickupLatestDateTime = moment(tempTask.pickupLatestDateTime).format(
      'YYYY-MM-DD HH:mm',
    );
    tempTask.dropoffEarliestDateTime = moment(tempTask.dropoffEarliestDateTime).format(
      'YYYY-MM-DD HH:mm',
    );
    tempTask.dropoffLatestDateTime = moment(tempTask.dropoffLatestDateTime).format(
      'YYYY-MM-DD HH:mm',
    );

    // Do not show warning if user copying order
    if (!this.isCopy) {
      this.taskService.checkIfTaskExists(tempTask).then((res) => {
        if (res) {
          this.messageService.clear();
          this.messageService.add(
            Message.Warning('The same order already exists in database', 'Warning'),
          );
          return;
        }
      });
    }

    this.calculatedPrice = null;
    this.pricelog = null;
    this.originalOrders = Object.assign([], this.newJobs);
    this.originalTask = Object.assign({}, this.task);

    if (this.createMovementJobStep != CreateMovementJobSteps.JobPreview) {
      if (this.editTask) {
        this.updateExistingTaskFromEditTask();
      } else {
        this.SaveDetails();
      }
    }

    this.newJobs.forEach((order) => {
      let tempOrder = JSON.parse(JSON.stringify(order)); //Object.assign({}, order);

      tempOrder.tasks.forEach((t) => {
        t.pickupEarliestDateTime = moment(t.pickupEarliestDateTime).format('YYYY-MM-DD HH:mm');
        t.pickupLatestDateTime = moment(t.pickupLatestDateTime).format('YYYY-MM-DD HH:mm');
        t.dropoffEarliestDateTime = moment(t.dropoffEarliestDateTime).format('YYYY-MM-DD HH:mm');
        t.dropoffLatestDateTime = moment(t.dropoffLatestDateTime).format('YYYY-MM-DD HH:mm');
      });

      this.orderService.getCustomerPrice(tempOrder).then((data) => {
        order.customerPriceMin = data.value * this.systemSettings.priceCalculation_Lowest;
        order.customerPriceMax = data.value * this.systemSettings.priceCalculation_Highest;
        order.includedMilesFixed = data.includedMilesFixed;
        order.isGuranteeFulfilment = data.isGuranteeFulfilment;
        order.quoteId = data.quoteId;
        order.isFixPrice = data.isFixPrice;
        order.customerPrice = data.value;
        order.inspectionCharge = data.inspectionCharge;
        this.calculatedPrice = data;

        console.log('CAP ', data);
      });
    });
    this.createOrderAnalyticsService.sendEvent(
      this.getAnalyticsCreateOrderObject(AnalyticsOrderEvent.order_price_summary_view),
    );
    this.displayCalculatePrice = true;
  }

  private ConvertStringToDateForTask(task: ITaskInfo) {
    task.pickupEarliestDateTime = moment(task.pickupEarliestDateTime).toDate();
    task.pickupLatestDateTime = moment(task.pickupLatestDateTime).toDate();
    task.dropoffEarliestDateTime = moment(task.dropoffEarliestDateTime).toDate();
    task.dropoffLatestDateTime = moment(task.dropoffLatestDateTime).toDate();
  }

  isExistNotGuranteed(newJobs: IOrderInfo[]) {
    if (!newJobs) {
      return false;
    }

    let result = true;

    newJobs.forEach((x) => {
      result = result && x.isGuranteeFulfilment;
    });

    return !result;
  }

  ReviewOrders() {
    this.isFirstAction = false;
    this.SaveDetails();
    this.updateTaskSequencingFlagForTasksInJob();
    this.createMovementJobStep = CreateMovementJobSteps.JobPreview;
    this.createOrderAnalyticsService.sendEvent(
      this.getAnalyticsCreateOrderObject(AnalyticsOrderEvent.order_list_summary_view),
    );
  }

  SubmitOrders() {
    this.displayCalculatePrice = false;
    this.SaveAllJob();
  }

  CancelSubmitOrders() {
    this.displayCalculatePrice = false;
    this.createOrderAnalyticsService.sendEvent(
      this.getAnalyticsCreateOrderObject(AnalyticsOrderEvent.order_price_summary_exit),
    );
    this.newJobs = this.originalOrders;
    this.task = this.originalTask;
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (this.displayCalculatePrice) {
      this.CancelSubmitOrders();
    }
  }

  pricelog: any[];

  getPriceLog(order) {
    this.orderService.getOrderPriceLog(order).then((result) => {
      this.pricelog = result;
      setTimeout(() => window.dispatchEvent(new Event('resize')), 100);
    });
  }

  onKeyDownOrderPriceIndex: any = null;

  PriceDebugKey: string = 'getdebug';
  inputPriceDebugKey: string = '';

  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    this.inputPriceDebugKey += event.key;
    if (!this.PriceDebugKey.startsWith(this.inputPriceDebugKey)) {
      this.inputPriceDebugKey = event.key;
      if (!this.PriceDebugKey.startsWith(event.key)) {
        this.inputPriceDebugKey = '';
      }
    }

    if (
      this.PriceDebugKey == this.inputPriceDebugKey &&
      (this.isVmeUser || this.isUserImpersonate)
    ) {
      this.isDebug = !this.isDebug;
    }
  }

  orderSummarySelectTask(event) {
    this.orderSummarySelectedTask = event;
  }

  calendarselect(e) {
    if (e != undefined) {
      this.roundUpTime(e);
    }
  }

  getShortAddress(address: IVehicleAddress): string {
    if (!address) {
      return '';
    }

    if (address.city) {
      return address.city;
    }

    if (address.postcode) {
      return address.postcode;
    }

    if (address.primaryAddress && address.primaryAddress.length < 10) {
      return address.primaryAddress;
    } else if (address.primaryAddress && address.primaryAddress.length >= 10) {
      return address.primaryAddress.substring(0, 10);
    } else {
      return '';
    }
  }

  // for more details look at ReadOnlyMode enum in map-contro.ts
  getReadOnlyMode() {
    if (this.isReturnJourney) return 1; // both pickup and dropoff disabled
    else if (this.isFollowOnJourney) return 2; // disabled only pickup
    else return 0;
  }

  public isShowSite: boolean = false;
  public isShowMoDelDialog: boolean = false;
  public isShowMoDelContainerError: boolean = false;
  public isPickupDlg: boolean = false;
  public showContactNumberDialog: boolean = false;

  public showSuggestedPickUpLocationDialog: boolean = false;
  public suggestedPickUpLocationFromVehiclePreviousDropOff: IVehicleLastDropOffAddress;

  openSite(isPickup: boolean) {
    this.isPickupDlg = isPickup;
    this.isShowSite = true;
  }

  selectSite(item, isPickup: boolean) {
    let siteItem: ICustomerSites = item;

    //console.log(siteItem.siteName);
    if (isPickup) {
      this.pickupLocation = this.convertSiteToVehicleAddress(siteItem);

      this.pickupNotes = siteItem.pickupNotes;

      this.pickupEmail = siteItem.pickupEmail;
      this.pickupForename = siteItem.pickupForename;
      this.pickupSurname = siteItem.pickupSurname;
      this.pickupPhone1 = siteItem.pickupPhone1;
      this.pickupPhone2 = siteItem.pickupPhone2;
      this.pickupNotification = siteItem.pickupNotification;

      this.locationsform.patchValue({
        pickupEmail: this.pickupEmail,
        pickupForename: this.pickupForename,
        pickupSurname: this.pickupSurname,
        pickupPhone1: this.pickupPhone1,
        pickupPhone2: this.pickupPhone2,
        pickupNotification: this.pickupNotification,
      });

      this.task.releaseCode = siteItem.releaseCode;
      this.siteOpeningHoursService.patchForm(this.pickupSiteHoursFormGroup, siteItem.openingHours);
      this.disableAddressSearchPickupFields = true;
      this.pickupAddressMatchedSite = null;
      this.suggestedCustomerDropOffLocations = [];
    } else {
      this.dropoffLocation = this.convertSiteToVehicleAddress(siteItem);
      this.dropoffNotes = siteItem.dropoffNotes;

      this.dropoffEmail = siteItem.dropoffEmail;
      this.dropoffForename = siteItem.dropoffForename;
      this.dropoffSurname = siteItem.dropoffSurname;
      this.dropoffPhone1 = siteItem.dropoffPhone1;
      this.dropoffPhone2 = siteItem.dropoffPhone2;
      this.dropoffNotification = siteItem.dropoffNotification;

      this.locationsform.patchValue({
        dropoffEmail: this.dropoffEmail,
        dropoffForename: this.dropoffForename,
        dropoffSurname: this.dropoffSurname,
        dropoffPhone1: this.dropoffPhone1,
        dropoffPhone2: this.dropoffPhone2,
        dropoffNotification: this.dropoffNotification,
      });

      this.siteOpeningHoursService.patchForm(this.dropOffSiteHoursFormGroup, siteItem.openingHours);
      this.task.vehicleLifeCycleSiteId = siteItem.id;
      this.disableAddressSearchDropoffFields = true;
      this.dropoffAddressMatchedSite = null;
    }

    this.isShowSite = false;
  }

  convertSiteToVehicleAddress(site: ICustomerSites): IVehicleAddress {
    let primaryAddressComponents: Array<keyof ICustomerSites> = [
      'address1',
      'address2',
      'address3',
      'city',
      'postcode',
    ];
    return {
      id: 0,
      businessName: site.businessName,
      primaryAddress: primaryAddressComponents
        .filter((x) => site[x] != null && site[x] != '')
        .map((x) => site[x])
        .join(', '),
      secondary: '',
      postcode: site.postcode,
      city: site.city,
      country: '',
      latitude: site.latitude,
      longitude: site.longitude,
      route: '',
      postal_town: site.city,
      addressLine1: site.address1,
      what3Words: site.what3Words,
    };
  }

  disabledPickupEarliest() {
    if (!this.systemSettings.autoCalculateOrderDates) return false;

    if (!this.pickupEarliestDateTime || this.isFollowOnJourney) return true;

    return false;
  }

  disabledPickupLatest() {
    if (!this.systemSettings.autoCalculateOrderDates) return false;

    if (!this.pickupLatestDateTime || this.isFollowOnJourney) return true;

    return false;
  }

  disabledDropoffEarliest() {
    if (!this.systemSettings.autoCalculateOrderDates) return false;

    if (!this.dropoffEarliestDateTime) return true;

    return false;
  }

  disabledDropoffLatest() {
    if (!this.systemSettings.autoCalculateOrderDates) return false;

    if (!this.dropoffLatestDateTime) return true;

    return false;
  }

  clearFilter(dt: Table) {
    dt.sortField = '';
    dt.rows = 10;
    this.initDefaultFilter();
    this.filter.next(this.filterVal);
  }

  search() {
    this.filterVal.first = 0; //fix error - when you set page > 1 and filter, then data not display
    console.log('???????????????????');
    console.log(this.filterVal);
    this.filter.next(this.filterVal);
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    // map grid lazy load event to filter
    //var eventString = JSON.stringify(event);
    //if (eventString === this.filterString) return;
    //console.log(event);
    //this.filter.next(flatten(event));

    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filterVal.sortField = event.sortField;
    this.filterVal.sortOrder = event.sortOrder;

    this.filter.next(this.filterVal);
  }

  motWarningType: MotWarningType;
  motWarningTypeEnum = MotWarningType;

  public async onTaskTypeChange(event, motType: MotWarningType) {
    if (!this.isMotValid && event.checked) {
      this.motWarningType = motType;
      this.isShowMotWarning = true;
    }

    this.getMappedChecklists(this._taskType);
    await this.getTaskStepsForTaskType(this._taskType);
  }

  /**
   *
   * @param taskType
   */
  getTaskStepsForTaskType(taskType): Promise<any> {
    console.log('Getting TaskSteps for TaskType ', taskType, ' Checklist ', this.selectedGroupId);

    return this.taskTypeService.getTaskTypeSteps(taskType).then((result) => {
      this.selectedTaskTypeSteps = result;

      console.log('Received TaskSteps for TaskType ', this.selectedTaskTypeSteps);

      if (this.selectedGroupId) {
        console.log('GetTaskStepsForTaskType');
        return this.refreshMappedChecklistSteps(this.selectedGroupId, taskType, 'GTSFTT').then(
          () => {
            this.setSelectedChecklistForTaskType(taskType);
          },
        );
      } else {
        return this.setSelectedChecklistForTaskType(taskType);
      }
    });
  }

  public motWarningContinue() {
    if (this.motWarningType == MotWarningType.DrivenPlated) this.isPlated = true;
    else if (this.motWarningType == MotWarningType.DriverInsured) this.isDriverInsured = true;
    else if (this.motWarningType == MotWarningType.EngineiusGo) this.isEngineiusGo = true;
    else if (this.motWarningType == MotWarningType.Turnaround) this.isTurnaround = true;
    else if (this.motWarningType == MotWarningType.CustomerInsured) this.isCustomerInsured = true;
    else if (this.motWarningType == MotWarningType.DrivenPrestige) this.isPrestige = true;
    else if (this.motWarningType == MotWarningType.PickupDropoffDates) {
      this.taxMotDatesConfirm = true;
      this.NextStep();
    } else if (this.motWarningType == MotWarningType.TransportedCovered) this.isCovered = true;
    else if (this.motWarningType == MotWarningType.TransportedUncovered) this.isUncovered = true;
    else if (this.motWarningType == MotWarningType.PrestigeTransported)
      this.isPrestigeTransported = true;
    else if (this.motWarningType == MotWarningType.RecoveryStandard) this.isRecoveryStandard = true;
    else if (this.motWarningType == MotWarningType.DrivenInsuredInspection)
      this.isDrivenInsuredInspection = true;
    else if (this.motWarningType == MotWarningType.DrivenPlatedInspection)
      this.isDrivenPlatedInspection = true;

    this.isShowMotWarning = false;
  }

  public motWarningCancel() {
    if (this.motWarningType == MotWarningType.DrivenPlated) this.isPlated = false;
    else if (this.motWarningType == MotWarningType.DriverInsured) this.isDriverInsured = false;
    else if (this.motWarningType == MotWarningType.EngineiusGo) this.isEngineiusGo = false;
    else if (this.motWarningType == MotWarningType.Turnaround) this.isTurnaround = false;
    else if (this.motWarningType == MotWarningType.CustomerInsured) this.isCustomerInsured = false;
    else if (this.motWarningType == MotWarningType.DrivenPrestige) this.isPrestige = false;
    else if (this.motWarningType == MotWarningType.RecoveryStandard)
      this.isRecoveryStandard = false;
    else if (this.motWarningType == MotWarningType.TransportedCovered) this.isCovered = false;
    else if (this.motWarningType == MotWarningType.TransportedUncovered) this.isUncovered = false;
    else if (this.motWarningType == MotWarningType.PrestigeTransported)
      this.isPrestigeTransported = false;
    else if (this.motWarningType == MotWarningType.PickupDropoffDates)
      this.taxMotDatesConfirm = false;
    else if (this.motWarningType == MotWarningType.DrivenInsuredInspection)
      this.isDrivenInsuredInspection = false;
    else if (this.motWarningType == MotWarningType.DrivenPlatedInspection)
      this.isDrivenPlatedInspection = false;
    else if (this.motWarningType == MotWarningType.VehicleOrMotChange) {
      this.isPlated = false;
      this.isCustomerInsured = false;
      this.isDriverInsured = false;
      this.isEngineiusGo = false;
      this.isPrestige = false;
      this.isTurnaround = false;
      this.isCovered = false;
      this.isUncovered = false;
      this.isPrestigeTransported = false;
      this.isRecoveryStandard = false;
      this.isDrivenInsuredInspection = false;
      this.isDrivenPlatedInspection = false;
    }

    this.isShowMotWarning = false;
  }

  public onTaxChanged(event) {
    console.log('onTaxChanged');
    console.log(this.isTaxValid);

    if (!this.isTaxValid) {
      this.isDriverInsured = false;
      this.isEngineiusGo = false;
      this.isTurnaround = false;
      this.isCustomerInsured = false;
      this.isPrestige = false;
      this.isDrivenInsuredInspection = false;
      this.vehicle.taxStatus = null;
      this.vehicle.isTaxValid = false;
    } else {
      this.vehicle.isTaxValid = true;
      this.vehicle.taxStatus = 'Taxed';
    }

    this.vehicle = this.vehicle;
  }

  public onMotChanged(event) {
    console.log('onMotChanged');
    console.log(this.isMotValid);

    this.chekhMovementTypeOnMotChanged();
  }

  private chekhMovementTypeOnMotChanged() {
    if (
      !this.isMotValid &&
      (this.isPlated ||
        this.isCustomerInsured ||
        this.isDriverInsured ||
        this.isPrestige ||
        this.isEngineiusGo ||
        this.isTurnaround ||
        this.isCovered ||
        this.isUncovered ||
        this.isMoreEquipmentNeeded ||
        this.isPrestigeTransported ||
        this.isRecoveryStandard ||
        this.isDrivenInsuredInspection ||
        this.isDrivenPlatedInspection)
    ) {
      this.motWarningType = MotWarningType.VehicleOrMotChange;
      this.isShowMotWarning = true;
    }
  }

  public taxMotPickupEarliestError: string;
  public taxMotPickupLatestError: string;
  public taxMotDropoffEarliestError: string;
  public taxMotDropoffLatestError: string;

  public pickupPhone1Error: string;
  public pickupPhone2Error: string;
  public dropoffPhone1Error: string;
  public dropoffPhone2Error: string;

  public taxMotDatesConfirm: boolean = false;

  updateExistingTaskFromEditTask() {
    let currentTask = this.task;

    if (this.editTask) {
      for (let i = 0; i < this.newJobs.length; i++) {
        for (let j = 0; j < this.newJobs[i].tasks.length; j++) {
          if (this.editTask == this.newJobs[i].tasks[j]) {
            // edit task finded
            this.newJobs[i].tasks[j] = currentTask;

            this.newJobs[i].accountCodeListId = currentTask.furtherInformation.accountCode;
            this.newJobs[i].purchaseOrderNo = currentTask.furtherInformation.purchaseOrderNo;

            this.newJobs[i].customerDepartmentId =
              currentTask.furtherInformation.customerDepartmentId;
            this.newJobs[i].customerTeamId = currentTask.furtherInformation.customerTeamId;
          }
        }
      }
    }
  }

  /**
   * Here's where we get mapped checklists.
   * todo: Doesn't currently account for legacy checklists
   * @param taskTypeId The Task Type ID Selected
   */
  async getMappedChecklists(
    taskTypeId?: number,
    copyOrder?: boolean,
    checklistId?: number,
  ): Promise<any> {
    this.logger.debug(`getMappedChecklists(${taskTypeId})`);
    if (taskTypeId == null) {
      this.logger.error('Cannot retrieve checklist yet, no task type');
      console.log('COULD NOT RETRIEVE CHECKLIST list. TaskType: ', taskTypeId);
      return null;
    }

    if (!this.task.furtherInformation.customerDepartmentId) {
      this.logger.error('Cannot retrieve checklist yet, no department selected');
      return null;
    }

    const result = await this.organisationSpecificStepsService.getMappedChecklists(
      this.task.furtherInformation.customerDepartmentId,
      taskTypeId,
      true,
    );

    this.checklistMappingList = result;
    console.log('CHECKISTS: ', this.checklistMappingList);

    // Update the checklist dropdown list
    await this.setSelectedChecklistForTaskType(taskTypeId);

    this.logger.debug('result from getmappedchecklist', result);

    if (!get(result, 'length')) {
      this.logger.debug('No mapped, checklists, nothing we can do?');
      return;
    }

    if (!this.selectedGroupId && this.selectedGroupId !== 0) {
      if (result.length === 1) {
        const checklist = result[0];
        this.logger.debug('Only one Checklist returned - automatically selecting it', checklist);
        this.selectedGroupId = checklist.organisationSpecificStepGroupId;
        this.task.checklistId = this.selectedGroupId;
      } else {
        this.logger.debug('No checklist returned');
      }
    }
    // if copyOrder true and checklist id exists
    if (copyOrder && checklistId) {
      this.selectedGroupId = checklistId;
      this.task.checklistId = checklistId;
    }

    this.logger.debug('Refreshing');
    await this.refreshMappedChecklistSteps(this.selectedGroupId, taskTypeId, 'GMCL');
    this.logger.debug('Refreshed');
    this.logger.debug(`getMappedChecklists(${taskTypeId}) complete`);
  }

  setSelectedChecklistForTaskType(taskTypeId: number) {
    this.specificStepGroups = [];

    if (this.checklistMappingList) {
      this.checklistMappingList.forEach((x) => {
        if (x.taskTypeId === taskTypeId)
          this.specificStepGroups.push({
            label: x.organisationSpecificStepGroup.groupName,
            value: x.organisationSpecificStepGroupId,
          });
      });
    }

    console.log('Specific steps groups: ', this.specificStepGroups);
  }

  checklistChanged(checklistId, taskType) {
    this.task.checklistId = checklistId;
    this.showAllDropOffSteps = false;
    this.showAllPickupSteps = false;

    console.log('Checklist Changed');
    this.refreshMappedChecklistSteps(checklistId, taskType, 'CLC').then(() => {});
  }

  async refreshMappedChecklistSteps(checklistId: number, taskTypeId: number, source: string) {
    this.logger.debug(`refreshMappedChecklistSteps(${checklistId}, ${taskTypeId}, ${source})`);
    this.pickupSpecificSteps = [];
    this.dropoffSpecificSteps = [];

    // If missing task type or checklist we can't populate the specific steps yet.
    if (!checklistId || !taskTypeId) {
      this.logger.debug('task type or checklist not selected');
      this.selectedChecklistTaskType = null;
      return await this.buildWorkflowForChecklist();
    }

    // Otherwise, we get the checklist mapping
    const result = await this.organisationSpecificStepsService.getChecklistTaskTypeStepDetail(
      checklistId,
      taskTypeId,
      true,
    );

    this.selectedChecklistTaskType = result;

    // Build a list of checklist names
    this.setSelectedChecklistForTaskType(taskTypeId);

    // If the checklist mapping has step mappings we use the populate method?
    if (get(result, 'stepsTaskTypeDetails.length')) {
      this.logger.debug('result found with steps in getChecklistTaskTypeStepDetail', result);
      return await this.populateSpecificSteps(result.stepsTaskTypeDetails);
    }

    // If the checklist mapping has no steps then look for legacy steps
    if (this.selectedGroupId) {
      this.defaultChecklistSteps = await this.organisationSpecificStepsService.getChecklistSteps(
        this.selectedGroupId,
      );
      if (this.defaultChecklistSteps) {
        // If there's a checklist mapping but no steps (legacy)
        this.logger.debug('result found without steps in getChecklistTaskTypeStepDetail', result);
        return await this.populateSpecificSteps(this.defaultChecklistSteps);
      }
    }

    // Final catch-all is to go ahead and build the workflow
    this.logger.debug('result not found in getChecklistTaskTypeStepDetail');
    return await this.buildWorkflowForChecklist();
  }

  async populateSpecificSteps(steps: any[]) {
    // Required because of casing issue!
    const normalized: any[] = steps.map((step) => ({
      ...step,
      isPickUp: step.IsPickUp || step.isPickUp,
    }));

    this.pickupSpecificSteps = normalized.filter((step) => step.isPickUp);
    this.dropoffSpecificSteps = normalized.filter((step) => !step.isPickUp);
    // todo: not really sure why we cast to string here only to parse int later on.
    const selectedPickupSteps = this.pickupSpecificSteps.map((step) => `${step.id}`);
    const selectedDropoffSteps = this.dropoffSpecificSteps.map((step) => `${step.id}`);
    this.selectedPickupSpecificSteps = selectedPickupSteps;
    this.selectedDropoffSpecificSteps = selectedDropoffSteps;

    await this.buildWorkflowForChecklist();
  }

  async buildWorkflowForChecklist() {
    this.logger.debug('buildWorkflowForChecklist()');
    this.logger.debug('selectedGroupId:', this.selectedGroupId);
    this.logger.debug('selectedTaskTypeSteps:', this.selectedTaskTypeSteps);
    this.logger.debug('taskType:', this._taskType);

    if (!((this.selectedGroupId || this.selectedTaskTypeSteps) && this._taskType)) {
      return;
    }

    if (this.selectedGroupId) {
      const defaultChecklistSteps = await this.organisationSpecificStepsService.getChecklistSteps(
        this.selectedGroupId,
      );
      // Store here for if/when we select them
      this.defaultChecklistSteps = defaultChecklistSteps;

      let mappedTaskSteps = this.organisationSpecificStepsService.buildTaskStepsChecklistStepList(
        this.selectedTaskTypeSteps,
        this.selectedChecklistTaskType,
        defaultChecklistSteps,
      );

      if (this.pickupCustomActions || this.dropoffCustomActions) {
        const checklistSteps = [...this.pickupCustomActions, ...this.dropoffCustomActions];
        mappedTaskSteps = this.organisationSpecificStepsService.sortStepsWithEnhancedChecklistSteps(
          mappedTaskSteps,
          checklistSteps,
        );
      }
      if (mappedTaskSteps) {
        this.workflow = <IMovementTaskStep>{
          pickupSteps: mappedTaskSteps.filter((x) => x.isPickUp),
          dropoffSteps: mappedTaskSteps.filter((x) => !x.isPickUp),
        };
      }
    }
  }

  handleShowDetails(pickupSpecificStep: IGenericTaskStepDetail) {
    pickupSpecificStep.showDetails = !pickupSpecificStep.showDetails;
  }

  handleMouseEnter = (ev: Event, data: IGenericTaskStepDetail) => (data.showControls = true);
  handleMouseLeave = (ev: Event, data: IGenericTaskStepDetail) => (data.showControls = true);

  handleAdditionalRequirementClick = (data: IGenericTaskStepDetail) => {
    this.isShowAdditionalStepForm = true;
    this.buildCustomActionStepForm(<ICustomTaskAction>{
      id: this.customActionId,
      allowPhotos: false,
      allowComments: false,
      name: '',
      isPickUp: data.isPickUp,
      parentEngineiusStepId: data.isEngineiusStep ? data.id : null,
      parentEngineiusStepName: data.name,
    }); // ToDo: should we be placing this between org specific steps?
  };

  buildCustomActionStepForm(data: ICustomTaskAction) {
    // build for drop off, note id changes
    this.addCustomStepForm = this.fb.group({
      id: new UntypedFormControl(data.id || 0, null),
      name: new UntypedFormControl(data.name, null),
      isPickUp: new UntypedFormControl(data.isPickUp, Validators.compose([Validators.required])),
      allowPhotos: new UntypedFormControl(data.allowPhotos, null),
      allowComments: new UntypedFormControl(data.allowPhotos, null),
      parentEngineiusStepId: data.parentEngineiusStepId,
      isEngineiusStep: false,
      isCustomStep: true,
      parentEngineiusStepName: data.parentEngineiusStepName,
    });
  }

  pickupDateTimeWindowChanged(event: any) {
    this.pickupEarliestDateTime = event[0];
    this.pickupLatestDateTime = event[1];

    //console.log("Pickup date times set to: ", event);
  }

  dropoffDateTimeWindowChanged(event: any) {
    this.dropoffEarliestDateTime = event[0];
    this.dropoffLatestDateTime = event[1];

    //console.log("Dropoff date times set to: ", event);
  }

  @ViewChild('pickupSiteHoursForm') pickupSiteHoursForm: OverlayPanel;
  @ViewChild('dropOffSiteHoursForm') dropOffSiteHoursForm: OverlayPanel;
  contactNumberDialogHeader: string;

  closePickupSiteHoursForm() {
    this.pickupSiteHoursForm.hide();
  }

  closeDropOffSiteHoursForm() {
    this.dropOffSiteHoursForm.hide();
  }

  getSuggestedCustomerDropOffLocations(): void {
    this.suggestedCustomerDropOffLocations = [];

    if (!this.autoSuggestNearestDropOffLocationsEnabled) {
      return;
    }

    this.loadingSuggestedCustomerDropOffLocations = true;
    this.csService.getSuggestedCustomerDropOffLocations(this.pickupLocation).then(
      (res) => {
        if (res) {
          this.suggestedCustomerDropOffLocations = res;
          this.autoSelectClosestSiteWithCapacity();
        }
        this.loadingSuggestedCustomerDropOffLocations = false;
      },
      () => {
        this.loadingSuggestedCustomerDropOffLocations = false;
      },
    );
  }

  selectSuggestedCustomerDropOffLocation(
    selectedSite: ICustomerSitesDistanceAndDetails,
    index: number,
    autoSelected: boolean = false,
  ): void {
    this.suggestedCustomerDropOffLocations.forEach((item, i) => {
      item.selected = i === index;
    });

    this.selectSite(selectedSite.siteDetails, false);

    const closestSiteWithCapacityIndex = this.getClosestSiteWithCapacityIndex();

    if (
      closestSiteWithCapacityIndex !== -1 &&
      closestSiteWithCapacityIndex !== index &&
      !autoSelected
    ) {
      const closestSite = this.suggestedCustomerDropOffLocations[closestSiteWithCapacityIndex];

      this.datadogRumService.addAction('vlc-select-non-closest-dropoff-site', {
        selectedSiteIndex: index,
        closestSiteWithCapacityIndex: closestSiteWithCapacityIndex,
        selectedSiteName: selectedSite.siteDetails?.siteName || 'Unknown',
        selectedSiteDistance: selectedSite.distanceMeters,
        selectedSiteMaxCapacity: selectedSite.siteDetails?.vehicleLifeCycleMaxCapacity,
        selectedSiteRefurbsOnSiteCount:
          selectedSite.siteDetails?.vehicleLifeCycleRefurbsOnSiteCount,
        closestSiteWithCapacityName: closestSite.siteDetails?.siteName || 'Unknown',
        closestSiteWithCapacityDistance: closestSite.distanceMeters,
        closestSiteWithCapacityMaxCapacity: closestSite.siteDetails?.vehicleLifeCycleMaxCapacity,
        closestSiteWithCapacityRefurbsOnSiteCount:
          closestSite.siteDetails?.vehicleLifeCycleRefurbsOnSiteCount,
        totalSuggestedSites: this.suggestedCustomerDropOffLocations.length,
        vehicleReg: this.registrationNumber,
        pickupLocation: this.pickupLocation,
      });
    }
  }

  closeSuggestedCustomerDropOffLocationDialog(): void {
    this.suggestedCustomerDropOffLocations = [];
  }

  checkIfVehicleHasPreviousDropOffLocation(): void {
    this.suggestedPickUpLocationFromVehiclePreviousDropOff = null;
    this.showSuggestedPickUpLocationDialog = false;

    if (
      !this.autoSuggestPickUpLocationEnabled ||
      (this.vehicleLifeCycleRefurbDetailsForNewOrder &&
        this.vehicleLifeCycleRefurbDetailsForNewOrder.currentSite > 0)
    ) {
      return;
    }

    let vehicleReg = this.registrationNumber.trim();

    if (!vehicleReg || vehicleReg.toUpperCase() == 'TBC') {
      return;
    }

    this.vehicleAddressService
      .getLastDropOffAddressForVehicleReg(vehicleReg)
      .then((prevDropOffAddress: IVehicleLastDropOffAddress) => {
        if (prevDropOffAddress.dropOffAddress) {
          this.suggestedPickUpLocationFromVehiclePreviousDropOff = prevDropOffAddress;
          this.showSuggestedPickUpLocationDialog = true;
        }
      });
  }

  closeSuggestedPickUpLocationDialog(proceed: boolean): void {
    this.showSuggestedPickUpLocationDialog = false;

    if (proceed) {
      if (this.suggestedPickUpLocationFromVehiclePreviousDropOff.site != null) {
        this.selectSite(this.suggestedPickUpLocationFromVehiclePreviousDropOff.site, true);
        this.suggestedPickUpLocationFromVehiclePreviousDropOff = null;
      } else {
        this.pickupLocation = this.suggestedPickUpLocationFromVehiclePreviousDropOff.dropOffAddress;
        this.disableAddressSearchPickupFields = false;
        this.siteOpeningHoursService.resetForm(this.pickupSiteHoursFormGroup);
        this.getSuggestedCustomerDropOffLocations();
        this.suggestedPickUpLocationFromVehiclePreviousDropOff = null;
      }
    }
  }

  navigateToJobScreen(): void {
    const url = `app/jobscreen/${this.suggestedPickUpLocationFromVehiclePreviousDropOff.jobId}/${this.suggestedPickUpLocationFromVehiclePreviousDropOff.orderId}`;
    window.open(url, '_blank');
  }

  duplicateTaskResponse(event) {
    this.showDuplicateTaskDialog = false;

    if (event == true) {
      this.CheckOrgStepReqModelPinOrActionNextStep();
    }
  }

  public fuelTypes: SelectItem[] = [];
  department: string;
  team: string;

  public vehicleLifeCycleCapacityIndicator(site: ICustomerSites): string {
    const capacityPercentage =
      (site.vehicleLifeCycleRefurbsOnSiteCount / site.vehicleLifeCycleMaxCapacity) * 100;

    if (capacityPercentage < 75) {
      return 'vlc-capacity-count-ok';
    } else if (capacityPercentage < 100) {
      return 'vlc-capacity-count-warn';
    } else {
      return 'vlc-capacity-over';
    }
  }

  onDepartmentChangeEvent(event) {
    this.task.dropoffNotification = false;
    this.task.furtherInformation.customerDepartmentId = event;
    this.getMappedChecklists(this._taskType);

    if (event) {
      this.organisationsService
        .getDepartment(event)
        .then((result) => {
          this.isJobTaggingEnforced = result.isJobTaggingEnforced;
          this.task.dropoffNotification = result.dropoffNotification;
        })
        .catch((err) => {
          console.log(`Error loading department details: ${err}`);
        });
    }
  }

  onTeamChangeEvent(event) {
    console.log('TCE', event);
    this.task.furtherInformation.customerTeamId = event;
  }

  onPickupAddressManualEntry(): void {
    this.isPickupPostcodeValidUKPostcodeFormat = isValidUKPostcodeFormat(
      this.addressSearchPickupLocation.postcode,
    );
    this.addressSearchPickupLocation.manualEntry = true;
    this.displayAddressSearchPickupLocationManualSave = true;
  }

  savePickupAddressManualEntry(): void {
    if (
      this.isAddressParamNullOrEmpty(this.addressSearchPickupLocation.addressLine1) ||
      this.isAddressParamNullOrEmpty(this.addressSearchPickupLocation.city) ||
      this.isAddressParamNullOrEmpty(this.addressSearchPickupLocation.postcode)
    ) {
      this.messageService.add(
        Message.Warning('Please make sure you have filled out all the required fields'),
      );
      return;
    }

    this.csService
      .getSiteByPostcode(this.addressSearchPickupLocation.postcode)
      .then((matchedSite) => {
        if (matchedSite) {
          this.pickupAddressMatchedSite = matchedSite;
          return;
        }
      });

    let address = this.addressAutoCompletionService.formatVehicleAddress(
      this.addressSearchPickupLocation,
    );

    this.addressAutoCompletionService.validateAddress(address).subscribe((validationResponse) => {
      if (validationResponse == null || validationResponse.status != 200) {
        this.messageService.add(
          Message.Warning("The address details you've entered are not valid"),
        );
        return;
      } else {
        this.messageService.add(Message.Success('Collection Address Updated'));
        this.pickupLocation = { ...this.addressSearchPickupLocation };
        this.pickupLocation.primaryAddress = address;
        this.pickupLocation.latitude = validationResponse.address.latitude;
        this.pickupLocation.longitude = validationResponse.address.longitude;
        this.getSuggestedCustomerDropOffLocations();
      }
    });
  }

  onDropoffAddressManualEntry(): void {
    this.isDropoffPostcodeValidUKPostcodeFormat = isValidUKPostcodeFormat(
      this.addressSearchDropoffLocation.postcode,
    );
    this.addressSearchDropoffLocation.manualEntry = true;
    this.displayAddressSearchDropoffLocationManualSave = true;
  }

  saveDropoffAddressManualEntry(): void {
    if (
      this.isAddressParamNullOrEmpty(this.addressSearchDropoffLocation.addressLine1) ||
      this.isAddressParamNullOrEmpty(this.addressSearchDropoffLocation.city) ||
      this.isAddressParamNullOrEmpty(this.addressSearchDropoffLocation.postcode)
    ) {
      this.messageService.add(
        Message.Warning('Please make sure you have filled out all the required fields'),
      );
      return;
    }

    this.csService
      .getSiteByPostcode(this.addressSearchDropoffLocation.postcode)
      .then((matchedSite) => {
        if (matchedSite) {
          this.dropoffAddressMatchedSite = matchedSite;
          return;
        }
      });

    let address = this.addressAutoCompletionService.formatVehicleAddress(
      this.addressSearchDropoffLocation,
    );

    this.addressAutoCompletionService.validateAddress(address).subscribe((validationResponse) => {
      if (validationResponse == null || validationResponse.status != 200) {
        this.messageService.add(
          Message.Warning("The address details you've entered are not valid"),
        );
        return;
      } else {
        this.messageService.add(Message.Success('Delivery Address Updated'));
        this.addressSearchDropoffLocation.primaryAddress = address;
        this.addressSearchDropoffLocation.latitude = validationResponse.address.latitude;
        this.addressSearchDropoffLocation.longitude = validationResponse.address.longitude;
        this.dropoffLocation = this.addressSearchDropoffLocation;
      }
    });
  }

  isAddressParamNullOrEmpty(value: string | null | undefined): boolean {
    return value == null || value.trim().length === 0;
  }

  isCurrentTaskInspectAndCollect(): boolean {
    return [TaskType.DrivenPlatedInspection, TaskType.DrivenInsuredInspection].includes(
      this.task.taskTypeId,
    );
  }

  openSavedSiteEditDialog(isPickup: boolean): void {
    this.siteEditorContactInfo = this.buildCustomerSiteContact(isPickup);

    if (isPickup) {
      this.addressSearchPickupSiteEditor = true;
    } else {
      this.addressSearchDropoffSiteEditor = true;
    }
  }

  closeMatchedSitePickupLocationDialog(proceed: boolean): void {
    if (proceed) {
      this.selectSite(this.pickupAddressMatchedSite, true);
    }

    this.pickupAddressMatchedSite = null;
  }

  closeMatchedSiteDropoffLocationDialog(proceed: boolean): void {
    if (proceed) {
      this.selectSite(this.dropoffAddressMatchedSite, false);
    }

    this.dropoffAddressMatchedSite = null;
  }

  onVehicleWeightChanged(weight: number) {
    // store the weight against the current vehicle
    this.vehicle.kerbWeight = weight; // weight in kg
  }

  isInspectionContactValid(): boolean {
    if (!this.isCurrentTaskInspectAndCollect()) {
      return true;
    }

    const hasValidEmail = Boolean(
      this.inspectionContactEmail && this.inspectionContactEmail.trim().length > 0,
    );
    const hasValidName = Boolean(
      this.inspectionContactFullName && this.inspectionContactFullName.trim().length > 0,
    );

    return hasValidEmail && hasValidName;
  }

  taskSequenceUpdated(tasks: ITaskInfo[]): void {
    this.selectedNewJob.tasks = tasks;
  }

  updateTaskSequencingFlagForTasksInJob(): void {
    this.newJobs.forEach((job) => {
      const tasks = job.tasks;
      if (tasks?.length > 1) {
        tasks.forEach((task, index) => {
          task.taskSequence = index + 1;
        });
      } else if (tasks?.length === 1) {
        tasks[0].taskSequence = null;
      }
    });
  }

  setRouteTime() {
    if (
      this.pickupLocation &&
      this.dropoffLocation &&
      typeof this.pickupLocation.latitude == 'number' &&
      typeof this.pickupLocation.longitude == 'number' &&
      typeof this.dropoffLocation.latitude == 'number' &&
      typeof this.dropoffLocation.longitude == 'number'
    ) {
      const dto = this.mapService.GetRouteDTO(
        this.pickupLocation,
        this.dropoffLocation,
        this.pickupEarliestDateTime,
      );

      this.mapService.GetRoute(dto).then((route) => {
        if (route != null) {
          this.routeTime = route.duration;
        }
      });
    }
  }

  private autoSelectClosestSiteWithCapacity(): void {
    if (
      !this.suggestedCustomerDropOffLocations ||
      this.suggestedCustomerDropOffLocations.length === 0
    ) {
      return;
    }

    const closestSiteIndex = this.getClosestSiteWithCapacityIndex();

    if (closestSiteIndex === -1) {
      return;
    }

    const closestSite = this.suggestedCustomerDropOffLocations[closestSiteIndex];

    this.selectSuggestedCustomerDropOffLocation(closestSite, closestSiteIndex, true);
  }

  private getClosestSiteWithCapacityIndex(): number {
    if (
      !this.suggestedCustomerDropOffLocations ||
      this.suggestedCustomerDropOffLocations.length === 0
    ) {
      return -1;
    }

    const sitesWithCapacity = this.suggestedCustomerDropOffLocations
      .map((site, index) => ({ site, index }))
      .filter(
        ({ site }) =>
          site.siteDetails &&
          site.siteDetails.vehicleLifeCycleRefurbsOnSiteCount <
            site.siteDetails.vehicleLifeCycleMaxCapacity,
      );

    if (sitesWithCapacity.length === 0) {
      return -1;
    }

    const closest = sitesWithCapacity.sort(
      (a, b) => a.site.distanceMeters - b.site.distanceMeters,
    )[0];

    return closest.index;
  }

  protected hasCustomerBookingRole: boolean = false;
  protected orderPriceDialogHeader: string = 'Order Price';
  protected hasCustomerPriceRole: boolean = false;
  private async initRoles() {
    this.hasCustomerBookingRole = await this.userService.isUserInRole('CUSTOMER_BOOKING');
    if (this.hasCustomerBookingRole) {
      this.orderPriceDialogHeader = 'Order';
    }

    this.hasCustomerPriceRole = await this.userService.isUserInRole('CUSTOMER_PRICE');
  }

  private buildCustomerSiteContact(isPickup: boolean): ICustomerSitesContact {
    const formValues = this.locationsform.value;

    return isPickup
      ? {
          forename: formValues.pickupForename,
          surname: formValues.pickupSurname,
          email: formValues.pickupEmail,
          phone1: formValues.pickupPhone1,
          phone2: formValues.pickupPhone2,
          notification: formValues.pickupNotification,
          notes: formValues.pickupNotes,
        }
      : {
          forename: formValues.dropoffForename,
          surname: formValues.dropoffSurname,
          email: formValues.dropoffEmail,
          phone1: formValues.dropoffPhone1,
          phone2: formValues.dropoffPhone2,
          notification: formValues.dropoffNotification,
          notes: formValues.dropoffNotes,
        };
  }
}

interface AutoCompleteCompleteEvent {
  originalEvent: Event;
  query: string;
}

export enum MotWarningType {
  DrivenPlated = 1,
  CustomerInsured = 2,
  DriverInsured = 3,
  PickupDropoffDates = 4,
  DrivenPrestige = 5,
  TransportedUncovered = 6,
  TransportedCovered = 7,
  VehicleOrMotChange = 8,
  EngineiusGo = 9,
  Turnaround = 10,
  RecoveryStandard = 11,
  Inspection = 14,
  DrivenInsuredInspection = 15,
  DrivenPlatedInspection = 16,
  PrestigeTransported = 17,
}
